// Initialize Charts object if it doesn't exist
if (!window.Charts) {
  window.Charts = {};
}

window.Charts.roleData = window.Charts.roleData || null;
window.Charts.schoolData = window.Charts.schoolData || null;
window.Charts.gradeData = window.Charts.gradeData || null;
window.Charts.sentimentByRoleData = window.Charts.sentimentByRoleData || null;
window.Charts.openSentimentByRoleChartModal =
  window.Charts.openSentimentByRoleChartModal || null;
window.Charts.sentimentBySchoolData =
  window.Charts.sentimentBySchoolData || null;
window.Charts.methodData = window.Charts.methodData || null;
window.Charts.sentimentData = window.Charts.sentimentData || null;
window.Charts.languageData = window.Charts.languageData || null;
window.Charts.submissionsData = window.Charts.submissionsData || null;
window.Charts.dailySubmissionData = window.Charts.dailySubmissionData || null;
window.Charts.weeklySubmissionData = window.Charts.weeklySubmissionData || null;
window.Charts.wordCloudData = window.Charts.wordCloudData || null;
window.Charts.responseLengthData = window.Charts.responseLengthData || null;
window.Charts.totalSubmissionsData = window.Charts.totalSubmissionsData || null;
window.Charts.openTotalSubmissionsChartModal =
  window.Charts.openTotalSubmissionsChartModal || null;

window.loadHtmlToImage = function (callback) {
  if (typeof htmlToImage !== "undefined") {
    if (callback) callback();
    return;
  }

  const script = document.createElement("script");
  script.src =
    "https://cdnjs.cloudflare.com/ajax/libs/html-to-image/1.11.13/html-to-image.js";
  script.onload = function () {
    //console.log('html-to-image library loaded successfully');
    if (callback) callback();
  };
  script.onerror = function () {
    console.error("Failed to load html-to-image library");
  };
  document.head.appendChild(script);
};

document.addEventListener("DOMContentLoaded", function () {
  window.loadHtmlToImage();
});

window.isMobileDevice = function () {
  // Check if the screen width is less than 768px (common tablet/mobile breakpoint)
  const isMobileWidth = window.innerWidth < 768;

  const isMobileAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return isMobileWidth || isMobileAgent;
};

// mobile warning
document.addEventListener("DOMContentLoaded", function () {
  // Only create the modal if it doesn't already exist
  if (!document.getElementById("mobileWarningModal")) {
    const mobileModal = document.createElement("div");
    mobileModal.id = "mobileWarningModal";
    mobileModal.style.cssText = `
            display: none;
            position: fixed;
            z-index: 9999;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            overflow: auto;
            background-color: rgba(0,0,0,0.4);
        `;

    const modalContent = document.createElement("div");
    modalContent.style.cssText = `
            background-color: #fefefe;
            margin: 15% auto;
            padding: 20px;
            border: 1px solid #888;
            width: 80%;
            max-width: 500px;
            border-radius: 8px;
            text-align: center;
        `;
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    modalContent.innerHTML = `
            <h3 style="margin-top: 0; color: #444;">Mobile Detected</h3>
            <p>Dig deeper into your data by opening your Student Story dashboard on a larger screen</p>
            <p>Our desktop view has interactive charts that allow you to explore all aspects of your data on a granular level.</p>
            <button id="closeMobileWarningBtn" style="
                padding: 8px 16px;
                background-color: #4CAF50;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                margin-top: 10px;
            ">Got it</button>
        `;

    mobileModal.appendChild(modalContent);
    document.body.appendChild(mobileModal);

    document
      .getElementById("closeMobileWarningBtn")
      .addEventListener("click", function () {
        document.getElementById("mobileWarningModal").style.display = "none";
      });

    mobileModal.addEventListener("click", function (event) {
      if (event.target === mobileModal) {
        mobileModal.style.display = "none";
      }
    });
  }

  setTimeout(function () {
    const wordCloudContainer = document.querySelector(".word-cloud-container");
    const wordCloudHeader = document.querySelector(".word-cloud-header");

    if (wordCloudContainer && wordCloudHeader) {
      // Create download button
      const downloadButton = document.createElement("button");
      downloadButton.className = "word-cloud-download-btn";
      downloadButton.innerHTML =
        '<i class="fa-duotone fa-solid fa-camera-retro fa-fade" style="--fa-primary-color: #285f81; --fa-secondary-color: #285f81; margin-top:0px; font-size: 2.2rem !important;"></i>';
      downloadButton.setAttribute("title", "Save Word Cloud as Image");
      downloadButton.style.cssText = `
                position: absolute;
                top: 10px;
                right: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 10;
                transition: scale (1) 0.2s ease-in-out;
            `;

      const styleElement = document.createElement("style");
      styleElement.textContent = `
                .word-cloud-download-btn:hover {
                    transition: scale (1.1) 0.2s ease-in-out;
                }
                
                .word-cloud-container {
                    position: relative;
                }
            `;
      document.head.appendChild(styleElement);

      downloadButton.addEventListener("click", function (e) {
        e.stopPropagation(); // Prevent click from triggering modal
        window.downloadMainWordCloud();
      });

      wordCloudContainer.appendChild(downloadButton);
    }
  }, 1000);
});

// Function to show mobile warning xxxXXXXXXXXXXXXXXXXXXXXXXXX
function showMobileWarning() {
  const modal = document.getElementById("mobileWarningModal");
  if (modal) {
    modal.style.display = "block";
  }
}

if (!window.Charts.getRoleData) {
  window.Charts.getRoleData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.roleData) {
      return window.Charts.roleData;
    }

    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const roleCounts = {};
      window.sheetData.forEach((item) => {
        if (item && item.role) {
          roleCounts[item.role] = (roleCounts[item.role] || 0) + 1;
        }
      });

      Object.entries(roleCounts).forEach(([role, count]) => {
        data.push([role, count]);
      });
    }
    return data;
  };
}

if (!window.Charts.getSchoolData) {
  window.Charts.getSchoolData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.schoolData) {
      return window.Charts.schoolData;
    }

    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const schoolCounts = {};

      window.sheetData.forEach((item) => {
        // Skip null or undefined items
        if (!item) return;

        let schoolValue = null;
        if (item.school) {
          schoolValue = item.school;
        } else if (item.School) {
          schoolValue = item.School;
        } else if (item.school_name) {
          schoolValue = item.school_name;
        } else if (item.schoolName) {
          schoolValue = item.schoolName;
        }

        if (schoolValue) {
          const normalizedSchool = String(schoolValue).trim();
          if (normalizedSchool) {
            schoolCounts[normalizedSchool] =
              (schoolCounts[normalizedSchool] || 0) + 1;
          }
        }
      });

      Object.entries(schoolCounts).forEach(([school, count]) => {
        data.push([school, count]);
      });
    }
    return data;
  };
}

if (!window.Charts.getGradeData) {
  window.Charts.getGradeData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.gradeData) {
      return window.Charts.gradeData;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const gradeCounts = {};

      // Process the data to count grade occurrences
      window.sheetData.forEach((item) => {
        if (!item) return;

        // Try different field names for grade
        let gradeValue = null;
        if (item.grade) {
          gradeValue = item.grade;
        } else if (item.Grade) {
          gradeValue = item.Grade;
        } else if (item.grade_level) {
          gradeValue = item.grade_level;
        } else if (item.gradeLevel) {
          gradeValue = item.gradeLevel;
        }

        // Handle comma-separated grades
        if (gradeValue) {
          if (gradeValue.includes(",")) {
            // Split and count each grade separately
            const grades = gradeValue.split(",").map((g) => g.trim());
            grades.forEach((grade) => {
              if (grade) {
                gradeCounts[grade] = (gradeCounts[grade] || 0) + 1;
              }
            });
          } else {
            const normalizedGrade = String(gradeValue).trim();
            if (normalizedGrade) {
              gradeCounts[normalizedGrade] =
                (gradeCounts[normalizedGrade] || 0) + 1;
            }
          }
        }
      });

      // Convert counts to array format, sorted appropriately
      Object.entries(gradeCounts)
        .sort((a, b) => {
          // First try to compare as numbers (if grades are like "1", "2", etc.)
          const numA = parseInt(a[0]);
          const numB = parseInt(b[0]);
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          }
          // Otherwise sort alphabetically
          return a[0].localeCompare(b[0]);
        })
        .forEach(([grade, count]) => {
          data.push([grade, count]);
        });
    }
    return data;
  };
}

// Define sentiment by role data retrieval method if it doesn't exist
if (!window.Charts.getSentimentByRoleData) {
  window.Charts.getSentimentByRoleData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.sentimentByRoleData) {
      return window.Charts.sentimentByRoleData;
    }

    // Otherwise generate data from sheetData
    const data = {
      roleLabels: [],
      positive: [],
      neutral: [],
      negative: [],
      unknown: [],
    };

    if (window.sheetData && window.sheetData.length > 0) {
      // Group data by role
      const roleGroups = {};

      window.sheetData.forEach((item) => {
        if (!item || !item.role) return;

        const role = item.role.trim();
        const sentiment = parseFloat(item.sentiment || 5.5);

        if (!roleGroups[role]) {
          roleGroups[role] = {
            total: 0,
            positive: 0,
            neutral: 0,
            negative: 0,
            unknown: 0,
          };
        }

        roleGroups[role].total++;
        // Categorize sentiment
        if (sentiment === 5.5 || sentiment === 0 || !sentiment || 
            typeof sentiment === 'string' || isNaN(sentiment)) {
          roleGroups[role].unknown++;
        } else if (sentiment >= 6.6) {
          roleGroups[role].positive++;
        } else if (sentiment >= 3.3 && sentiment < 6.6 && sentiment !== 5.5 && sentiment !== 0) {
          roleGroups[role].neutral++;
        } else if (sentiment < 3.3 && sentiment !== 5.5 && sentiment !== 0) {
          roleGroups[role].negative++;
        } else {
          roleGroups[role].unknown++;
        }
      });

      // Convert to arrays for the chart
      Object.entries(roleGroups).forEach(([role, counts]) => {
        data.roleLabels.push(role);
        data.positive.push(counts.positive);
        data.neutral.push(counts.neutral);
        data.negative.push(counts.negative);
        data.unknown.push(counts.unknown);
      });
    }

    return data;
  };
}

if (!window.Charts.getSentimentBySchoolData) {
  window.Charts.getSentimentBySchoolData = function () {
    if (window.Charts.sentimentBySchoolData) {
      return window.Charts.sentimentBySchoolData;
    }

    const data = {
      schoolLabels: [],
      positive: [],
      neutral: [],
      negative: [],
      unknown: [],
    };

    if (window.sheetData && window.sheetData.length > 0) {
      const schoolGroups = {};

      window.sheetData.forEach((item) => {
        if (!item) return;

        let schoolValue = null;
        if (item.school) {
          schoolValue = item.school;
        } else if (item.School) {
          schoolValue = item.School;
        } else if (item.school_name) {
          schoolValue = item.school_name;
        } else if (item.schoolName) {
          schoolValue = item.schoolName;
        }

        if (!schoolValue) return;

        const school = String(schoolValue).trim();
        const sentiment = parseFloat(item.sentiment || 5.5);

        if (!schoolGroups[school]) {
          schoolGroups[school] = {
            total: 0,
            positive: 0,
            neutral: 0,
            negative: 0,
            unknown: 0,
          };
        }

        schoolGroups[school].total++;

        if (sentiment === 5.5 || sentiment === 0 || !sentiment || isNaN(sentiment)) {
          schoolGroups[school].unknown++;
        } else if (sentiment >= 6.6) {
          schoolGroups[school].positive++;
        } else if (sentiment >= 3.3 && sentiment < 6.6 && sentiment !== 5.5 && sentiment !== 0) {
          schoolGroups[school].neutral++;
        } else if (sentiment < 3.3 && sentiment !== 5.5 && sentiment !== 0) {
          schoolGroups[school].negative++;
        } else {
          schoolGroups[school].unknown++;
        }
      });

      Object.entries(schoolGroups).forEach(([school, counts]) => {
        data.schoolLabels.push(school);
        data.positive.push(counts.positive);
        data.neutral.push(counts.neutral);
        data.negative.push(counts.negative);
        data.unknown.push(counts.unknown);
      });
    }
    return data;
  };
}

if (!window.Charts.getMethodData) {
  window.Charts.getMethodData = function () {
    if (window.Charts.methodData) {
      return window.Charts.methodData;
    }

    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const methodCounts = {};

      window.sheetData.forEach((item) => {
        if (!item) return;

        let methodValue = null;
        if (item.method) {
          methodValue = item.method;
        } else if (item.Method) {
          methodValue = item.Method;
        } else if (item.response_method) {
          methodValue = item.response_method;
        } else if (item.responseMethod) {
          methodValue = item.responseMethod;
        }

        if (!methodValue) return;

        const method = String(methodValue).trim();
        const normalizedMethod =
          method.charAt(0).toUpperCase() + method.slice(1).toLowerCase();

        methodCounts[normalizedMethod] =
          (methodCounts[normalizedMethod] || 0) + 1;
      });

      Object.entries(methodCounts).forEach(([method, count]) => {
        data.push([method, count]);
      });
    }
    return data;
  };
}

window.addEventListener("click", function (event) {
  const modal = document.getElementById("rolesChartModal");
  if (modal && event.target == modal) {
    closeRolesChartModal();
  }

  const schoolModal = document.getElementById("schoolChartModal");
  if (schoolModal && event.target == schoolModal) {
    closeSchoolChartModal();
  }

  const gradeLevelModal = document.getElementById("gradeLevelChartModal");
  if (gradeLevelModal && event.target == gradeLevelModal) {
    closeGradeLevelChartModal();
  }

  const sentimentByRoleModal = document.getElementById(
    "sentimentByRoleChartModal"
  );
  if (sentimentByRoleModal && event.target == sentimentByRoleModal) {
    closeSentimentByRoleChartModal();
  }

  const sentimentBySchoolModal = document.getElementById(
    "sentimentBySchoolChartModal"
  );
  if (sentimentBySchoolModal && event.target == sentimentBySchoolModal) {
    closeSentimentBySchoolChartModal();
  }

  const methodModal = document.getElementById("methodChartModal");
  if (methodModal && event.target == methodModal) {
    closeMethodChartModal();
  }

  const sentimentModal = document.getElementById("sentimentChartModal");
  if (sentimentModal && event.target == sentimentModal) {
    closeSentimentChartModal();
  }

  const languageModal = document.getElementById("languageChartModal");
  if (languageModal && event.target == languageModal) {
    closeLanguageChartModal();
  }

  const dailySubmissionsModal = document.getElementById(
    "dailySubmissionsChartModal"
  );
  if (dailySubmissionsModal && event.target == dailySubmissionsModal) {
    closeDailySubmissionsChartModal();
  }

  const weeklySubmissionsModal = document.getElementById(
    "weeklySubmissionsChartModal"
  );
  if (weeklySubmissionsModal && event.target == weeklySubmissionsModal) {
    closeWeeklySubmissionsChartModal();
  }

  const wordCloudModal = document.getElementById("wordCloudChartModal");
  if (wordCloudModal && event.target == wordCloudModal) {
    closeWordCloudChartModal();
  }

  const responseLengthModal = document.getElementById(
    "responseLengthChartModal"
  );
  if (responseLengthModal && event.target == responseLengthModal) {
    closeResponseLengthChartModal();
  }

  const languageDistributionModal = document.getElementById(
    "languageDistributionChartModal"
  );
  if (languageDistributionModal && event.target == languageDistributionModal) {
    closeLanguageDistributionChartModal();
  }

  const totalSubmissionsModal = document.getElementById(
    "totalSubmissionsChartModal"
  );
  if (totalSubmissionsModal && event.target == totalSubmissionsModal) {
    closeTotalSubmissionsChartModal();
  }
});

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

function openRolesChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("rolesChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get role data from the existing chart if possible
    let roleData = [];
    if (window.Charts && window.Charts.getRoleData) {
      roleData = window.Charts.getRoleData();
    }

    const modalContent = document.getElementById("rolesChartModalContent");
    if (modalContent) {
      // --- MODIFIED: Match consistent modal structure/styles ---
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2>Distribution Analysis</h2>


                        <p>Submission data organized by role.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadRolesChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeRolesChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="rolesChartDetailed" style="width: 100%; height: 400px;"></div>

                <div class="roles-stats"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3>Role Distribution</h3>
                            <p>Breakdown of submission data organized by role.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadRolesTable" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadRolesTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                                <span class="rolesChartModal-close" onclick="closeRolesChartModal()">&times;</span> 
                            </div>
                        </div>
                    </div>
                    <div id="roleBreakdown"></div>
                </div>
            `;
      // --- END MODIFIED ---

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Role");
          data.addColumn("number", "Count");

          // If we have role data from the chart object
          if (roleData.length > 0) {
            data.addRows(roleData);
          }
          // Otherwise use data from sheetData if available
          else if (window.sheetData && window.sheetData.length > 0) {
            // Debug: Log the first few items to see their structure

            // Count unique users per role
            const roleCounts = {};
            const usersByRole = {};

            // Helper function to get a reliable identifier for each user
            function getUserId(item) {
              return item.user_id;
            }

            window.sheetData.forEach((item) => {
              if (item && item.role) {
                const role = item.role;
                const userId = getUserId(item);

                if (!usersByRole[role]) {
                  usersByRole[role] = new Set();
                }
                usersByRole[role].add(userId);
              }
            });

            Object.entries(usersByRole).forEach(([role, userSet]) => {
              roleCounts[role] = userSet.size;
            });

            Object.entries(roleCounts).forEach(([role, count]) => {
              data.addRow([role, count]);
            });
          }

          const options = {
            title: "",
            is3D: true,
            colors: [
              "#1f4f71",
              "#ffb703",
              "#99582a",
              "#219ebc",
              "#185040",
              "#c3c3c3",
              "#850101",
            ],
            chartArea: { width: "90%", height: "80%" },
            legend: { position: "bottom" },
            pieSliceText: "percentage",
          };

          const chart = new google.visualization.PieChart(
            document.getElementById("rolesChartDetailed")
          );

          google.visualization.events.addListener(chart, "select", function () {
            const selection = chart.getSelection();
            if (selection.length > 0) {
              const selectedItem = selection[0];
              if (selectedItem) {
                const selectedRole = data.getValue(selectedItem.row, 0);

                closeRolesChartModal();

                applyRoleFilter(selectedRole);
              }
            }
          });

          let uniqueUserData = new google.visualization.DataTable();
          uniqueUserData.addColumn("string", "Role");
          uniqueUserData.addColumn("number", "Total");

          if (window.sheetData && window.sheetData.length > 0) {
            const roleUsers = new Map();
            const processedUsers = new Set();

            window.sheetData.forEach((item) => {
              if (item && item.role) {
                if (!roleUsers.has(item.role)) {
                  roleUsers.set(item.role, new Set());
                }
              }
            });

            window.sheetData.forEach((item) => {
              if (!item || !item.role) return;

              const userKey =
                item.userId ||
                item.user_id ||
                item.email ||
                item.name + "-" + (item.timestamp || Date.now());

              if (processedUsers.has(userKey)) return;

              roleUsers.get(item.role).add(userKey);
              processedUsers.add(userKey);
            });

            roleUsers.forEach((users, role) => {
              // Capitalize first letter of role
              const capitalizedRole =
                role.charAt(0).toUpperCase() + role.slice(1);
              uniqueUserData.addRow([capitalizedRole, users.size]);
            });
          }

          chart.draw(uniqueUserData, options);

          uniqueUserData.sort([{ column: 0, desc: false }]);
          chart.draw(uniqueUserData, options);

          const roleBreakdown = document.getElementById("roleBreakdown");
          if (roleBreakdown) {
            let breakdownHTML =
              '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">';
            breakdownHTML +=
              '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">';
            breakdownHTML +=
              '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">';
            breakdownHTML +=
              '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Role</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total</th>'; // Changed header text
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Percentage</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Action</th>';
            breakdownHTML += "</tr></thead>";

            breakdownHTML += "<tbody>";
            let total = 0;
            for (let i = 0; i < uniqueUserData.getNumberOfRows(); i++) {
              total += uniqueUserData.getValue(i, 1);
            }

            for (let i = 0; i < uniqueUserData.getNumberOfRows(); i++) {
              const role = uniqueUserData.getValue(i, 0);
              const count = uniqueUserData.getValue(i, 1);
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0"; // Avoid division by zero

              breakdownHTML += `<tr style="background-color: ${
                i % 2 === 0 ? "#fff" : "#f9f9f9"
              };">
                                 <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${role}</td>
                                 <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>
                                 <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>
                                 <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                                     <button onclick="applyRoleFilter('${role}')" class="filter-by-role-btn"
                                         style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                                         View Responses
                                     </button>
                                 </td>
                             </tr>`;
            }
            breakdownHTML += "</tbody>";

            // Footer Row
            breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
            breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${total.toLocaleString()}</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${
              total > 0 ? "100.0%" : "N/A"
            }</td>`;
            breakdownHTML += `<td style="padding: 8px 8px; border-top: 2px solid #ccc;"></td>`; // Empty cell for Action column
            breakdownHTML += `</tr></tfoot>`;

            breakdownHTML += "</table></div>";
            roleBreakdown.innerHTML = breakdownHTML;
          }

          // Add download button handlers
          document
            .getElementById("downloadRolesChart")
            .addEventListener("click", function () {
              const chartImageURI = chart.getImageURI();

              const downloadLink = document.createElement("a");
              downloadLink.href = chartImageURI;
              downloadLink.download = "roles-distribution-chart.png";

              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadRolesTable")
            .addEventListener("click", function () {
              const table = document.querySelector("#roleBreakdown table");
              if (!table) return;

              let csv = [];
              csv.push(['"Role Distribution"']);
              csv.push(['"Breakdown of submission data organized by role."']);
              csv.push([]);

              const rows = table.querySelectorAll("tr");
              rows.forEach((row) => {
                const cells = row.querySelectorAll("td, th");
                const rowData = Array.from(cells)
                  .slice(0, -1)
                  .map((cell) => {
                    return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
                  });
                csv.push(rowData.join(","));
              });

              const csvContent = csv.join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "roles-distribution-table.csv";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadRolesTablePNG")
            .addEventListener("click", function () {
              const table = document.querySelector("#roleBreakdown table");
              if (!table) return;
              if (typeof html2canvas !== "function") {
                alert("html2canvas library not loaded.");
                return;
              }

              const container = document.createElement("div");
              container.style.position = "absolute";
              container.style.left = "-9999px";
              container.style.background = "white";
              container.style.padding = "20px";
              container.style.border = "1px solid #ccc";
              container.style.fontFamily = "Arial, sans-serif";

              const titleElement = modalContent.querySelector(
                ".modal-title-and-x-2 h3"
              );
              if (titleElement) {
                const titleClone = titleElement.cloneNode(true);
                titleClone.style.marginBottom = "5px";
                titleClone.style.fontSize = "18px";
                container.appendChild(titleClone);
              }

              const descElement = modalContent.querySelector(
                ".modal-title-and-x-2 p"
              );
              if (descElement) {
                const descClone = descElement.cloneNode(true);
                descClone.style.marginBottom = "20px";
                descClone.style.fontSize = "14px";
                container.appendChild(descClone);
              }

              const tableClone = table.cloneNode(true);

              tableClone.querySelectorAll("tr").forEach((row) => {
                const cells = row.cells;
                if (cells.length > 0) {
                  cells[cells.length - 1].remove();
                }
              });

              container.appendChild(tableClone);
              document.body.appendChild(container);

              html2canvas(container, { scale: 2, useCORS: true })
                .then(function (canvas) {
                  document.body.removeChild(container);

                  const link = document.createElement("a");
                  link.download = "roles-distribution-table.png";
                  link.href = canvas.toDataURL("image/png");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                })
                .catch((err) => {
                  console.error("Error generating canvas:", err);
                  alert("Failed to generate table image.");
                  if (document.body.contains(container)) {
                    document.body.removeChild(container);
                  }
                });
            });
        }
      } catch (e) {
        console.error("Error rendering roles chart in modal:", e);
        document.getElementById("rolesChartDetailed").innerHTML =
          "<p>Unable to display detailed chart.</p>";
      }
    }
  }
}

function applyRoleFilter(role) {
  // CLOSE response length modal
  // XXX ??????????? closeResponseLengthChartModal();

  closeRolesChartModal();

  applyFilterWithoutModal("role", role);
}

function closeRolesChartModal() {
  const modal = document.getElementById("rolesChartModal");
  if (modal) {
    modal.classList.add("closing");

    setTimeout(() => {
      modal.style.display = "none";
      modal.classList.remove("closing");
    }, 3600);
  }
}

function openSchoolChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("schoolChartModal");
  if (modal) {
    modal.style.display = "block";

    let schoolData = [];
    if (window.Charts && window.Charts.getSchoolData) {
      schoolData = window.Charts.getSchoolData();
      console.log("School data retrieved:", schoolData);
    }

    const modalContent = document.getElementById("schoolChartModalContent");
    if (modalContent) {
      modalContent.innerHTML = `
                 <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2>School Distribution Analysis</h2>
                        <p>Submission data organized by school.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadSchoolChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeSchoolChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="schoolChartDetailed" style="width: 100%; height: 400px;"></div>

                <div class="roles-stats"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3>School Distribution</h3>
                            <p>Breakdown of submission data organized by school.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSchoolTable" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSchoolTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                                <span class="rolesChartModal-close" onclick="closeSchoolChartModal()">&times;</span> 
                            </div>
                        </div>
                    </div>
                    <div id="schoolBreakdown"></div>
                </div>
            `;
      // --- END MODIFIED ---

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for school chart");

        document.getElementById("schoolChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please replas the page.</p>
                    </div>
                `;
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "School");
          data.addColumn("number", "Count");

          if (schoolData && schoolData.length > 0) {
            data.addRows(schoolData);
          } else if (window.sheetData && window.sheetData.length > 0) {
            console.log("Generating school data from sheet data");
          }

          const options = {
            title: "",
            is3D: true,
            colors: [
              "#219ebc",
              "#ffb703",
              "#850101",
              "#c3c3c3",
              "#1f4f71",
              "#99582a",
              "#185040",
            ],
            chartArea: { width: "90%", height: "80%" },
            legend: { position: "bottom" },
            pieSliceText: "percentage",
          };

          const chart = new google.visualization.PieChart(
            document.getElementById("schoolChartDetailed")
          );

          google.visualization.events.addListener(chart, "select", function () {
            const selection = chart.getSelection();
            if (selection.length > 0) {
              const selectedItem = selection[0];
              if (selectedItem) {
                const selectedSchool = uniqueUserData.getValue(
                  selectedItem.row,
                  0
                );
                // Don't apply filter for placeholder data
                if (
                  selectedSchool === "No Data Available" ||
                  selectedSchool === "No School Data Found"
                ) {
                  return;
                }

                closeSchoolChartModal();

                // Apply the school filter
                applySchoolFilter(selectedSchool);
              }
            }
          });

          // Create unique users data table - exactly like in openRolesChartModal
          let uniqueUserData = new google.visualization.DataTable();
          uniqueUserData.addColumn("string", "School");
          uniqueUserData.addColumn("number", "Unique Users");

          if (window.sheetData && window.sheetData.length > 0) {
            // Use Map to track unique users by school
            const schoolUsers = new Map();
            const processedUsers = new Set();

            // First pass - identify all schools
            window.sheetData.forEach((item) => {
              if (!item) return;

              // Try different field names for school
              let schoolValue = null;
              if (item.school) {
                schoolValue = item.school;
              } else if (item.School) {
                schoolValue = item.School;
              } else if (item.school_name) {
                schoolValue = item.school_name;
              } else if (item.schoolName) {
                schoolValue = item.schoolName;
              }

              if (schoolValue) {
                const normalizedSchool = String(schoolValue).trim();
                if (normalizedSchool && !schoolUsers.has(normalizedSchool)) {
                  schoolUsers.set(normalizedSchool, new Set());
                }
              }
            });

            console.log(`Found ${schoolUsers.size} unique schools`);

            // Second pass - process each user only once with their primary school
            // This prevents double-counting users with multiple schools
            window.sheetData.forEach((item) => {
              if (!item) return;

              // Skip if no school value
              let schoolValue = null;
              if (item.school) {
                schoolValue = item.school;
              } else if (item.School) {
                schoolValue = item.School;
              } else if (item.school_name) {
                schoolValue = item.school_name;
              } else if (item.schoolName) {
                schoolValue = item.schoolName;
              }

              if (!schoolValue) return;

              // Create a user identifier from available fields
              const userKey =
                item.userId ||
                item.user_id ||
                item.email ||
                item.name + "-" + (item.timestamp || Date.now());

              // Skip if we've already processed this user
              if (processedUsers.has(userKey)) return;

              // Add this user to their school and mark as processed
              const normalizedSchool = String(schoolValue).trim();
              if (normalizedSchool && schoolUsers.has(normalizedSchool)) {
                schoolUsers.get(normalizedSchool).add(userKey);
                processedUsers.add(userKey);
              }
            });

            // Convert to rows for the chart
            schoolUsers.forEach((users, school) => {
              // Skip School District (case insensitive)
              if (!school.toUpperCase().includes("SCHOOL DISTRICT")) {
                uniqueUserData.addRow([school, users.size]);
              }
            });

            // Log for debugging
            console.log(
              "Unique users by school (final, excluding District):",
              Array.from(schoolUsers.entries())
                .filter(
                  ([school, _]) =>
                    !school.toUpperCase().includes("SCHOOL DISTRICT")
                )
                .map(([school, users]) => `${school}: ${users.size}`)
            );

            // If no schools had any users, add a placeholder
            if (uniqueUserData.getNumberOfRows() === 0) {
              console.warn("No school data found with users");
              uniqueUserData.addRow(["No School Data Found", 1]);

              // Show a message about the missing data
              document.getElementById("schoolBreakdown").innerHTML = `
                                <div class="alert" style="background-color: #f8d7da; color: #721c24; padding: 10px; border-radius: 4px; margin-top: 15px;">
                                    <p><strong>No school data found.</strong> Your data may not include school information, or it might be using a different field name.</p>
                                    <p>Please check your data structure to ensure school information is available.</p>
                                </div>
                            `;
            }
          } else {
            // No data available, show a placeholder
            console.warn("No data source available for school chart");
            uniqueUserData.addRow(["No Data Available", 1]);
          }

          // Use the unique user data for the chart
          chart.draw(uniqueUserData, options);

          // Properly order the data
          uniqueUserData.sort([{ column: 0, desc: false }]);
          chart.draw(uniqueUserData, options);

          // Display the breakdown as text
          const schoolBreakdown = document.getElementById("schoolBreakdown");
          if (schoolBreakdown) {
            // --- MODIFIED: Apply consistent table styling ---
            let breakdownHTML =
              '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Container div
            breakdownHTML +=
              '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Basic table style

            // Header Row
            breakdownHTML +=
              '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Sticky header
            breakdownHTML +=
              '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">School</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total</th>'; // Changed header
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Percentage</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Action</th>';
            breakdownHTML += "</tr></thead>";

            // Table Body
            breakdownHTML += "<tbody>";
            let total = 0;
            for (let i = 0; i < uniqueUserData.getNumberOfRows(); i++) {
              total += uniqueUserData.getValue(i, 1);
            }

            for (let i = 0; i < uniqueUserData.getNumberOfRows(); i++) {
              const school = uniqueUserData.getValue(i, 0);
              const count = uniqueUserData.getValue(i, 1);
              // Avoid division by zero for percentage
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";

              // Don't show filter button for placeholder data
              const actionCell =
                school === "No Data Available" ||
                school === "No School Data Found"
                  ? `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">-</td>` // Apply consistent style
                  : `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                                    <button onclick="applySchoolFilter('${school}')" class="filter-by-school-btn"
                                        style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                                        View Responses
                                    </button>
                                </td>`;

              // Apply alternating background and consistent cell styles
              breakdownHTML += `<tr style="background-color: ${
                i % 2 === 0 ? "#fff" : "#f9f9f9"
              };">
                                <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${school}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>
                                ${actionCell}
                            </tr>`;
            }
            breakdownHTML += "</tbody>";

            // Footer Row
            breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
            breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${total.toLocaleString()}</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${
              total > 0 ? "100.0%" : "N/A"
            }</td>`;
            breakdownHTML += `<td style="padding: 8px 8px; border-top: 2px solid #ccc;"></td>`; // Empty cell for Action column
            breakdownHTML += `</tr></tfoot>`;

            breakdownHTML += "</table></div>";
            schoolBreakdown.innerHTML = breakdownHTML;
            // --- END MODIFIED ---
          }

          // Add download button handlers
          document
            .getElementById("downloadSchoolChart")
            .addEventListener("click", function () {
              // Get the chart image URI
              const chartImageURI = chart.getImageURI();

              // Create a temporary link element
              const downloadLink = document.createElement("a");
              downloadLink.href = chartImageURI;
              downloadLink.download = "school-distribution-chart.png";

              // Append to document, click, and remove
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadSchoolTable")
            .addEventListener("click", function () {
              // Get the table data
              const table = document.querySelector("#schoolBreakdown table");
              if (!table) return;

              // Create CSV content starting with the title and description
              let csv = [];
              csv.push(['"School Distribution"']);
              csv.push(['"Breakdown of submission data organized by school."']);
              csv.push([]); // Empty line for spacing

              // Convert table to CSV, excluding the Action column
              const rows = table.querySelectorAll("tr");
              rows.forEach((row) => {
                const cells = row.querySelectorAll("td, th");
                // Take all cells except the last one (Action column)
                const rowData = Array.from(cells)
                  .slice(0, -1)
                  .map((cell) => {
                    // Remove any commas from the cell text to avoid CSV issues
                    return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
                  });
                csv.push(rowData.join(","));
              });

              // Create and trigger download
              const csvContent = csv.join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "school-distribution-table.csv";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadSchoolTablePNG")
            .addEventListener("click", function () {
              const table = document.querySelector("#schoolBreakdown table");
              if (!table) return;
              // --- ADDED: Check for html2canvas ---
              if (typeof html2canvas !== "function") {
                alert("html2canvas library not loaded.");
                return;
              }

              // --- MODIFIED: Create container with consistent styling ---
              const container = document.createElement("div");
              container.style.position = "absolute";
              container.style.left = "-9999px";
              container.style.background = "white";
              container.style.padding = "20px";
              container.style.border = "1px solid #ccc";
              container.style.fontFamily = "Arial, sans-serif";

              // Add title and description (use the new structure and styles)
              const titleElement = modalContent.querySelector(
                ".modal-title-and-x-2 h3"
              );
              if (titleElement) {
                const titleClone = titleElement.cloneNode(true);
                titleClone.style.marginBottom = "5px";
                titleClone.style.fontSize = "18px";
                container.appendChild(titleClone);
              }

              const descElement = modalContent.querySelector(
                ".modal-title-and-x-2 p"
              );
              if (descElement) {
                const descClone = descElement.cloneNode(true);
                descClone.style.marginBottom = "20px";
                descClone.style.fontSize = "14px";
                container.appendChild(descClone);
              }

              // Create a clone of the table
              const tableClone = table.cloneNode(true);

              // Remove the Action column (last column) from each row
              tableClone.querySelectorAll("tr").forEach((row) => {
                const cells = row.cells;
                if (cells.length > 0) {
                  cells[cells.length - 1].remove();
                }
              });

              container.appendChild(tableClone);
              document.body.appendChild(container);

              // --- MODIFIED: Use scale, CORS, and add error handling ---
              html2canvas(container, { scale: 2, useCORS: true })
                .then(function (canvas) {
                  document.body.removeChild(container);

                  const link = document.createElement("a");
                  link.download = "school-distribution-table.png";
                  link.href = canvas.toDataURL("image/png");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                })
                .catch((err) => {
                  console.error("Error generating canvas:", err);
                  alert("Failed to generate table image.");
                  if (document.body.contains(container)) {
                    document.body.removeChild(container);
                  }
                });
              // --- END MODIFIED ---
            });
        }
      } catch (e) {
        console.error("Error rendering school chart in modal:", e);
        document.getElementById("schoolChartDetailed").innerHTML =
          "<p>Unable to display detailed chart.</p>";
      }
    }
  }
}

function closeSchoolChartModal() {
  const modal = document.getElementById("schoolChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// Function to apply school filter
function applySchoolFilter(school) {
  // Add this line to close the language distribution modal
  closeLanguageDistributionChartModal();

  // First, close the modal
  closeSchoolChartModal();

  // Use the common filter function
  applyFilterWithoutModal("school", school);
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// apply filters xxx
document.addEventListener("DOMContentLoaded", function () {
  // Get the apply filter button from the window object or directly from the DOM
  const applyFilterBtn =
    window.applyFilterBtn || document.getElementById("applyFilter");

  if (applyFilterBtn) {
    applyFilterBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const filterValue = document.getElementById("sentimentFilter").value;
      // Use window object to access global variables
      window.currentPage = 1;
      document.getElementById("currentPage").textContent = "1";
      displayResponses(sheetData, filterValue);
      document.querySelector("responseData").scrollIntoView({
        behavior: "smooth",
      });
    });
  }
});

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

function openGradeLevelChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("gradeLevelChartModal");
  if (modal) {
    modal.style.display = "block";

    // --- MODIFIED: Update Modal Content Structure ---
    const modalContent = document.getElementById("gradeLevelChartModalContent");
    if (modalContent) {
      modalContent.style.opacity = "0";
      modalContent.style.transition = "opacity 0.45s ease-in-out";

      // New HTML structure - STRICTLY MATCHING Language Modal
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2 id="gradeDistTitle">Grade Level</h2> 
                        <p id="gradeDistDescription">Breakdown of grade distribution across all users.</p>
                    </div>
                    <div class="action-container">
                        <div style="margin-right: 15px;"> 
                             <select id="gradeChartViewOption" onchange="switchGradeView(this.value)" 
                                style="padding: 4px 8px; border-radius: 4px; border: 1px solid #ccc; font-size: 0.9em;">
                                 <option value="overall">View by grade</option>
                                 <option value="byRole">View by role</option>
                             </select>
                         </div>
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadGradeChartPNG" class="download-chart-btn">
                                     <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                            <!-- Table download buttons moved below -->
                        </div>
                        <span class="rolesChartModal-close" onclick="closeGradeLevelChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="gradeLevelChartDetailed" style="width: 100%; height: 400px; margin-top: 15px; transition: opacity 0.3s ease-in-out;"></div>

               
                <div class="roles-stats" style="margin-top: 20px;"> 
                    <!-- ADDED: Secondary title/action container for table -->
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3 id="gradeBreakdownTitle">Grade Level</h3>
                            <p id="gradeBreakdownDescription">Breakdown of grade distribution across all users.</p> 
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadGradeTableCSV" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadGradeTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END ADDED Secondary container -->

                    <div id="gradeBreakdown" style="width: 100%; transition: opacity 0.3s ease-in-out;"></div> 
                </div>
                
            `;

      // Data check and initial render remains the same
      if (!window.sheetData || window.sheetData.length === 0) {
        // ... (error handling as before) ...
        return;
      }
      renderGradeChart("overall");

      // --- REMOVED: Event Delegation Setup ---
      // const modalContentElement = document.getElementById('gradeLevelChartModalContent');
      // if (modalContentElement) {
      //    modalContentElement.removeEventListener('click', handleGradeModalClick);
      //    modalContentElement.addEventListener('click', handleGradeModalClick);
      // }
      // --- END REMOVED ---

      // Event listeners - ATTACH TO NEW BUTTON IDs/STRUCTURE
      // Re-introduce direct listener attachment logic in render functions
      const downloadTableCSVButton = document.getElementById(
        "downloadGradeTableCSV"
      );
      const downloadTablePNGButton = document.getElementById(
        "downloadGradeTablePNG"
      );

      // Chart download listener will be attached in render functions

      if (downloadTableCSVButton) {
        const newBtn = downloadTableCSVButton.cloneNode(true);
        downloadTableCSVButton.parentNode.replaceChild(
          newBtn,
          downloadTableCSVButton
        );
        newBtn.addEventListener("click", () => downloadGradeTableData("csv"));
      }
      if (downloadTablePNGButton) {
        const newBtn = downloadTablePNGButton.cloneNode(true);
        downloadTablePNGButton.parentNode.replaceChild(
          newBtn,
          downloadTablePNGButton
        );
        newBtn.addEventListener("click", () => downloadGradeTableData("png"));
      }

      // Fade in
      setTimeout(() => {
        modalContent.style.opacity = "1";
      }, 150);
    }
  }
}
function switchGradeView(viewType) {
  console.log(`Switching grade level view to: ${viewType}`);

  const chartContainer = document.getElementById("gradeLevelChartDetailed");
  const breakdownContainer = document.getElementById("gradeBreakdown");

  // Fade out content
  if (chartContainer) chartContainer.style.opacity = "0";
  if (breakdownContainer) breakdownContainer.style.opacity = "0";

  // Use a short delay for the fade-out effect
  setTimeout(() => {
    // Re-render the chart with the new view type
    // Data check happens inside renderGradeChart
    renderGradeChart(viewType);
    // Fade-in is handled within renderGradeChart now
  }, 300); // Adjust timeout as needed
}
function renderGradeChart(viewType) {
  console.log(`Rendering grade chart with view type: ${viewType}`);
  const chartContainer = document.getElementById("gradeLevelChartDetailed");
  const breakdownContainer = document.getElementById("gradeBreakdown");
  const modalContent = document.getElementById("gradeLevelChartModalContent"); // Get modal content for opacity

  try {
    if (!window.google || !window.google.visualization) {
      console.error("Google visualization library not available");
      if (chartContainer)
        chartContainer.innerHTML = "<p>Chart visualization not available.</p>";
      if (breakdownContainer) breakdownContainer.innerHTML = ""; // Clear breakdown too
      // Fade in the modal content to show the error
      if (modalContent) modalContent.style.opacity = "1";
      return;
    }

    // --- MODIFIED: Update Titles/Descriptions Dynamically ---
    const titleElement = document.getElementById("gradeDistTitle");
    const descriptionElement = document.getElementById("gradeDistDescription");
    const breakdownTitleElement = document.getElementById(
      "gradeBreakdownTitle"
    );
    const breakdownDescriptionElement = document.getElementById(
      "gradeBreakdownDescription"
    );

    if (viewType === "overall") {
      if (titleElement) titleElement.textContent = "Grade Distribution";
      if (descriptionElement)
        descriptionElement.textContent =
          "All user responses organized by grade level.";
      if (breakdownTitleElement)
        breakdownTitleElement.textContent =
          "Grade level breakdown across all users.";
      if (breakdownDescriptionElement)
        breakdownDescriptionElement.textContent =
          "Breakdown of responses across all questions.";
      renderOverallGradeChart();
    } else if (viewType === "byRole") {
      if (titleElement) titleElement.textContent = "Grade Distribution";
      if (descriptionElement)
        descriptionElement.textContent =
          "All user responses organized by grade level.";
      if (breakdownTitleElement)
        breakdownTitleElement.textContent = "Grade Level Breakdown";
      if (breakdownDescriptionElement)
        breakdownDescriptionElement.textContent =
          "Breakdown of user responses across all questions.";
      renderGradeByRoleChart();
    }
    // --- END MODIFIED Titles/Descriptions ---

    // --- MODIFIED: Fade in chart and breakdown containers ---
    // Fade in the chart and breakdown containers after rendering
    setTimeout(() => {
      if (chartContainer) chartContainer.style.opacity = "1";
      if (breakdownContainer) breakdownContainer.style.opacity = "1";
      // Ensure modal content is also visible if it was faded out
      if (modalContent && modalContent.style.opacity === "0") {
        modalContent.style.opacity = "1";
      }
    }, 150);
    // --- END MODIFIED Fade-in ---
  } catch (e) {
    console.error("Error rendering grade level chart:", e);
    if (chartContainer) {
      chartContainer.innerHTML = `
                <div style="color: #721c24; background-color: #f8d7da; padding: 15px; border-radius: 5px;">
                    <h3>Error Displaying Chart</h3>
                    <p>${e.message}</p>
                </div>
            `;
    }
    if (breakdownContainer) breakdownContainer.innerHTML = ""; // Clear breakdown on error

    // Fade in the modal content to show the error
    if (modalContent) modalContent.style.opacity = "1";
    // Also ensure chart/breakdown are visible to show error msg
    if (chartContainer) chartContainer.style.opacity = "1";
    if (breakdownContainer) breakdownContainer.style.opacity = "1";
  }
}
function downloadGradeTableData(format) {
  const breakdownContainer = document.getElementById("gradeBreakdown");
  const table = breakdownContainer
    ? breakdownContainer.querySelector("table")
    : null;

  if (!table) {
    console.error("Breakdown table not found for download.");
    alert("Could not find the table data to download.");
    return;
  }

  const viewType =
    document.getElementById("gradeChartViewOption")?.value || "overall";
  const timestamp = new Date().toISOString().split("T")[0];
  const filename = `Grade_Distribution_${viewType}_${timestamp}`;

  if (format === "csv") {
    // Logic to convert HTML table to CSV
    let csv = [];
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      let rowData = [];
      const cols = row.querySelectorAll("th, td");
      cols.forEach((col) => {
        // Extract text, handling potential links or other elements inside cells
        let cellText = col.innerText.trim();
        // Clean quotes
        cellText = cellText.replace(/"/g, '""');
        rowData.push(`"${cellText}"`);
      });
      csv.push(rowData.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else if (format === "png") {
    // Logic to download table as PNG using html2canvas
    if (typeof html2canvas === "undefined") {
      console.error("html2canvas library is not loaded.");
      alert("Could not download table as PNG. Required library not found.");
      return;
    }

    const tableTitle =
      document.getElementById("gradeBreakdownTitle")?.textContent ||
      "Grade Breakdown Table";
    const tableDescription =
      document.getElementById("gradeBreakdownDescription")?.textContent || "";

    // Create a temporary container for rendering
    const renderContainer = document.createElement("div");
    renderContainer.style.padding = "20px";
    renderContainer.style.backgroundColor = "#ffffff"; // White background
    renderContainer.style.border = "1px solid #ccc";
    renderContainer.style.display = "inline-block"; // Fit content

    const titleElement = document.createElement("h3");
    titleElement.textContent = tableTitle;
    titleElement.style.marginBottom = "5px";
    renderContainer.appendChild(titleElement);

    const descriptionElement = document.createElement("p");
    descriptionElement.textContent = tableDescription;
    descriptionElement.style.marginBottom = "15px";
    descriptionElement.style.fontSize = "12px";
    descriptionElement.style.color = "#555";
    renderContainer.appendChild(descriptionElement);

    // Clone the table to avoid modifying the original
    const tableClone = table.cloneNode(true);
    renderContainer.appendChild(tableClone);

    // Append to body temporarily for rendering
    document.body.appendChild(renderContainer);

    html2canvas(renderContainer, {
      scale: 2, // Increase scale for better resolution
      useCORS: true,
      logging: false,
    })
      .then((canvas) => {
        const image = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        const link = document.createElement("a");
        link.setAttribute("download", `${filename}.png`);
        link.setAttribute("href", image);
        link.click();

        // Clean up the temporary container
        document.body.removeChild(renderContainer);
      })
      .catch((error) => {
        console.error("Error generating table PNG:", error);
        alert("An error occurred while generating the table image.");
        // Clean up the temporary container even if there's an error
        if (document.body.contains(renderContainer)) {
          document.body.removeChild(renderContainer);
        }
      });
  }
}

function renderOverallGradeChart() {
  console.log("Rendering overall grade chart counting unique users");
  const chartContainer = document.getElementById("gradeLevelChartDetailed");
  if (!chartContainer) return;

  // Define colors array
  const colors = [
    "#219ebc",
    "#ffb703",
    "#850101",
    "#1f4f71",
    "#99582a",
    "#607080",
    "#185040",
    "#c3c3c3",
    "#fb8500",
    "#457b9d",
    "#d4a373",
    "#5b8e7d",
    "#8ecae6",
    "#6a4c93",
    "#f72585",
    "#272727",
    "#1f4f71",
    "#99582a",
  ];

  // Create a data structure to hold unique users by grade
  const gradeUsers = new Map(); // grade -> Set of userIds
  const gradeSet = new Set();
  const processedUsers = new Set(); // Track processed users to avoid double counting

  if (!window.sheetData || window.sheetData.length === 0) {
    console.warn("No sheet data available for grade chart");
    chartContainer.innerHTML = `
            <div style="text-align: center; padding: 20px;">
                <p>No data available. Please ensure data is loaded correctly.</p>
            </div>
        `;
    return;
  }

  // First pass - identify all unique grades
  window.sheetData.forEach((item) => {
    if (!item) return;

    // Skip community role users
    let roleValue = null;
    if (item.role) {
      roleValue = item.role;
    } else if (item.Role) {
      roleValue = item.Role;
    }

    if (roleValue && String(roleValue).trim().toLowerCase() === "community") {
      return;
    }

    // Try different field names for grade
    let gradeValue = null;
    if (item.grade) {
      gradeValue = item.grade;
    } else if (item.Grade) {
      gradeValue = item.Grade;
    } else if (item.grade_level) {
      gradeValue = item.grade_level;
    } else if (item.gradeLevel) {
      gradeValue = item.gradeLevel;
    }

    if (!gradeValue) return;

    // Handle comma-separated grades
    if (gradeValue.includes(",")) {
      // Split grades and register each one
      const grades = gradeValue.split(",").map((g) => g.trim());
      grades.forEach((grade) => {
        if (grade) {
          const normalizedGrade = String(grade).trim();
          gradeSet.add(normalizedGrade);
          if (!gradeUsers.has(normalizedGrade)) {
            gradeUsers.set(normalizedGrade, new Set());
          }
        }
      });
    } else {
      const normalizedGrade = String(gradeValue).trim();
      if (normalizedGrade) {
        gradeSet.add(normalizedGrade);
        if (!gradeUsers.has(normalizedGrade)) {
          gradeUsers.set(normalizedGrade, new Set());
        }
      }
    }
  });

  console.log(`Found ${gradeSet.size} unique grades`);

  // If no grades were found, show placeholder
  if (gradeSet.size === 0) {
    console.warn("No grade data found in items");
    chartContainer.innerHTML = `
            <div style="text-align: center; padding: 20px;">
                <p>No grade data found. Please ensure your data includes grade information.</p>
            </div>
        `;

    // Also show a message in the breakdown area
    document.getElementById("gradeBreakdown").innerHTML = `
            <div class="alert" style="background-color: #f8d7da; color: #721c24; padding: 10px; border-radius: 4px; margin-top: 15px;">
                <p><strong>No grade level data found.</strong> Your data may not include grade information, or it might be using a different field name.</p>
                <p>Please check your data structure to ensure grade information is available.</p>
            </div>
        `;
    return;
  }

  // Second pass - process each user only once with their primary grade
  // This prevents double-counting users
  window.sheetData.forEach((item) => {
    if (!item) return;

    // Skip if no grade value
    let gradeValue = null;
    if (item.grade) {
      gradeValue = item.grade;
    } else if (item.Grade) {
      gradeValue = item.Grade;
    } else if (item.grade_level) {
      gradeValue = item.grade_level;
    } else if (item.gradeLevel) {
      gradeValue = item.gradeLevel;
    }

    if (!gradeValue) return;

    // Skip community role users
    let roleValue = null;
    if (item.role) {
      roleValue = item.role;
    } else if (item.Role) {
      roleValue = item.Role;
    }

    if (roleValue && String(roleValue).trim().toLowerCase() === "community") {
      return;
    }

    // Create a user identifier from available fields
    const userKey =
      item.userId ||
      item.user_id ||
      item.email ||
      item.name + "-" + (item.timestamp || Date.now());

    // Skip if we've already processed this user
    if (processedUsers.has(userKey)) {
      return;
    }

    // Handle comma-separated grades - use the first grade as primary
    if (gradeValue.includes(",")) {
      const grades = gradeValue.split(",").map((g) => g.trim());
      if (grades.length > 0 && grades[0]) {
        const primaryGrade = String(grades[0]).trim();
        if (gradeUsers.has(primaryGrade)) {
          gradeUsers.get(primaryGrade).add(userKey);
          processedUsers.add(userKey);
        }
      }
    } else {
      const normalizedGrade = String(gradeValue).trim();
      if (gradeUsers.has(normalizedGrade)) {
        gradeUsers.get(normalizedGrade).add(userKey);
        processedUsers.add(userKey);
      }
    }
  });

  // Log for debugging
  console.log(
    "Unique users by grade (final):",
    Array.from(gradeUsers.entries()).map(
      ([grade, users]) => `${grade}: ${users.size}`
    )
  );

  // Custom sort function for grades to put PK, K at the beginning
  const gradeOrder = (a, b) => {
    // Handle special cases for PK and K
    const gradeA = a.toUpperCase();
    const gradeB = b.toUpperCase();

    // PK/Pre-K should always be first
    if (gradeA === "PK" || gradeA === "PRE-K" || gradeA.includes("PRE-K"))
      return -2;
    if (gradeB === "PK" || gradeB === "PRE-K" || gradeB.includes("PRE-K"))
      return 2;

    // K/Kindergarten should be second
    if (gradeA === "K" || gradeA === "KINDERGARTEN" || gradeA.includes("KIND"))
      return -1;
    if (gradeB === "K" || gradeB === "KINDERGARTEN" || gradeB.includes("KIND"))
      return 1;

    // Try to compare as numbers for numbered grades (1st, 2nd, etc.)
    const numA = parseInt(gradeA);
    const numB = parseInt(gradeB);
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }

    // Otherwise sort alphabetically
    return a.localeCompare(b);
  };

  // Filter out any grades that might still have only community role users
  const validGrades = Array.from(gradeSet).filter((grade) => {
    const userSet = gradeUsers.get(grade);
    return userSet && userSet.size > 0;
  });

  // Triple-check: completely remove any users with community role
  window.sheetData.forEach((item) => {
    if (!item) return;

    // Check if this is a community role
    let roleValue = null;
    if (item.role) {
      roleValue = item.role;
    } else if (item.Role) {
      roleValue = item.Role;
    }

    if (!roleValue || String(roleValue).trim().toLowerCase() !== "community") {
      return; // Skip non-community roles
    }

    // This is a community role - remove from all grades
    const userKey =
      item.userId ||
      item.user_id ||
      item.email ||
      item.name + "-" + (item.timestamp || Date.now());

    gradeUsers.forEach((users, grade) => {
      if (users.has(userKey)) {
        users.delete(userKey);
        console.log(`Removed community user ${userKey} from grade ${grade}`);
      }
    });
  });

  const sortedGrades = validGrades.sort(gradeOrder);

  // Helper function to format grade names for display
  function formatGradeName(grade) {
    if (!grade) return grade;

    const upperGrade = grade.toUpperCase();
    if (upperGrade === "PK" || upperGrade.includes("PRE-K")) return "Pre-K";
    if (upperGrade === "K" || upperGrade.includes("KIND"))
      return "Kindergarten";

    // Check if it's a numeric grade
    const numMatch = grade.match(/^(\d+)/);
    if (numMatch) {
      const num = parseInt(numMatch[1]);
      if (!isNaN(num)) {
        let suffix = "th";
        if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
        else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
        else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";
        return `${num}${suffix} Grade`;
      }
    }

    return grade; // Return original if no transformation applies
  }

  const chartData = new google.visualization.DataTable();
  chartData.addColumn("string", "Grade");
  chartData.addColumn("number", "Unique Users");
  chartData.addColumn({ type: "string", role: "style" });
  chartData.addColumn({ type: "string", role: "tooltip", p: { html: true } });

  sortedGrades.forEach((grade, index) => {
    const userSet = gradeUsers.get(grade);
    const count = userSet ? userSet.size : 0;
    const colorIndex = index % colors.length;
    const formattedGrade = formatGradeName(grade);
    const tooltip = `<div style="padding:10px; white-space:nowrap; min-width:150px;"><strong>${formattedGrade}</strong><br/>${count.toLocaleString()} Submissions</div>`;
    chartData.addRow([grade, count, colors[colorIndex], tooltip]);
  });

  const options = {
    title: "Grade distribution percentage across all users",
    legend: "none",
    chartArea: { width: "90%", height: "80%" },
    tooltip: { isHtml: true, trigger: "both" },
  };

  const chart = new google.visualization.BarChart(chartContainer);

  google.visualization.events.addListener(chart, "select", function () {
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      if (selectedItem) {
        const selectedGrade = chartData.getValue(selectedItem.row, 0);

        closeGradeLevelChartModal();

        applyGradeFilter(selectedGrade);
      }
    }
  });

  chart.draw(chartData, options);

  const downloadChartPNGButton = document.getElementById(
    "downloadGradeChartPNG"
  );
  if (downloadChartPNGButton) {
    const newDownloadChartPNGButton = downloadChartPNGButton.cloneNode(true);
    downloadChartPNGButton.parentNode.replaceChild(
      newDownloadChartPNGButton,
      downloadChartPNGButton
    );

    newDownloadChartPNGButton.addEventListener("click", function () {
      // Use the 'chart' object directly from the renderOverallGradeChart scope
      if (chart && typeof chart.getImageURI === "function") {
        try {
          const chartImageURI = chart.getImageURI();
          const link = document.createElement("a");
          link.href = chartImageURI;
          link.download = "overall-grade-distribution-chart.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (e) {
          console.error("Error getting chart image URI:", e);
          alert("Failed to download chart image.");
        }
      } else {
        console.warn("Chart object not ready for download click.");
        alert("Chart may still be rendering. Please try again.");
      }
    });
    console.log("Overall chart rendered, listener attached directly.");
  }

  createOverallGradeBreakdownTable(chartData);
}
function renderGradeByRoleChart() {
  const chartContainer = document.getElementById("gradeLevelChartDetailed");
  if (!chartContainer) return;

  // Helper function to capitalize the first letter
  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Helper function to format grade names for display
  function formatGradeName(grade) {
    if (!grade) return grade;

    const upperGrade = grade.toUpperCase();
    if (upperGrade === "PK" || upperGrade.includes("PRE-K")) return "Pre-K";
    if (upperGrade === "K" || upperGrade.includes("KIND"))
      return "Kindergarten";

    // Check if it's a numeric grade
    const numMatch = grade.match(/^(\d+)/);
    if (numMatch) {
      const num = parseInt(numMatch[1]);
      if (!isNaN(num)) {
        let suffix = "th";
        if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
        else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
        else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";
        return `${num}${suffix} Grade`;
      }
    }

    return grade; // Return original if no transformation applies
  }

  // Check if we have the necessary data
  if (!window.sheetData || window.sheetData.length === 0) {
    chartContainer.innerHTML = `
            <div style="text-align: center; padding: 20px;">
                <p>No data available. Please ensure data is loaded correctly.</p>
            </div>
        `;
    return;
  }

  const roleGradeMap = new Map(); // Map of role -> grade -> user Set
  const roleSet = new Set();
  const gradeSet = new Set();
  const processedUsers = new Set(); // Track processed users to avoid double counting

  window.sheetData.forEach((item) => {
    if (!item) return;

    let roleValue = null;
    if (item.role) {
      roleValue = item.role;
    } else if (item.Role) {
      roleValue = item.Role;
    }

    let gradeValue = null;
    if (item.grade) {
      gradeValue = item.grade;
    } else if (item.Grade) {
      gradeValue = item.Grade;
    } else if (item.grade_level) {
      gradeValue = item.grade_level;
    } else if (item.gradeLevel) {
      gradeValue = item.gradeLevel;
    }

    if (roleValue && gradeValue) {
      const normalizedRole = String(roleValue).trim();

      // Skip community role
      if (normalizedRole.toLowerCase() === "community") return;

      roleSet.add(normalizedRole);

      // Initialize the role map if not exists
      if (!roleGradeMap.has(normalizedRole)) {
        roleGradeMap.set(normalizedRole, new Map());
      }

      // Handle comma-separated grades
      if (gradeValue.includes(",")) {
        const grades = gradeValue.split(",").map((g) => g.trim());
        grades.forEach((grade) => {
          if (grade) {
            const normalizedGrade = grade.trim();
            gradeSet.add(normalizedGrade);

            // Initialize the user set for this role-grade combination
            if (!roleGradeMap.get(normalizedRole).has(normalizedGrade)) {
              roleGradeMap.get(normalizedRole).set(normalizedGrade, new Set());
            }
          }
        });
      } else {
        const normalizedGrade = String(gradeValue).trim();
        if (normalizedGrade) {
          gradeSet.add(normalizedGrade);

          // Initialize the user set for this role-grade combination
          if (!roleGradeMap.get(normalizedRole).has(normalizedGrade)) {
            roleGradeMap.get(normalizedRole).set(normalizedGrade, new Set());
          }
        }
      }
    }
  });

  // If we don't have enough data, show a message
  if (roleSet.size === 0 || gradeSet.size === 0) {
    chartContainer.innerHTML = `
            <div style="text-align: center; padding: 20px;">
                <p>Insufficient data to show grade levels by role. Please ensure both grade and role data are available.</p>
            </div>
        `;
    return;
  }

  // Second pass - add each user to their primary role-grade combination
  window.sheetData.forEach((item) => {
    if (!item) return;

    // Get role value
    let roleValue = null;
    if (item.role) {
      roleValue = item.role;
    } else if (item.Role) {
      roleValue = item.Role;
    }

    // Get grade value
    let gradeValue = null;
    if (item.grade) {
      gradeValue = item.grade;
    } else if (item.Grade) {
      gradeValue = item.Grade;
    } else if (item.grade_level) {
      gradeValue = item.grade_level;
    } else if (item.gradeLevel) {
      gradeValue = item.gradeLevel;
    }

    if (!roleValue || !gradeValue) return;

    // Skip community role
    if (String(roleValue).trim().toLowerCase() === "community") return;

    // Create a user identifier from available fields
    const userKey =
      item.userId ||
      item.user_id ||
      item.email ||
      item.name + "-" + (item.timestamp || Date.now());

    // Skip if we've already processed this user
    if (processedUsers.has(userKey)) return;

    const normalizedRole = String(roleValue).trim();

    // Handle comma-separated grades - use the first grade as primary
    if (gradeValue.includes(",")) {
      const grades = gradeValue.split(",").map((g) => g.trim());
      if (grades.length > 0 && grades[0]) {
        const primaryGrade = String(grades[0]).trim();

        if (
          roleGradeMap.has(normalizedRole) &&
          roleGradeMap.get(normalizedRole).has(primaryGrade)
        ) {
          // Add user to their role-grade combination
          roleGradeMap.get(normalizedRole).get(primaryGrade).add(userKey);
          processedUsers.add(userKey);
        }
      }
    } else {
      const normalizedGrade = String(gradeValue).trim();

      if (
        roleGradeMap.has(normalizedRole) &&
        roleGradeMap.get(normalizedRole).has(normalizedGrade)
      ) {
        // Add user to their role-grade combination
        roleGradeMap.get(normalizedRole).get(normalizedGrade).add(userKey);
        processedUsers.add(userKey);
      }
    }
  });

  // Custom sort function for grades to put PK, K at the beginning
  const gradeOrder = (a, b) => {
    // Handle special cases for PK and K
    if (a.toUpperCase() === "PK" || a.toUpperCase() === "PRE-K") return -2;
    if (b.toUpperCase() === "PK" || b.toUpperCase() === "PRE-K") return 2;
    if (a.toUpperCase() === "K" || a.toUpperCase() === "KINDERGARTEN")
      return -1;
    if (b.toUpperCase() === "K" || b.toUpperCase() === "KINDERGARTEN") return 1;

    // Try to compare as numbers for numbered grades (1st, 2nd, etc.)
    const numA = parseInt(a);
    const numB = parseInt(b);
    if (!isNaN(numA) && !isNaN(numB)) {
      return numA - numB;
    }

    // Otherwise sort alphabetically
    return a.localeCompare(b);
  };

  // Sort grades for consistent display
  const sortedGrades = Array.from(gradeSet).sort(gradeOrder);

  // Create a DataTable with grades as columns and roles as rows
  const data = new google.visualization.DataTable();
  data.addColumn("string", "Role");

  // Add a column for each grade and tooltip
  sortedGrades.forEach((grade) => {
    data.addColumn("number", grade);
    data.addColumn({ type: "string", role: "tooltip", p: { html: true } });
  });

  const roleTotals = new Map();
  Array.from(roleSet)
    .filter((role) => role.toLowerCase() !== "community") // EXPLICITLY filter out community role
    .forEach((role) => {
      let total = 0;
      sortedGrades.forEach((grade) => {
        const userSet = roleGradeMap.get(role)?.get(grade);
        const count = userSet ? userSet.size : 0;
        total += count;
      });
      roleTotals.set(role, total);
    });

  // Add data rows for each role with percentages
  Array.from(roleSet)
    .filter((role) => role.toLowerCase() !== "community") // EXPLICITLY filter out community role
    .forEach((role) => {
      const row = [capitalizeFirstLetter(role)]; // Capitalize role ONLY for chart display
      const roleTotal = roleTotals.get(role) || 0;

      if (roleTotal === 0) {
        sortedGrades.forEach((grade) => {
          row.push(0); // Value
          const formattedGrade = formatGradeName(grade);
          row.push(
            `<div style="padding:10px; white-space:nowrap; min-width:150px;"><strong>${capitalizeFirstLetter(
              role
            )}</strong><br/>${formattedGrade}<br/>0 Submissions<br/>0.0%</div>`
          ); // Tooltip
        });
      } else {
        sortedGrades.forEach((grade) => {
          const userSet = roleGradeMap.get(role)?.get(grade);
          const count = userSet ? userSet.size : 0;
          const percentage = roleTotal > 0 ? (count / roleTotal) * 100 : 0;
          row.push(percentage); // Value
          const formattedGrade = formatGradeName(grade);
          row.push(
            `<div style="padding:10px; white-space:nowrap; min-width:150px;"><strong>${capitalizeFirstLetter(
              role
            )}</strong><br/>${formattedGrade}<br/>${count.toLocaleString()} Submissions<br/>${percentage.toFixed(
              1
            )}%`
          ); // Tooltip
        });
      }

      data.addRow(row);
    });

  const view = new google.visualization.DataView(data);

  const formatter = new google.visualization.NumberFormat({
    pattern: "#.#'%'",
  });

  // Format only number columns, skip tooltip columns
  for (let i = 1; i < data.getNumberOfColumns(); i += 2) {
    formatter.format(data, i);
  }

  const options = {
    title: "Grade Level Distribution by Role",
    isStacked: true,
    legend: { position: "bottom", maxLines: 1 },
    // hAxis: {title: 'Role', titleTextStyle: {color: '#333'}},
    vAxis: {
      minValue: 0,
      maxValue: 100,
      title: "",
      format: "#'%'",
    },
    tooltip: { isHtml: true, trigger: "both" },
    colors: [
      "#219ebc",
      "#ffb703",
      "#850101",
      "#1f4f71",
      "#99582a",
      "#607080",
      "#185040",
      "#c3c3c3",
      "#fb8500",
      "#457b9d",
      "#d4a373",
      "#5b8e7d",
      "#8ecae6",
      "#6a4c93",
      "#f72585",
      "#272727",
      "#1f4f71",
      "#99582a",
    ],
  };

  const chart = new google.visualization.ColumnChart(chartContainer);

  google.visualization.events.addListener(chart, "select", function () {
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      if (selectedItem) {
        const role = data.getValue(selectedItem.row, 0);
        // Since we have 2 columns per grade (value + tooltip), we need to adjust
        const gradeIndex = Math.floor((selectedItem.column - 1) / 2);
        const grade = sortedGrades[gradeIndex];

        closeGradeLevelChartModal();

        // Apply both grade and role filters
        applyGradeAndRoleFilter(grade, role);
      }
    }
  });

  chart.draw(view, options);

  // --- MODIFIED: Restore direct listener attachment (matching working pattern) ---
  const downloadChartPNGButton = document.getElementById(
    "downloadGradeChartPNG"
  );
  if (downloadChartPNGButton) {
    // Remove previous listeners by cloning *before* adding the new one
    const newDownloadChartPNGButton = downloadChartPNGButton.cloneNode(true);
    downloadChartPNGButton.parentNode.replaceChild(
      newDownloadChartPNGButton,
      downloadChartPNGButton
    );

    newDownloadChartPNGButton.addEventListener("click", function () {
      // Use the 'chart' object directly from the renderGradeByRoleChart scope
      if (chart && typeof chart.getImageURI === "function") {
        try {
          const chartImageURI = chart.getImageURI();
          const link = document.createElement("a");
          link.href = chartImageURI;
          link.download = "grade-distribution-by-role-chart.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (e) {
          console.error("Error getting chart image URI:", e);
          alert("Failed to download chart image.");
        }
      } else {
        console.warn("Chart object not ready for download click.");
        alert("Chart may still be rendering. Please try again.");
      }
    });
  }

  const gradeBreakdownContainer = document.getElementById("gradeBreakdown");
  if (gradeBreakdownContainer) {
    let breakdownHTML =
      '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">';
    breakdownHTML +=
      '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">';

    breakdownHTML +=
      '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">';
    breakdownHTML +=
      '<th style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #ddd;">Role</th>';
    sortedGrades.forEach((grade) => {
      breakdownHTML += `<th style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #ddd;">${grade}</th>`;
    });
    breakdownHTML +=
      '<th style="text-align:center; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #ddd;">Total</th></tr></thead>';

    breakdownHTML += "<tbody>";
    let grandTotalsByGrade = {};
    sortedGrades.forEach((grade) => (grandTotalsByGrade[grade] = 0));
    let grandTotalAll = 0;

    Array.from(roleSet)
      .sort()
      .forEach((role, roleIndex) => {
        // Alternating row color - STRICTLY MATCHING
        breakdownHTML += `<tr style="background-color: ${
          roleIndex % 2 === 0 ? "#fff" : "#f9f9f9"
        };">`;
        breakdownHTML += `<td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${role}</td>`;

        let roleTotal = 0;
        sortedGrades.forEach((grade) => {
          const userSet = roleGradeMap.get(role)?.get(grade);
          const count = userSet ? userSet.size : 0;
          roleTotal += count;
          grandTotalsByGrade[grade] += count;

          breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                    <a href="#" onclick="applyGradeAndRoleFilter(\'${grade}\', \'${role}\'); return false;" 
                       style="text-decoration: none; color: ${
                         count > 0 ? "#0056b3" : "#999"
                       }; display: block; width: 100%; height: 100%;">
                        ${count.toLocaleString()}
                    </a>
                </td>`;
        });
        grandTotalAll += roleTotal;
        breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee; font-weight: bold;">
                ${roleTotal.toLocaleString()}
            </td></tr>`;
      });
    breakdownHTML += "</tbody>";

    breakdownHTML +=
      '<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>';
    breakdownHTML +=
      '<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>';
    sortedGrades.forEach((grade) => {
      breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">
                <a href="#" onclick="applyGradeFilter(\'${grade}\'); return false;" 
                   style="text-decoration: none; color: ${
                     grandTotalsByGrade[grade] > 0 ? "#0056b3" : "#999"
                   }; display: block; width: 100%; height: 100%;">
                    ${(grandTotalsByGrade[grade] || 0).toLocaleString()}
                </a>
            </td>`;
    });

    breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">
            ${grandTotalAll.toLocaleString()}
        </td></tr></tfoot>`;

    breakdownHTML += "</table></div>"; // Close container div
    gradeBreakdownContainer.innerHTML = breakdownHTML;
  }
}

function createOverallGradeBreakdownTable(data) {
  const gradeBreakdownContainer = document.getElementById("gradeBreakdown");
  if (!gradeBreakdownContainer) return;

  let breakdownHTML =
    '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">';
  breakdownHTML +=
    '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">';
  breakdownHTML +=
    '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">';
  breakdownHTML +=
    '<th style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #ddd;">Grade Level</th>';
  breakdownHTML +=
    '<th style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #ddd;">Total</th>';
  breakdownHTML +=
    '<th style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #ddd;">Percentage</th>';
  breakdownHTML +=
    '<th style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #ddd;">Action</th></tr></thead>';

  breakdownHTML += "<tbody>";
  let totalUsers = 0;
  for (let i = 0; i < data.getNumberOfRows(); i++) {
    totalUsers += data.getValue(i, 1);
  }

  for (let i = 0; i < data.getNumberOfRows(); i++) {
    const grade = data.getValue(i, 0);
    const count = data.getValue(i, 1);
    const percentage =
      totalUsers > 0 ? ((count / totalUsers) * 100).toFixed(1) : 0;

    const isPlaceholder =
      grade === "No Data Available" || grade === "No Grade Data Found";
    const actionCellHTML = isPlaceholder
      ? `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">-</td>`
      : `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                <button onclick="applyGradeFilter(\'${grade}\')" class="filter-by-grade-btn"
                    style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5; font-size: 0.9em;">
                    View Responses
                </button>
            </td>`;

    breakdownHTML += `<tr style="background-color: ${
      i % 2 === 0 ? "#fff" : "#f9f9f9"
    };">
            <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${grade}</td>
            <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>
            <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>
            ${actionCellHTML}
        </tr>`;
  }
  breakdownHTML += "</tbody>";

  breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
  breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Total</td>`;
  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${totalUsers.toLocaleString()}</td>`;
  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">100.0%</td>`;
  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">-</td>`;
  breakdownHTML += `</tr></tfoot>`;

  breakdownHTML += "</table></div>"; // Close container div
  gradeBreakdownContainer.innerHTML = breakdownHTML;
}
function applyGradeAndRoleFilter(grade, role) {
  closeGradeLevelChartModal();

  const gradeChips = document.querySelectorAll(".grade-chip");
  const roleChips = document.querySelectorAll(".role-chip");

  if (gradeChips.length > 0 && roleChips.length > 0) {
    const clearAllFiltersBtn = document.querySelector(
      ".clear-all-filters-chip"
    );
    if (clearAllFiltersBtn) {
      clearAllFiltersBtn.click();
    }

    setTimeout(() => {
      gradeChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      roleChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });

      let targetGradeChip = findFilterChip(gradeChips, grade, "data-grade");
      if (targetGradeChip) {
        targetGradeChip.classList.add("active");
      }

      let targetRoleChip = findFilterChip(roleChips, role, "data-role");
      if (targetRoleChip) {
        targetRoleChip.classList.add("active");
        console.log("Activated role chip:", role);
      }

      if (typeof updateDisplay === "function") {
        updateDisplay();
      }

      const filterModal = document.querySelector(".filter-modal");
      const collapseBtn = document.querySelector(".collapse-btn");

      if (filterModal && filterModal.style.display !== "none") {
        if (collapseBtn) {
          collapseBtn.click();
        } else {
          filterModal.style.display = "none";
        }
      }

      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
      }

      setTimeout(() => {
        const responsesSection = document.getElementById("d");
        if (responsesSection) {
          responsesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
    }, 100);
  } else {
    console.warn("Grade or role filter chips not found in the document");
  }
}
function findFilterChip(chips, value, attribute) {
  let chip = Array.from(chips).find((c) => c.getAttribute(attribute) === value);

  if (!chip) {
    chip = Array.from(chips).find((c) => {
      const attrValue = c.getAttribute(attribute);
      return attrValue && attrValue.toLowerCase() === value.toLowerCase();
    });
  }

  if (!chip) {
    chip = Array.from(chips).find((c) => c.textContent.trim() === value);
  }

  return chip;
}
function closeGradeLevelChartModal() {
  const modal = document.getElementById("gradeLevelChartModal");
  if (modal) {
    const modalContent = document.getElementById("gradeLevelChartModalContent");
    if (modalContent) {
      modalContent.style.opacity = "0";
    }

    modal.classList.add("closing");

    setTimeout(() => {
      modal.style.display = "none";
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}
function applyGradeFilter(grade) {
  closeLanguageDistributionChartModal();

  closeGradeLevelChartModal();

  applyFilterWithoutModal("grade", grade);
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if (
      typeof window.sheetData === "undefined" &&
      typeof sheetData !== "undefined"
    ) {
      window.sheetData = sheetData;
    }

    if (typeof window.sheetData === "undefined") {
      window.sheetData = [];
    } else if (window.sheetData && window.sheetData.length === 0) {
    } else {
      console.log(`Data ready`);
    }

    syncSubmissionsData();
  }, 1000);
});

function syncSubmissionsData() {
  // The main charts data is in window.Charts which has the _cachedData property
  if (window.Charts && window.Charts._cachedData) {
    // Check if we have submissionsData in the cached data
    if (window.Charts._cachedData.submissionsData) {
      window.Charts.submissionsData = window.Charts._cachedData.submissionsData;
    }
  } else if (window.Charts && window.Charts._fetchPromise) {
    window.Charts._fetchPromise
      .then((data) => {
        if (data && data.submissionsData) {
          window.Charts.submissionsData = data.submissionsData;
        }
      })
      .catch((err) => {
        console.error("23", err);
      });
  } else {
    if (typeof submissionsData !== "undefined" && submissionsData) {
      window.Charts.submissionsData = submissionsData;
    } else if (typeof sheetData !== "undefined" && sheetData) {
    }
  }
}

document.addEventListener("chartsRefreshed", function (e) {
  syncSubmissionsData();
});

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

//  ***********************************************************************************************************************************************************************************
//  ***********************************************************************************************************************************************************************************

function openSentimentByRoleChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("sentimentByRoleChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get sentiment by role data
    let sentimentData = {};
    if (window.Charts && window.Charts.getSentimentByRoleData) {
      sentimentData = window.Charts.getSentimentByRoleData();
    }

    const modalContent = document.getElementById(
      "sentimentByRoleChartModalContent"
    );
    if (modalContent) {
      modalContent.innerHTML = `
        <div class="modal-title-and-x"> 
            <div class="wordcloud-title-wrapper"> 
                <h2 id="sentimentRoleTitle">Sentiment Analysis by Role</h2> 
                <p id="sentimentRoleDescription">Sentiment distribution of every user response.</p>
            </div>
            <div class="action-container"> 
                <div style="margin-right: 15px;"> 
                    <select id="sentimentChartViewOption" 
                        style="padding: 4px 8px; border-radius: 4px; border: 1px solid #ccc; font-size: 0.9em;">
                        <option value="percentage">Percentage View</option>
                        <option value="stacked">Total Count</option>
                    </select>
                </div>
                <div class="wordcloud-tooltip-wrapper"> 
                    <div class="wordcloud-tooltip-container"> 
                        <button id="downloadSentimentByRoleChart" class="download-chart-btn">
                            <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                        </button>
                        <span class="tooltip">Save Chart as Image</span> 
                    </div>
                </div>
                <span class="rolesChartModal-close" onclick="closeSentimentByRoleChartModal()">&times;</span> 
            </div>
        </div>
        <div id="sentimentByRoleChartDetailed" style="width: 100%; height: 400px; margin-top: 15px; transition: opacity 0.3s ease-in-out;"></div>

        <div class="roles-stats" style="margin-top: 20px;"> 
            <div class="modal-title-and-x-2"> 
                <div class="wordcloud-title-wrapper"> 
                    <h3 id="sentimentRoleBreakdownTitle">Sentiment Breakdown</h3> 
                    <p id="sentimentRoleBreakdownDescription">Sentiment analysis of each response, organized by role.</p>
                </div>
                <div class="action-container">
                    <div class="wordcloud-tooltip-wrapper"> 
                        <div class="wordcloud-tooltip-container"> 
                            <button id="downloadSentimentByRoleTable" class="download-chart-btn">
                                <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                            </button>
                            <span class="tooltip">Save Table as CSV</span> 
                        </div>
                        <div class="wordcloud-tooltip-container"> 
                            <button id="downloadSentimentByRoleTablePNG" class="download-chart-btn">
                                <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                            </button>
                            <span class="tooltip">Save Table as Image</span> 
                        </div>
                    </div>
                </div>
            </div>
            <div id="sentimentRoleBreakdown" style="width: 100%; transition: opacity 0.3s ease-in-out;"></div> 
        </div>
      `;

      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for sentiment by role chart");

        document.getElementById("sentimentByRoleChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      renderSentimentByRoleChart("percentage");

      const viewSelector = document.getElementById("sentimentChartViewOption");
      if (viewSelector) {
        viewSelector.addEventListener("change", function () {
          const modalContent = document.getElementById(
            "sentimentByRoleChartModalContent"
          );
          const chartContainer = document.getElementById(
            "sentimentByRoleChartDetailed"
          );

          if (chartContainer) {
            chartContainer.style.opacity = "0";
            chartContainer.style.transition = "opacity 0.45s ease-in-out";
          }

          setTimeout(() => {
            renderSentimentByRoleChart(this.value);

            setTimeout(() => {
              if (chartContainer) {
                chartContainer.style.opacity = "1";
              }
            }, 150);
          }, 450);
        });
      }
    }
  }
}
function switchSentimentView(viewType) {
  console.log(`Switching sentiment view to: ${viewType}`);
  const chartContainer = document.getElementById(
    "sentimentByRoleChartDetailed"
  );
  const breakdownContainer = document.getElementById("sentimentRoleBreakdown"); // Assuming this is the ID

  if (chartContainer) chartContainer.style.opacity = "0";
  if (breakdownContainer) breakdownContainer.style.opacity = "0";

  setTimeout(() => {
    renderSentimentByRoleChart(viewType); // Re-render with new view
  }, 300);
}
function downloadSentimentTableData(format) {
  const breakdownContainer = document.getElementById("sentimentRoleBreakdown");
  const table = breakdownContainer
    ? breakdownContainer.querySelector("table")
    : null;

  if (!table) {
    console.error("Sentiment breakdown table not found for download.");
    alert("Could not find the table data to download.");
    return;
  }

  const timestamp = new Date().toISOString().split("T")[0];
  const filename = `Sentiment_by_Role_Breakdown_${timestamp}`;

  if (format === "csv") {
    let csv = [];
    const title =
      document.getElementById("sentimentRoleBreakdownTitle")?.textContent ||
      "Sentiment Breakdown by Role";
    const description =
      document.getElementById("sentimentRoleBreakdownDescription")
        ?.textContent || "";
    csv.push(`\"${title.replace(/\"/g, '""')}\"`);
    csv.push(`\"${description.replace(/\"/g, '""')}\"`);
    csv.push([]); // Spacer

    const rows = table.querySelectorAll("tr");
    rows.forEach((row) => {
      let rowData = [];
      const cols = row.querySelectorAll("th, td");
      cols.forEach((col) => {
        let cellText = col.innerText.trim();
        cellText = cellText.replace(/\"/g, '""'); // Escape quotes
        rowData.push(`\"${cellText}\"`);
      });
      csv.push(rowData.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else if (format === "png") {
    if (typeof html2canvas === "undefined") {
      console.error("html2canvas library is not loaded.");
      alert("Could not download table as PNG. Required library not found.");
      return;
    }

    const title =
      document.getElementById("sentimentRoleBreakdownTitle")?.textContent ||
      "Sentiment Breakdown by Role";
    const description =
      document.getElementById("sentimentRoleBreakdownDescription")
        ?.textContent || "";

    const renderContainer = document.createElement("div");
    renderContainer.style.padding = "20px";
    renderContainer.style.backgroundColor = "#ffffff";
    renderContainer.style.border = "1px solid #ccc";
    renderContainer.style.display = "inline-block";

    const titleElement = document.createElement("h3");
    titleElement.textContent = title;
    titleElement.style.marginBottom = "5px";
    renderContainer.appendChild(titleElement);

    const descriptionElement = document.createElement("p");
    descriptionElement.textContent = description;
    descriptionElement.style.marginBottom = "15px";
    descriptionElement.style.fontSize = "12px";
    descriptionElement.style.color = "#555";
    renderContainer.appendChild(descriptionElement);

    const tableClone = table.cloneNode(true);
    tableClone.querySelectorAll("a").forEach((a) => {
      a.outerHTML = a.innerHTML;
    });
    renderContainer.appendChild(tableClone);
    document.body.appendChild(renderContainer);

    html2canvas(renderContainer, { scale: 2, useCORS: true, logging: false })
      .then((canvas) => {
        const image = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        const link = document.createElement("a");
        link.setAttribute("download", `${filename}.png`);
        link.setAttribute("href", image);
        link.click();
        document.body.removeChild(renderContainer);
      })
      .catch((error) => {
        console.error("Error generating sentiment table PNG:", error);
        alert("An error occurred while generating the table image.");
        if (document.body.contains(renderContainer)) {
          document.body.removeChild(renderContainer);
        }
      });
  }
}
function closeSentimentByRoleChartModal() {
  const modal = document.getElementById("sentimentByRoleChartModal");
  if (modal) {
    modal.classList.add("closing");

    setTimeout(() => {
      modal.style.display = "none";
      modal.classList.remove("closing");
    }, 600);
  }
}
function renderSentimentByRoleChart(viewType) {
  try {
    if (!window.google || !window.google.visualization) {
      console.error("Google visualization library not available");
      document.getElementById("sentimentByRoleChartDetailed").innerHTML =
        "<p>Chart visualization not available. Please make sure Google Charts is loaded.</p>";
      return;
    }

    const chartContainer = document.getElementById(
      "sentimentByRoleChartDetailed"
    );
    if (chartContainer) {
      chartContainer.style.transition = "opacity 0.45s ease-in-out";
      chartContainer.style.opacity = "0";
    }

    const downloadChartBtn = document.getElementById(
      "downloadSentimentByRoleChart"
    );
    const downloadTableBtn = document.getElementById(
      "downloadSentimentByRoleTable"
    );
    const downloadTablePNGBtn = document.getElementById(
      "downloadSentimentByRoleTablePNG"
    );

    if (downloadChartBtn) {
      const newBtn = downloadChartBtn.cloneNode(true);
      downloadChartBtn.parentNode.replaceChild(newBtn, downloadChartBtn);
    }

    if (downloadTableBtn) {
      const newBtn = downloadTableBtn.cloneNode(true);
      downloadTableBtn.parentNode.replaceChild(newBtn, downloadTableBtn);
    }

    if (downloadTablePNGBtn) {
      const newBtn = downloadTablePNGBtn.cloneNode(true);
      downloadTablePNGBtn.parentNode.replaceChild(newBtn, downloadTablePNGBtn);
    }

    const sentimentData = window.Charts.getSentimentByRoleData();
    if (
      !sentimentData ||
      !sentimentData.roleLabels ||
      sentimentData.roleLabels.length === 0
    ) {
      document.getElementById("sentimentByRoleChartDetailed").innerHTML =
        "<p>No sentiment data available.</p>";
      return;
    }

    const data = new google.visualization.DataTable();
    data.addColumn("string", "Role");
    data.addColumn("number", "Positive");
    data.addColumn("number", "Neutral");
    data.addColumn("number", "Negative");
    data.addColumn("number", "Unknown");

    for (let i = 0; i < sentimentData.roleLabels.length; i++) {
      data.addRow([
        sentimentData.roleLabels[i],
        sentimentData.positive[i],
        sentimentData.neutral[i],
        sentimentData.negative[i],
        sentimentData.unknown[i],
      ]);
    }

    const options = {
      title: "Sentiment Distribution by User Role",
      isStacked: viewType === "stacked" ? true : "percent",
      height: 400,
      legend: { position: "top", maxLines: 3 },
      hAxis: { title: "", titleTextStyle: { color: "#333" } },
      vAxis: {
        title: viewType === "stacked" ? "Count" : "Percentage",
        minValue: 0,
        format: viewType === "percentage" ? "#.#%" : "#",
      },
      colors: ["#54907f", "#ffb703", "#980912", "#c7c7c7"],
    };

    const chart = new google.visualization.ColumnChart(chartContainer);

    google.visualization.events.addListener(chart, "select", function () {
      const selection = chart.getSelection();
      if (selection.length > 0) {
        const selectedItem = selection[0];
        if (selectedItem) {
          const role = data.getValue(selectedItem.row, 0);
          const sentimentIndex = selectedItem.column;
          let sentimentCategory = "";

          switch (sentimentIndex) {
            case 1:
              sentimentCategory = "positive";
              break;
            case 2:
              sentimentCategory = "neutral";
              break;
            case 3:
              sentimentCategory = "negative";
              break;
            case 4:
              sentimentCategory = "unknown";
              break;
          }

          closeSentimentByRoleChartModal();

          if (sentimentCategory) {
            applySentimentAndRoleFilter(sentimentCategory, role);
          } else {
            applyRoleFilter(role);
          }
        }
      }
    });

    chart.draw(data, options);

    createSentimentRoleBreakdownTable(data);

    document
      .getElementById("downloadSentimentByRoleChart")
      .addEventListener("click", function () {
        const chartImageURI = chart.getImageURI();

        const downloadLink = document.createElement("a");
        downloadLink.href = chartImageURI;
        downloadLink.download = `sentiment-by-role-${viewType}-chart.png`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

    document
      .getElementById("downloadSentimentByRoleTable")
      .addEventListener("click", function () {
        const table = document.querySelector("#sentimentRoleBreakdown table");
        if (!table) return;

        let csv = [];
        csv.push([
          `"Sentiment Distribution by Role (${
            viewType === "percentage" ? "Percentage" : "Stacked"
          } View)"`,
        ]);
        csv.push(['"Breakdown of sentiment data organized by role."']);
        csv.push([]);

        const rows = table.querySelectorAll("tr");
        rows.forEach((row) => {
          const cells = row.querySelectorAll("td, th");
          const rowData = Array.from(cells).map((cell) => {
            return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
          });
          csv.push(rowData.join(","));
        });

        const csvContent = csv.join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `sentiment-by-role-${viewType}-table.csv`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });

    document
      .getElementById("downloadSentimentByRoleTablePNG")
      .addEventListener("click", function () {
        const table = document.querySelector("#sentimentRoleBreakdown table");
        if (!table) return;

        const container = document.createElement("div");
        container.style.background = "white";
        container.style.padding = "20px";

        const title = document.createElement("h2");
        title.style.marginBottom = "5px";
        title.textContent = `Sentiment Distribution by Role (${
          viewType === "percentage" ? "Percentage" : "Stacked"
        } View)`;

        const description = document.createElement("p");
        description.style.marginBottom = "20px";
        description.textContent =
          "Breakdown of sentiment data organized by role.";

        // Create a clone of the table
        const tableClone = table.cloneNode(true);

        // Replace all hyperlinks with their text content, but preserve the text
        tableClone.querySelectorAll("a").forEach((link) => {
          const textNode = document.createTextNode(link.textContent);
          const span = document.createElement("span");
          span.style.color = "black";
          span.style.textDecoration = "none";
          span.appendChild(textNode);
          link.parentNode.replaceChild(span, link);
        });

        // Add elements to container in order
        container.appendChild(title);
        container.appendChild(description);
        container.appendChild(tableClone);
        document.body.appendChild(container);

        html2canvas(container).then(function (canvas) {
          // Remove temporary container
          document.body.removeChild(container);

          const link = document.createElement("a");
          link.download = `sentiment-by-role-${viewType}-table.png`;
          link.href = canvas.toDataURL();
          link.click();
        });
      });

    // Fade in the chart container after rendering is complete
    if (chartContainer) {
      setTimeout(() => {
        chartContainer.style.opacity = "1";
      }, 150);
    }
  } catch (e) {
    console.error("Error rendering sentiment by role chart:", e);
    document.getElementById("sentimentByRoleChartDetailed").innerHTML = `
            <div style="color: #721c24; background-color: #f8d7da; padding: 15px; border-radius: 5px;">
                <h3>Error Displaying Chart</h3>
                <p>${e.message}</p>
                <p>Check the console for more details.</p>
            </div>
        `;
  }
}
function createSentimentRoleBreakdownTable(data) {
  const breakdownDiv = document.getElementById("sentimentRoleBreakdown");
  if (!breakdownDiv) return;

  let breakdownHTML = "";
  breakdownHTML +=
    '<table style="width:100%; margin-top:15px; border-collapse: collapse;">';
  breakdownHTML += `
        <tr>
            <th style="text-align:left; padding: 8px; border-bottom: 2px solid #ddd;">Role</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd; color: #54907f;">Positive</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd; color: #ffb703;">Neutral</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd; color: #980912;">Negative</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd; color:rgb(199, 199, 199);">Unknown</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd;">Total</th>
        </tr>
    `;

  // Calculate totals
  let totalPositive = 0;
  let totalNeutral = 0;
  let totalNegative = 0;
  let totalUnknown = 0;
  let grandTotal = 0;

  // Add a row for each role
  for (let i = 0; i < data.getNumberOfRows(); i++) {
    const role = data.getValue(i, 0);
    const positive = data.getValue(i, 1);
    const neutral = data.getValue(i, 2);
    const negative = data.getValue(i, 3);
    const unknown = data.getValue(i, 4);
    const rowTotal = positive + neutral + negative + unknown;

    totalPositive += positive;
    totalNeutral += neutral;
    totalNegative += negative;
    totalUnknown += unknown;
    grandTotal += rowTotal;

    breakdownHTML += `
            <tr>
                <td style="text-align:left; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">${role}</td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">
                    <a href="#" onclick="applySentimentAndRoleFilter('positive', '${role}'); return false;" 
                       style="text-decoration: none; color: ${
                         positive > 0 ? "#54907f" : "#999"
                       };">
                        ${positive} (${((positive / rowTotal) * 100).toFixed(
      1
    )}%)
                    </a>
                </td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">
                    <a href="#" onclick="applySentimentAndRoleFilter('neutral', '${role}'); return false;"
                       style="text-decoration: none; color: ${
                         neutral > 0 ? "#ffb703" : "#999"
                       };">
                        ${neutral} (${((neutral / rowTotal) * 100).toFixed(1)}%)
                    </a>
                </td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">
                    <a href="#" onclick="applySentimentAndRoleFilter('negative', '${role}'); return false;"
                       style="text-decoration: none; color: ${
                         negative > 0 ? "#980912" : "#999"
                       };">
                        ${negative} (${((negative / rowTotal) * 100).toFixed(
      1
    )}%)
                    </a>
                </td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">
                    <a href="#" onclick="applySentimentAndRoleFilter('unknown', '${role}'); return false;"
                       style="text-decoration: none; color: ${
                         unknown > 0 ? "#c7c7c7" : "#999"
                       };">
                        ${unknown} (${((unknown / rowTotal) * 100).toFixed(1)}%)
                    </a>
                </td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                    <a href="#" onclick="applySentimentAndRoleFilter('${role}'); return false;"
                       style="text-decoration: none; color: #007bff;">
                        ${rowTotal}
                    </a>
                </td>
            </tr>
        `;
  }

  // Add a totals row
  breakdownHTML += `
        <tr style="background-color: #f5f5f5;">
            <td style="text-align:left; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">Total</td>
            <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                <a href="#" onclick="applySentimentFilter('positive'); return false;"
                   style="text-decoration: none; color: #54907f;">
                    ${totalPositive} (${(
    (totalPositive / grandTotal) *
    100
  ).toFixed(1)}%)
                </a>
            </td>
            <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                <a href="#" onclick="applySentimentFilter('neutral'); return false;"
                   style="text-decoration: none; color: #ffb703;">
                    ${totalNeutral} (${(
    (totalNeutral / grandTotal) *
    100
  ).toFixed(1)}%)
                </a>
            </td>
            <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                <a href="#" onclick="applySentimentFilter('negative'); return false;"
                   style="text-decoration: none; color: #980912;">
                    ${totalNegative} (${(
    (totalNegative / grandTotal) *
    100
  ).toFixed(1)}%)
                </a>
            </td>
            <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                <a href="#" onclick="applySentimentFilter('unknown'); return false;"
                   style="text-decoration: none; color: #c7c7c7;">
                    ${totalUnknown} (${(
    (totalUnknown / grandTotal) *
    100
  ).toFixed(1)}%)
                </a>
            </td>
            <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">
                ${grandTotal}
            </td>
        </tr>
    `;

  breakdownHTML += "</table>";
  breakdownDiv.innerHTML = breakdownHTML;
}
function applySentimentFilter(sentiment) {
  // First, close any open modals
  closeSentimentChartModal();
  closeSentimentByRoleChartModal();
  closeSentimentBySchoolChartModal();
  // Small delay to ensure the modal is closed before proceeding
  setTimeout(() => {
    // Close the filter modal if it's open
    const filterModal = document.querySelector(".filter-modal");

    if (filterModal && filterModal.style.display !== "none") {
      filterModal.style.display = "none";
      filterModal.style.opacity = "0";
    }
  }, 100);

  // Use the common filter function
  applyFilterWithoutModal("sentiment", sentiment);
}
function applySentimentAndRoleFilter(sentiment, role) {
  // First, close the modal
  closeSentimentByRoleChartModal();

  // Handle case where function is called with just one parameter (role)
  // This happens when clicking the row total in the breakdown table
  if (role === undefined && sentiment) {
    role = sentiment;
    sentiment = null;
  }

  // Find all sentiment and role chips
  const sentimentChips = document.querySelectorAll(".sentiment-chip");
  const roleChips = document.querySelectorAll(".role-chip");

  if (sentimentChips.length > 0 && roleChips.length > 0) {
    // Clear all filters first
    const clearAllFiltersBtn = document.querySelector(
      ".clear-all-filters-chip"
    );
    if (clearAllFiltersBtn) {
      clearAllFiltersBtn.click();
    }

    // Short delay to allow filter clearing to complete
    setTimeout(() => {
      // Double-check that all other filters are inactive
      document
        .querySelectorAll(
          ".grade-chip, .language-chip, .method-chip, .question-chip, .school-chip"
        )
        .forEach((chip) => {
          if (
            chip.classList.contains("active") &&
            chip.getAttribute("data-grade") !== "all" &&
            chip.getAttribute("data-language") !== "all" &&
            chip.getAttribute("data-method") !== "all" &&
            chip.getAttribute("data-question") !== "all" &&
            chip.getAttribute("data-school") !== "all"
          ) {
            chip.classList.remove("active");
          }
        });

      // Now make sure all default "all" filters (except role and sentiment) are active
      document
        .querySelectorAll(
          '.grade-chip[data-grade="all"], .language-chip[data-language="all"], .method-chip[data-method="all"], .question-chip[data-question="all"], .school-chip[data-school="all"]'
        )
        .forEach((chip) => {
          chip.classList.add("active");
        });

      // Deactivate all sentiment and role chips
      sentimentChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      roleChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });

      // Find and activate the sentiment chip if sentiment is provided
      let sentimentLower = "";
      if (sentiment && typeof sentiment === "string") {
        sentimentLower = sentiment.toLowerCase();
        const targetSentimentChip = document.querySelector(
          `.sentiment-chip[data-sentiment="${sentimentLower}"]`
        );
        if (targetSentimentChip) {
          targetSentimentChip.classList.add("active");
        }
      } else {
        // If no sentiment specified, use the "all" sentiment chip
        const allSentimentChip = document.querySelector(
          '.sentiment-chip[data-sentiment="all"]'
        );
        if (allSentimentChip) {
          allSentimentChip.classList.add("active");
        }
      }

      // Find and activate the role chip
      let targetRoleChip = findFilterChip(roleChips, role, "data-role");
      if (targetRoleChip) {
        targetRoleChip.classList.add("active");
      }

      // Create a custom filter object that includes ONLY sentiment and role filters
      const customFilters = {
        sentiments: sentimentLower ? [sentimentLower] : [],
        roles: [role],
        grades: [],
        languages: [],
        methods: [],
        questions: [],
        schools: [],
        sortOrder:
          typeof currentSortOrder !== "undefined" ? currentSortOrder : "newest",
      };

      // Apply the filter directly to avoid the issue with getDefaultFilters
      if (typeof window.displayResponses === "function" && window.sheetData) {
        window.displayResponses(window.sheetData, customFilters);
      } else if (typeof updateDisplay === "function") {
        updateDisplay();
      }

      const filterModal = document.querySelector(".filter-modal");

      if (filterModal && filterModal.style.display !== "none") {
        filterModal.style.display = "none";
        filterModal.style.opacity = "0";
      }

      // Update the UI to indicate filtering
      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
      }

      // Scroll to the responses section
      setTimeout(() => {
        const responsesSection = document.getElementById("d");
        if (responsesSection) {
          responsesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
    }, 100);
  } else {
    console.warn("Sentiment or role filter chips not found in the document");
  }
}

// ***********************************************************
// ***********************************************************
// ***********************************************************

function openSentimentBySchoolChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("sentimentBySchoolChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get sentiment by school data (optional, depending if needed immediately)
    // let sentimentData = {};
    // if (window.Charts && window.Charts.getSentimentBySchoolData) {
    //     sentimentData = window.Charts.getSentimentBySchoolData();
    // }

    const modalContent = document.getElementById(
      "sentimentBySchoolChartModalContent"
    );
    if (modalContent) {
      // --- MODIFIED: Apply consistent modal structure (similar to Role/Grade modals) ---
      modalContent.innerHTML = `
                <div class="modal-title-and-x"> 
                    <div class="wordcloud-title-wrapper"> 
                        <h2 id="sentimentSchoolTitle">Sentiment Analysis by School</h2> 
                        <p id="sentimentSchoolDescription">Sentiment distribution of every user response.</p>
                    </div>
                    <div class="action-container"> 
                        <div style="margin-right: 15px;"> 
                            <select id="sentimentSchoolChartViewOption" onchange="switchSentimentSchoolView(this.value)" 
                                style="padding: 4px 8px; border-radius: 4px; border: 1px solid #ccc; font-size: 0.9em;">
                                <option value="percentage">Percentage View</option>
                                <option value="stacked">Total Count</option>
                            </select>
                        </div>
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadSentimentSchoolChartPNG" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeSentimentBySchoolChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="sentimentBySchoolChartDetailed" style="width: 100%; height: 400px; margin-top: 15px; transition: opacity 0.3s ease-in-out;"></div>

                <div class="roles-stats" style="margin-top: 20px;"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3 id="sentimentSchoolBreakdownTitle">Detailed Sentiment Breakdown</h3> 
                            <p id="sentimentSchoolBreakdownDescription">Sentiment analysis of each response, organized by school.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSentimentSchoolTableCSV" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSentimentSchoolTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="sentimentSchoolBreakdown" style="width: 100%; transition: opacity 0.3s ease-in-out;"></div> 
                </div>
            `;
      // --- END MODIFIED ---

      // Debug the data source (keep existing check)
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for sentiment by school chart");
        document.getElementById("sentimentBySchoolChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        // Ensure the breakdown area is also cleared or shows a message
        const breakdownContainer = document.getElementById(
          "sentimentSchoolBreakdown"
        );
        if (breakdownContainer) breakdownContainer.innerHTML = "";
        // Fade in the modal content to show the error message
        modalContent.style.opacity = "1";
        return;
      }

      // Initialize with percentage view by default
      renderSentimentBySchoolChart("percentage");

      // Add event listener for view option change (using a dedicated function)
      const viewSelector = document.getElementById(
        "sentimentSchoolChartViewOption"
      );
      if (viewSelector) {
        // Use switchSentimentSchoolView function defined below
        viewSelector.removeEventListener("change", switchSentimentSchoolView); // Remove if existing
        viewSelector.addEventListener("change", function () {
          switchSentimentSchoolView(this.value);
        });
      }

      // --- ADDED: Event listeners for table downloads ---
      const downloadTableCSVButton = document.getElementById(
        "downloadSentimentSchoolTableCSV"
      );
      const downloadTablePNGButton = document.getElementById(
        "downloadSentimentSchoolTablePNG"
      );

      if (downloadTableCSVButton) {
        // Clone and replace to ensure clean listeners
        const newBtn = downloadTableCSVButton.cloneNode(true);
        downloadTableCSVButton.parentNode.replaceChild(
          newBtn,
          downloadTableCSVButton
        );
        newBtn.addEventListener("click", () =>
          downloadSentimentSchoolTableData("csv")
        );
      }
      if (downloadTablePNGButton) {
        // Clone and replace to ensure clean listeners
        const newBtn = downloadTablePNGButton.cloneNode(true);
        downloadTablePNGButton.parentNode.replaceChild(
          newBtn,
          downloadTablePNGButton
        );
        newBtn.addEventListener("click", () =>
          downloadSentimentSchoolTableData("png")
        );
      }
      // Chart download listener will be attached within renderSentimentBySchoolChart
      // --- END ADDED ---

      // Fade in modal content
      setTimeout(() => {
        modalContent.style.opacity = "1";
      }, 150);
    }
  }
}
// --- ADDED: Helper function for view switching (similar to sentiment by role) ---
function switchSentimentSchoolView(viewType) {
  const chartContainer = document.getElementById(
    "sentimentBySchoolChartDetailed"
  );
  const breakdownContainer = document.getElementById(
    "sentimentSchoolBreakdown"
  );

  // Fade out content
  if (chartContainer) chartContainer.style.opacity = "0";
  if (breakdownContainer) breakdownContainer.style.opacity = "0";

  // Use a short delay for the fade-out effect
  setTimeout(() => {
    renderSentimentBySchoolChart(viewType); // Re-render with new view
    // Fade-in is handled within renderSentimentBySchoolChart
  }, 300);
}
// --- ADDED: Helper function for downloading sentiment by school table data ---
function downloadSentimentSchoolTableData(format) {
  const breakdownContainer = document.getElementById(
    "sentimentSchoolBreakdown"
  );
  const table = breakdownContainer
    ? breakdownContainer.querySelector("table")
    : null;

  if (!table) {
    console.error(
      "Sentiment by school breakdown table not found for download."
    );
    alert("Could not find the table data to download.");
    return;
  }

  const timestamp = new Date().toISOString().split("T")[0];
  const filename = `Sentiment_by_School_Breakdown_${timestamp}`;

  // Get title and description from the modal structure
  const title =
    document.getElementById("sentimentSchoolBreakdownTitle")?.textContent ||
    "Sentiment Breakdown by School";
  const description =
    document.getElementById("sentimentSchoolBreakdownDescription")
      ?.textContent || "";

  if (format === "csv") {
    let csv = [];
    csv.push(`\"${title.replace(/\"/g, '""')}\"`); // Add title
    csv.push(`\"${description.replace(/\"/g, '""')}\"`); // Add description
    csv.push([]); // Spacer row

    const rows = table.querySelectorAll("tr");
    rows.forEach((row) => {
      let rowData = [];
      const cols = row.querySelectorAll("th, td");
      cols.forEach((col) => {
        // Extract text, handling potential links or other elements inside cells
        let cellText = col.innerText.trim();
        // Clean quotes and commas (basic cleaning)
        cellText = cellText.replace(/"/g, '""');
        // Remove commas from numbers if needed (optional, depends on locale needs)
        // cellText = cellText.replace(/,/g, '');
        rowData.push(`\"${cellText}\"`);
      });
      csv.push(rowData.join(","));
    });

    const csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else if (format === "png") {
    if (typeof html2canvas === "undefined") {
      console.error("html2canvas library is not loaded.");
      alert("Could not download table as PNG. Required library not found.");
      return;
    }

    // Create a temporary container for rendering with consistent styling
    const renderContainer = document.createElement("div");
    renderContainer.style.padding = "20px";
    renderContainer.style.backgroundColor = "#ffffff"; // White background
    renderContainer.style.border = "1px solid #ccc";
    renderContainer.style.display = "inline-block"; // Fit content
    renderContainer.style.fontFamily = "Arial, sans-serif"; // Consistent font

    // Add Title
    const titleElement = document.createElement("h3");
    titleElement.textContent = title;
    titleElement.style.marginBottom = "5px";
    titleElement.style.fontSize = "18px"; // Match modal style if needed
    renderContainer.appendChild(titleElement);

    // Add Description
    const descriptionElement = document.createElement("p");
    descriptionElement.textContent = description;
    descriptionElement.style.marginBottom = "15px";
    descriptionElement.style.fontSize = "14px"; // Match modal style if needed
    descriptionElement.style.color = "#555";
    renderContainer.appendChild(descriptionElement);

    // Clone the table to avoid modifying the original and remove links for cleaner image
    const tableClone = table.cloneNode(true);
    tableClone.querySelectorAll("a").forEach((a) => {
      // Replace link with its text content for the image
      if (a.textContent) {
        a.outerHTML = a.textContent;
      } else {
        a.remove(); // Remove empty links
      }
    });
    renderContainer.appendChild(tableClone);

    // Append to body temporarily for rendering
    document.body.appendChild(renderContainer);

    html2canvas(renderContainer, {
      scale: 2, // Increase scale for better resolution
      useCORS: true,
      logging: false, // Suppress html2canvas logging in console
    })
      .then((canvas) => {
        const image = canvas
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream"); // Suggest download
        const link = document.createElement("a");
        link.setAttribute("download", `${filename}.png`);
        link.setAttribute("href", image);
        document.body.appendChild(link); // Append before click for Firefox compatibility
        link.click();
        document.body.removeChild(link); // Remove link after click

        // Clean up the temporary container
        document.body.removeChild(renderContainer);
      })
      .catch((error) => {
        console.error("Error generating sentiment by school table PNG:", error);
        alert("An error occurred while generating the table image.");
        // Clean up the temporary container even if there's an error
        if (document.body.contains(renderContainer)) {
          document.body.removeChild(renderContainer);
        }
      });
  }
}
// --- END ADDED helpers ---
function closeSentimentBySchoolChartModal() {
  // ... (keep existing implementation) ...
  const modal = document.getElementById("sentimentBySchoolChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}
// Function to render the sentiment by school chart based on selected view
function renderSentimentBySchoolChart(viewType) {
  const chartContainer = document.getElementById(
    "sentimentBySchoolChartDetailed"
  );
  const breakdownContainer = document.getElementById(
    "sentimentSchoolBreakdown"
  ); // Container for the table
  const modalContent = document.getElementById(
    "sentimentBySchoolChartModalContent"
  ); // Get modal content for opacity

  try {
    if (!window.google || !window.google.visualization) {
      console.error("Google visualization library not available");
      if (chartContainer)
        chartContainer.innerHTML = "<p>Chart visualization not available.</p>";
      if (breakdownContainer) breakdownContainer.innerHTML = ""; // Clear breakdown too
      // Fade in the modal content to show the error
      if (modalContent) modalContent.style.opacity = "1";
      return;
    }

    // --- MODIFIED: Update Titles/Descriptions Dynamically ---
    const titleElement = document.getElementById("sentimentSchoolTitle");
    const descriptionElement = document.getElementById(
      "sentimentSchoolDescription"
    );
    const breakdownTitleElement = document.getElementById(
      "sentimentSchoolBreakdownTitle"
    );
    const breakdownDescriptionElement = document.getElementById(
      "sentimentSchoolBreakdownDescription"
    );

    if (viewType === "percentage") {
      if (titleElement)
        titleElement.textContent = "Sentiment Analysis by School";
      if (descriptionElement)
        descriptionElement.textContent =
          "Percentage distribution of sentiment across all schools.";
      if (breakdownTitleElement)
        breakdownTitleElement.textContent = "Sentiment Distribution";
      if (breakdownDescriptionElement)
        breakdownDescriptionElement.textContent =
          "Sentiment analysis of each response, organized by school.";
    } else {
      // stacked view
      if (titleElement)
        titleElement.textContent = "Sentiment Analysis by School";
      if (descriptionElement)
        descriptionElement.textContent =
          "Total count of sentiment scores across all schools.";
      if (breakdownTitleElement)
        breakdownTitleElement.textContent = "Sentiment Distribution";
      if (breakdownDescriptionElement)
        breakdownDescriptionElement.textContent =
          "Sentiment analysis of each response, organized by school.";
    }
    // --- END MODIFIED Titles/Descriptions ---

    // Set chart container and breakdown to initial opacity 0 (will be faded in after rendering)
    if (chartContainer) {
      chartContainer.style.transition = "opacity 0.45s ease-in-out";
      chartContainer.style.opacity = "0";
    }
    if (breakdownContainer) {
      breakdownContainer.style.transition = "opacity 0.45s ease-in-out";
      breakdownContainer.style.opacity = "0";
    }

    // Get the chart data
    const sentimentData = window.Charts.getSentimentBySchoolData();
    if (
      !sentimentData ||
      !sentimentData.schoolLabels ||
      sentimentData.schoolLabels.length === 0
    ) {
      if (chartContainer)
        chartContainer.innerHTML = "<p>No school sentiment data available.</p>";
      if (breakdownContainer) breakdownContainer.innerHTML = ""; // Clear breakdown too
      // Fade in containers to show message
      setTimeout(() => {
        if (chartContainer) chartContainer.style.opacity = "1";
        if (breakdownContainer) breakdownContainer.style.opacity = "1";
      }, 150);
      return;
    }

    // Create a DataTable
    const data = new google.visualization.DataTable();
    data.addColumn("string", "School");
    data.addColumn("number", "Positive");
    data.addColumn("number", "Neutral");
    data.addColumn("number", "Negative");
    data.addColumn("number", "Unknown");

    // Add rows, excluding School District
    for (let i = 0; i < sentimentData.schoolLabels.length; i++) {
      // Skip School District (case insensitive)
      if (
        sentimentData.schoolLabels[i] &&
        !sentimentData.schoolLabels[i].toUpperCase().includes("SCHOOL DISTRICT")
      ) {
        data.addRow([
          sentimentData.schoolLabels[i],
          sentimentData.positive[i] || 0, // Default to 0 if undefined
          sentimentData.neutral[i] || 0,
          sentimentData.negative[i] || 0,
          sentimentData.unknown[i] || 0,
        ]);
      }
    }

    // If no data left after filtering, show a message
    if (data.getNumberOfRows() === 0) {
      if (chartContainer)
        chartContainer.innerHTML =
          '<p>No data available after filtering out "School District".</p>';
      if (breakdownContainer) breakdownContainer.innerHTML = ""; // Clear breakdown too
      // Fade in containers to show message
      setTimeout(() => {
        if (chartContainer) chartContainer.style.opacity = "1";
        if (breakdownContainer) breakdownContainer.style.opacity = "1";
      }, 150);
      return;
    }

    const options = {
      isStacked: viewType === "stacked" ? true : "percent",
      // title: viewType === 'stacked' ? 'Sentiment Scores by School' : 'Sentiment Percentage by School', // Title now handled above
      title: "", // Set title to empty as it's handled by the h2 element
      height: 400,
      legend: { position: "top", maxLines: 3 },
      chartArea: { width: "90%", height: "75%" }, // Adjust chart area
      hAxis: {
        title: "", // Remove axis title, schools are clear
        slantedText: data.getNumberOfRows() > 10, // Slant labels if many schools
        slantedTextAngle: data.getNumberOfRows() > 10 ? 30 : 0,
      },
      vAxis: {
        title: viewType === "stacked" ? "Individual Answers" : "",
        minValue: 0,
        // maxValue: viewType === 'percentage' ? 1 : undefined, // Ensure percentage axis goes to 1 (100%)
        format: viewType === "percentage" ? "percent" : "decimal", // Use 'percent' format for vAxis
      },
      colors: ["#54907f", "#ffb703", "#980912", "#D3D3D3"], // Consistent colors
    };

    const chart = new google.visualization.ColumnChart(chartContainer);

    google.visualization.events.addListener(chart, "select", function () {
      // ... (selection logic remains the same) ...
      const selection = chart.getSelection();
      if (selection.length > 0) {
        const selectedItem = selection[0];
        if (selectedItem) {
          const school = data.getValue(selectedItem.row, 0);
          const sentimentIndex = selectedItem.column;
          let sentimentCategory = "";

          switch (sentimentIndex) {
            case 1:
              sentimentCategory = "positive";
              break;
            case 2:
              sentimentCategory = "neutral";
              break;
            case 3:
              sentimentCategory = "negative";
              break;
            case 4:
              sentimentCategory = "unknown";
              break;
            default: // Clicked on the school label itself?
              applySchoolFilter(school);
              return;
          }

          closeSentimentBySchoolChartModal();

          // Apply both filters
          if (sentimentCategory) {
            applySentimentAndSchoolFilter(sentimentCategory, school);
          }
          // else handled above
        }
      }
    });

    chart.draw(data, options);

    // --- ADDED: Attach chart download listener directly ---
    const downloadChartPNGButton = document.getElementById(
      "downloadSentimentSchoolChartPNG"
    );
    if (downloadChartPNGButton) {
      // Clone and replace to ensure clean listeners, especially when switching views
      const newDownloadChartPNGButton = downloadChartPNGButton.cloneNode(true);
      downloadChartPNGButton.parentNode.replaceChild(
        newDownloadChartPNGButton,
        downloadChartPNGButton
      );

      newDownloadChartPNGButton.addEventListener("click", function () {
        if (chart && typeof chart.getImageURI === "function") {
          try {
            const chartImageURI = chart.getImageURI();
            const link = document.createElement("a");
            link.href = chartImageURI;
            link.download = `sentiment-by-school-${viewType}-chart.png`; // Dynamic filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (e) {
            console.error(
              "Error getting sentiment by school chart image URI:",
              e
            );
            alert("Failed to download chart image.");
          }
        } else {
          console.warn(
            "Sentiment by school chart object not ready for download click."
          );
          alert("Chart may still be rendering. Please try again.");
        }
      });
    }

    createSentimentSchoolBreakdownTable(data);

    setTimeout(() => {
      if (chartContainer) chartContainer.style.opacity = "1";
      if (breakdownContainer) breakdownContainer.style.opacity = "1";
      if (modalContent && modalContent.style.opacity === "0") {
        modalContent.style.opacity = "1";
      }
    }, 150);
  } catch (e) {
    console.error("Error rendering sentiment by school chart:", e);
    if (chartContainer) {
      chartContainer.innerHTML = `
                <div style="color: #721c24; background-color: #f8d7da; padding: 15px; border-radius: 5px;">
                    <h3>Error Displaying Chart</h3>
                    <p>${e.message}</p>
                </div>
            `;
    }
    if (breakdownContainer) breakdownContainer.innerHTML = "";

    if (modalContent) modalContent.style.opacity = "1";
    if (chartContainer) chartContainer.style.opacity = "1";
    if (breakdownContainer) breakdownContainer.style.opacity = "1";
  }
}
function createSentimentSchoolBreakdownTable(data) {
  const breakdownDiv = document.getElementById("sentimentSchoolBreakdown");
  if (!breakdownDiv) return;

  let breakdownHTML =
    '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">';
  breakdownHTML +=
    '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">';

  breakdownHTML +=
    '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">';
  breakdownHTML +=
    '<th style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #ddd;">School</th>';
  const sentimentLabels = ["Positive", "Neutral", "Negative", "Unknown"]; // Column labels from DataTable
  const sentimentColors = ["#54907f", "#ffb703", "#980912", "#888"]; // Matching colors
  const sentimentKeys = ["positive", "neutral", "negative", "unknown"]; // Keys for filter function

  for (let j = 0; j < sentimentLabels.length; j++) {
    breakdownHTML += `<th style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #ddd; color: ${sentimentColors[j]};">${sentimentLabels[j]}</th>`;
  }
  breakdownHTML +=
    '<th style="text-align:center; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #ddd;">Total</th>';
  breakdownHTML += "</tr></thead>";

  breakdownHTML += "<tbody>";
  let grandTotals = new Array(data.getNumberOfColumns()).fill(0);
  let grandRowTotal = 0;

  for (let i = 0; i < data.getNumberOfRows(); i++) {
    const school = data.getValue(i, 0);
    let rowValues = [];
    let rowTotal = 0;
    for (let j = 1; j < data.getNumberOfColumns(); j++) {
      const count = data.getValue(i, j);
      rowValues.push(count);
      rowTotal += count;
      grandTotals[j] += count;
    }
    grandRowTotal += rowTotal;

    // Alternating row color XXXXXXXXXXXXXXX TABLE BREAKDOWN
    breakdownHTML += `<tr style="background-color: ${
      i % 2 === 0 ? "#fff" : "#f9f9f9"
    };">
            <td style="text-align:left; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #eee;">${school}</td>`;

    for (let j = 0; j < sentimentLabels.length; j++) {
      const count = rowValues[j];
      const percentage =
        rowTotal > 0 ? ((count / rowTotal) * 100).toFixed(1) : "0.0";
      const sentimentKey = sentimentKeys[j];
      const color = count > 0 ? sentimentColors[j] : "#999"; // Dim color if count is 0

      // Display count and percentage, link to combined filter. Align right.
      breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                <a href="#" onclick="applySentimentAndSchoolFilter('${sentimentKey}', '${school.replace(
        /'/g,
        "\\'"
      )}'); return false;"
                   style="text-decoration: none; color: ${color}; display: block; width: 100%; height: 100%;">
                    ${count.toLocaleString()} (${percentage}%)
                </a>
            </td>`;
    }
    // Row Total Column - Link to filter by school only. Align right.
    breakdownHTML += `<td style="text-align:center; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #eee;">
            <a href="#" onclick="applySchoolFilter('${school.replace(
              /'/g,
              "\\'"
            )}'); return false;"
                style="text-decoration: none; color: #0056b3; display: block; width: 100%; height: 100%;">
                ${rowTotal.toLocaleString()}
            </a>
        </td>`;
    breakdownHTML += `</tr>`;
  }
  breakdownHTML += "</tbody>";

  // Footer Row (Totals) - Link to filter by sentiment only. Align right.
  breakdownHTML +=
    '<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>';
  breakdownHTML +=
    '<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>';
  for (let j = 1; j < data.getNumberOfColumns(); j++) {
    // Start from 1 to skip school column
    const totalCount = grandTotals[j];
    const percentage =
      grandRowTotal > 0
        ? ((totalCount / grandRowTotal) * 100).toFixed(1)
        : "0.0";
    const sentimentKey = sentimentKeys[j - 1]; // Adjust index for sentimentKeys array
    const color = totalCount > 0 ? sentimentColors[j - 1] : "#999";

    breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">
            <a href="#" onclick="applySentimentFilter('${sentimentKey}'); return false;"
               style="text-decoration: none; color: ${color}; display: block; width: 100%; height: 100%;">
                 ${totalCount.toLocaleString()} (${percentage}%)
            </a>
        </td>`;
  }
  // Grand Total Cell - Align right.
  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${grandRowTotal.toLocaleString()}</td>`;
  breakdownHTML += "</tr></tfoot>";

  breakdownHTML += "</table></div>"; // Close container div
  breakdownDiv.innerHTML = breakdownHTML;
  // --- END MODIFIED ---
}
// Assuming a function like this exists:
function applySchoolFilter(school) {
  // Add this line to close the language distribution modal
  //closeLanguageDistributionChartModal(); // Example if needed

  // First, close the relevant modal
  closeSentimentBySchoolChartModal();

  // Use the common filter function
  applyFilterWithoutModal("school", school);
}
// Function to apply both sentiment and school filters simultaneously
function applySentimentAndSchoolFilter(sentiment, school) {
  // ... (keep existing implementation - it should work with the new structure) ...
  // First, close the modal
  closeSentimentBySchoolChartModal();

  // Handle case where function is called with just one parameter (school)
  // This happens when clicking the row total in the breakdown table - NOW HANDLED by applySchoolFilter
  // if (school === undefined && sentiment) {
  //     school = sentiment;
  //     sentiment = null;
  // }

  const sentimentChips = document.querySelectorAll(".sentiment-chip");
  const schoolChips = document.querySelectorAll(".school-chip");

  if (sentimentChips.length > 0 && schoolChips.length > 0) {
    const clearAllFiltersBtn = document.querySelector(
      ".clear-all-filters-chip"
    );
    if (clearAllFiltersBtn) {
      clearAllFiltersBtn.click();
    }

    setTimeout(() => {
      document
        .querySelectorAll(
          ".role-chip, .grade-chip, .language-chip, .method-chip, .question-chip"
        )
        .forEach((chip) => {
          if (
            chip.classList.contains("active") &&
            (!chip.dataset.role || chip.dataset.role !== "all") &&
            (!chip.dataset.grade || chip.dataset.grade !== "all") &&
            (!chip.dataset.language || chip.dataset.language !== "all") &&
            (!chip.dataset.method || chip.dataset.method !== "all") &&
            (!chip.dataset.question || chip.dataset.question !== "all")
          ) {
            chip.classList.remove("active");
          }
        });

      document
        .querySelectorAll(
          '.role-chip[data-role="all"], .grade-chip[data-grade="all"], .language-chip[data-language="all"], .method-chip[data-method="all"], .question-chip[data-question="all"]'
        )
        .forEach((chip) => {
          chip.classList.add("active");
        });

      sentimentChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      schoolChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });

      let sentimentLower = "";
      if (sentiment && typeof sentiment === "string") {
        sentimentLower = sentiment.toLowerCase();
        const targetSentimentChip = document.querySelector(
          `.sentiment-chip[data-sentiment="${sentimentLower}"]`
        );
        if (targetSentimentChip) {
          targetSentimentChip.classList.add("active");
        }
      } else {
        // If no sentiment specified, activate the "all" sentiment chip
        const allSentimentChip = document.querySelector(
          '.sentiment-chip[data-sentiment="all"]'
        );
        if (allSentimentChip) {
          allSentimentChip.classList.add("active");
        }
      }

      let targetSchoolChip = findFilterChip(schoolChips, school, "data-school"); // Use helper
      if (targetSchoolChip) {
        targetSchoolChip.classList.add("active");
      } else {
        console.warn(`School chip not found for: ${school}`);
        // Activate 'all' school chip as fallback
        const allSchoolChip = document.querySelector(
          '.school-chip[data-school="all"]'
        );
        if (allSchoolChip) allSchoolChip.classList.add("active");
      }

      if (typeof updateDisplay === "function") {
        updateDisplay();
      } else {
        console.error("updateDisplay function not found.");
      }

      const filterModalElement = document.getElementById("filterModal");
      if (filterModalElement && filterModalElement.style.display !== "none") {
        filterModalElement.style.display = "none";
      }

      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
      }

      setTimeout(() => {
        const responsesSection = document.getElementById("d");
        if (responsesSection) {
          responsesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
    }, 150);
  } else {
    console.warn("Sentiment or school filter chips not found in the document");
  }
}
function findFilterChip(chips, value, attribute) {
  let chip = Array.from(chips).find((c) => c.getAttribute(attribute) === value);

  if (!chip) {
    chip = Array.from(chips).find((c) => {
      const attrValue = c.getAttribute(attribute);
      return attrValue && attrValue.toLowerCase() === value.toLowerCase();
    });
  }

  if (!chip) {
    chip = Array.from(chips).find(
      (c) => c.textContent.trim().toLowerCase() === value.toLowerCase()
    );
  }

  // Special case for "None" or empty values if needed - depends on data
  // if (!chip && (value === null || value === "" || value.toLowerCase() === 'none')) {
  //     chip = Array.from(chips).find(c => c.getAttribute(attribute) === 'none' || c.getAttribute(attribute) === '');
  // }

  return chip;
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

//OPEN METHOD CHART MODAL
function openMethodChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("methodChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get method data from the existing chart if possible
    let methodData = [];
    if (window.Charts && window.Charts.getMethodData) {
      methodData = window.Charts.getMethodData();
    }

    const modalContent = document.getElementById("methodChartModalContent");
    if (modalContent) {
      // --- MODIFIED: Match openWordCloudChartModal structure/styles ---
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper">
                        <h2>Submission Method Analysis</h2>
                        <p>Total unique users by submission method.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper">
                            <div class="wordcloud-tooltip-container">
                                <button id="downloadMethodChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span>
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeMethodChartModal()">&times;</span>
                    </div>
                </div>
                <div id="methodChartDetailed" style="width: 100%; height: 400px;"></div>

                <div class="roles-stats">
                    <div class="modal-title-and-x-2">
                        <div class="wordcloud-title-wrapper">
                            <h3>Unique Users by Role and Method</h3>
                            <p>Table view breaking down unique users by role for each method.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper">
                                <div class="wordcloud-tooltip-container">
                                    <button id="downloadMethodTable" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span>
                                </div>
                                <div class="wordcloud-tooltip-container">
                                    <button id="downloadMethodTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span>
                                </div>
                                <span class="rolesChartModal-close" onclick="closeMethodChartModal()">&times;</span>
                            </div>
                        </div>
                    </div>
                    <div id="methodBreakdown"></div>
                </div>
            `;

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for method chart");
        document.getElementById("methodChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        // Ensure breakdown is also cleared
        const methodBreakdownDiv = document.getElementById("methodBreakdown");
        if (methodBreakdownDiv) methodBreakdownDiv.innerHTML = "";
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          // --- NEW/MODIFIED: Start Data Aggregation by Method and Role ---

          const usersByMethodAndRole = new Map(); // Map: method -> Map(role -> Set<userId>)
          const allRoles = new Set(); // Keep track of all encountered roles
          const allMethods = new Set(); // Keep track of all encountered methods

          if (window.sheetData && window.sheetData.length > 0) {
            window.sheetData.forEach((item, index) => {
              const method = item?.method?.trim();
              const userId = item?.user_id;
              const role = item?.role?.trim() || "Unknown"; // Default if missing

              if (!method || !userId) return;

              allRoles.add(role);
              allMethods.add(method);

              if (!usersByMethodAndRole.has(method)) {
                usersByMethodAndRole.set(method, new Map());
              }
              const methodMap = usersByMethodAndRole.get(method);
              if (!methodMap.has(role)) {
                methodMap.set(role, new Set());
              }
              methodMap.get(role).add(userId);
            });
          } else {
            console.log("No sheetData found for method/role processing.");
          }
          const sortedRoles = Array.from(allRoles).sort();

          const totalUniqueUsersPerMethod = new Map();
          const overallUniqueUsers = new Set();

          usersByMethodAndRole.forEach((roleMap, method) => {
            const uniqueUsersForThisMethod = new Set();
            roleMap.forEach((userSet, role) => {
              userSet.forEach((userId) => {
                uniqueUsersForThisMethod.add(userId);
                overallUniqueUsers.add(userId);
              });
            });
            totalUniqueUsersPerMethod.set(
              method,
              uniqueUsersForThisMethod.size
            );
          });
          const overallTotalUniqueUsers = overallUniqueUsers.size;

          const methodNameMapping = {
            type: "Typed Online",
            sms: "SMS / Text",
            chat: "Chatbot",
            voice: "Voice Recording",
            phone: "AI Phone Call",
          };
          const originalMethodNames = new Map();
          function toTitleCase(str) {
            if (!str) return "";
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          }

          const chartData = new google.visualization.DataTable();
          chartData.addColumn("string", "Method");
          chartData.addColumn("number", "Total Unique Users"); // Column for chart

          totalUniqueUsersPerMethod.forEach((count, originalMethod) => {
            const displayMethod =
              methodNameMapping[originalMethod.toLowerCase()] ||
              toTitleCase(originalMethod);
            originalMethodNames.set(displayMethod, originalMethod);
            if (count > 0) {
              chartData.addRow([displayMethod, count]);
            }
          });

          const options = {
            title: "Submission Method Analysis (Total Unique Users)",
            is3D: true,
            colors: [
              "#219ebc",
              "#ffb703",
              "#850101",
              "#c3c3c3",
              "#1f4f71",
              "#99582a",
              "#185040",
            ],
            chartArea: { width: "90%", height: "80%" },
            legend: { position: "bottom" },
            pieSliceText: "percentage",
          };

          const chart = new google.visualization.PieChart(
            document.getElementById("methodChartDetailed")
          );

          google.visualization.events.addListener(chart, "select", function () {
            const selection = chart.getSelection();
            if (selection.length > 0) {
              const selectedItem = selection[0];
              if (selectedItem && selectedItem.row != null) {
                // Check row is not null
                const selectedDisplayMethod = chartData.getValue(
                  selectedItem.row,
                  0
                );
                const originalFilterMethod = originalMethodNames.get(
                  selectedDisplayMethod
                );

                if (originalFilterMethod) {
                  closeMethodChartModal();
                  applyMethodFilter(originalFilterMethod); // Use original name for filtering
                } else {
                  console.warn(
                    `Could not find original method name for display name: ${selectedDisplayMethod}`
                  );
                }
              }
            }
          });
          // --- END MODIFIED: Selection handler ---

          chart.draw(chartData, options); // Use chartData

          // --- NEW/MODIFIED: Generate Enhanced Breakdown Table ---
          const methodBreakdown = document.getElementById("methodBreakdown");
          if (methodBreakdown) {
            // --- MODIFIED: Match wordCloudBreakdown styling ---
            let breakdownHTML =
              '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Added border, adjusted margin
            breakdownHTML +=
              '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Keep existing styles

            // --- Create Table Headers ---
            breakdownHTML +=
              '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Keep sticky header style

            // Method Column Header (Left-aligned, consistent padding)
            breakdownHTML +=
              '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Method</th>';

            // Role columns (Center-aligned, consistent padding)
            sortedRoles.forEach((role) => {
              const displayRole = toTitleCase(role);
              breakdownHTML += `<th style="text-align: center; border-bottom: 1px solid #ddd; padding: 6px 8px;">${displayRole}</th>`;
            });

            // Total Users Column Header (Center-aligned, bold, consistent padding)
            breakdownHTML +=
              '<th style="text-align: center; border-bottom: 1px solid #ddd; padding: 6px 8px; font-weight: bold;">Total Users</th>';

            // Percentage Column Header (Center-aligned, consistent padding)
            breakdownHTML +=
              '<th style="text-align: center; border-bottom: 1px solid #ddd; padding: 6px 8px;">% of Total</th>';

            // Action column Header (Center-aligned, consistent padding)
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Action</th>';
            breakdownHTML += "</tr></thead>";

            // --- Create Table Body ---
            breakdownHTML += "<tbody>";
            // Sort methods for the table based on display name
            const sortedDisplayMethods = Array.from(
              originalMethodNames.keys()
            ).sort();

            sortedDisplayMethods.forEach((displayMethod, index) => {
              // Added index for alternating row colors
              const originalMethod = originalMethodNames.get(displayMethod);
              const totalUsersForMethod =
                totalUniqueUsersPerMethod.get(originalMethod) || 0;

              if (totalUsersForMethod === 0) return; // Skip methods with no users

              // MODIFIED: Added alternating background color like wordCloudBreakdown
              breakdownHTML += `<tr style="background-color: ${
                index % 2 === 0 ? "#fff" : "#f9f9f9"
              };">`;

              // Method Name Column (left-aligned, consistent padding, border)
              breakdownHTML += `<td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${displayMethod}</td>`;

              // Role Columns (Center-aligned, consistent padding, border)
              sortedRoles.forEach((role) => {
                const count =
                  usersByMethodAndRole.get(originalMethod)?.get(role)?.size ||
                  0;
                breakdownHTML += `<td style="text-align: center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>`;
              });

              // Total Users Column (Center-aligned, bold, consistent padding, border)
              breakdownHTML += `<td style="text-align: center; padding: 6px 8px; border-bottom: 1px solid #eee; font-weight: bold;">${totalUsersForMethod.toLocaleString()}</td>`;

              // Percentage Column (Center-aligned, consistent padding, border)
              const percentage =
                overallTotalUniqueUsers > 0
                  ? (
                      (totalUsersForMethod / overallTotalUniqueUsers) *
                      100
                    ).toFixed(1)
                  : "0.0";
              breakdownHTML += `<td style="text-align: center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>`;

              // Action Column (Center-aligned, consistent padding, border)
              breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                                <button onclick="applyMethodFilter('${originalMethod}')" class="filter-by-method-btn"
                                        style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                                    View Responses
                                </button>
                            </td>`;
              breakdownHTML += "</tr>";
            });
            breakdownHTML += "</tbody>";

            // --- ADDED: Table Footer (like wordCloudBreakdown) ---
            // Calculate totals for the footer row
            const finalTotals = { count: overallTotalUniqueUsers };
            sortedRoles.forEach((role) => {
              let roleTotal = 0;
              usersByMethodAndRole.forEach((roleMap, method) => {
                roleTotal += roleMap.get(role)?.size || 0;
              });
              finalTotals[role] = roleTotal;
            });

            breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`; // Footer styling
            breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`; // Footer label cell

            // Populate role totals in footer
            sortedRoles.forEach((role) => {
              const total = finalTotals[role] || 0;
              breakdownHTML += `<td style="text-align: center; padding: 8px 8px; border-top: 2px solid #ccc;">${total.toLocaleString()}</td>`;
            });

            // Populate grand total in footer
            breakdownHTML += `<td style="text-align: center; padding: 8px 8px; border-top: 2px solid #ccc;">${finalTotals.count.toLocaleString()}</td>`;
            // Percentage total (always 100%)
            breakdownHTML += `<td style="text-align: center; padding: 8px 8px; border-top: 2px solid #ccc;">100.0%</td>`;
            // Empty cell for Action column
            breakdownHTML += `<td style="padding: 8px 8px; border-top: 2px solid #ccc;"></td>`;
            breakdownHTML += `</tr></tfoot>`;
            // --- END ADDED: Table Footer ---

            breakdownHTML += "</table></div>"; // Close scrollable div
            methodBreakdown.innerHTML = breakdownHTML;
            // --- END MODIFIED: Match wordCloudBreakdown styling ---
          }

          // --- Setup Download Button Handlers ---
          // (Keep existing logic, but ensure IDs match the new HTML)
          const downloadMethodChartButton = document.getElementById(
            "downloadMethodChart"
          );
          if (downloadMethodChartButton) {
            downloadMethodChartButton.addEventListener("click", function () {
              const chartImageURI = chart.getImageURI();
              if (!chartImageURI) {
                alert("Could not generate chart image.");
                return;
              }
              const downloadLink = document.createElement("a");
              downloadLink.href = chartImageURI;
              // MODIFIED: Optional filename update
              downloadLink.download = "method-distribution-users-chart.png";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });
          }

          const downloadMethodTableCSVButton = document.getElementById(
            "downloadMethodTable"
          );
          if (downloadMethodTableCSVButton) {
            downloadMethodTableCSVButton.addEventListener("click", function () {
              const table = document.querySelector("#methodBreakdown table");
              if (!table) {
                alert("Table not found for CSV download.");
                return;
              }

              let csv = [];
              // Use updated title/description
              const titleElement = modalContent.querySelector("h3");
              const descElement = modalContent.querySelector("p");
              if (titleElement)
                csv.push(
                  `"${titleElement.textContent.trim().replace(/"/g, '""')}"`
                );
              if (descElement)
                csv.push(
                  `"${descElement.textContent
                    .trim()
                    .replace(/\s+/g, " ")
                    .replace(/"/g, '""')}"`
                ); // Clean description
              csv.push([]);

              const rows = table.querySelectorAll("tr");
              rows.forEach((row) => {
                const cells = row.querySelectorAll("td, th");
                // Exclude last cell (Action column)
                const rowData = Array.from(cells)
                  .slice(0, -1)
                  .map((cell) => {
                    return `"${(cell.textContent?.trim() || "").replace(
                      /"/g,
                      '""'
                    )}"`;
                  });
                csv.push(rowData.join(","));
              });

              const csvContent = csv.join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              // MODIFIED: Optional filename update
              downloadLink.download = "method-distribution-users-table.csv";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });
          }

          const downloadMethodTablePNGButton = document.getElementById(
            "downloadMethodTablePNG"
          );
          if (downloadMethodTablePNGButton) {
            downloadMethodTablePNGButton.addEventListener("click", function () {
              const table = document.querySelector("#methodBreakdown table");
              if (!table) {
                alert("Table not found for PNG download.");
                return;
              }
              if (typeof html2canvas !== "function") {
                alert("html2canvas library not loaded.");
                return;
              }

              const container = document.createElement("div");
              container.style.position = "absolute"; // Keep off-screen
              container.style.left = "-9999px";
              container.style.background = "white";
              container.style.padding = "20px";
              container.style.border = "1px solid #ccc";
              container.style.fontFamily = "Arial, sans-serif"; // Match word cloud export style

              // Use updated title/description from the new modal structure
              const titleElement = modalContent.querySelector(
                ".modal-title-and-x-2 h3"
              ); // Target the specific h3
              if (titleElement) {
                const titleClone = titleElement.cloneNode(true);
                titleClone.style.marginBottom = "5px"; // Match word cloud export style
                titleClone.style.fontSize = "18px"; // Match word cloud export style
                container.appendChild(titleClone);
              }
              const descElement = modalContent.querySelector(
                ".modal-title-and-x-2 p"
              ); // Target the specific p
              if (descElement) {
                const descClone = descElement.cloneNode(true);
                descClone.style.marginBottom = "20px"; // Match word cloud export style
                descClone.style.fontSize = "14px"; // Match word cloud export style
                container.appendChild(descClone);
              }

              const tableClone = table.cloneNode(true);
              // Remove Action column from clone
              tableClone.querySelectorAll("tr").forEach((row) => {
                const cells = row.cells;
                if (cells.length > 0) cells[cells.length - 1].remove();
              });
              container.appendChild(tableClone);
              document.body.appendChild(container);

              html2canvas(container, { scale: 2, useCORS: true })
                .then(function (canvas) {
                  document.body.removeChild(container);
                  const link = document.createElement("a");
                  link.download = "method-distribution-users-table.png";
                  link.href = canvas.toDataURL("image/png");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                })
                .catch((err) => {
                  console.error("Error generating canvas:", err);
                  alert("Failed to generate table image.");
                  if (document.body.contains(container))
                    document.body.removeChild(container);
                });
            });
          }
          // --- END Download Button Handlers ---
        } else {
          // Google charts not available (Keep existing code)
          if (modalContent) {
            modalContent.innerHTML =
              '<p style="color: red; text-align: center; padding: 20px;">Error: Google Charts library not available.</p>';
          }
        }
      } catch (e) {
        // Error handling for chart drawing (Keep existing code)
        console.error("Error rendering method chart in modal:", e);
        const chartDiv = document.getElementById("methodChartDetailed");
        if (chartDiv) {
          chartDiv.innerHTML =
            '<p style="color: red; text-align: center;">Error loading detailed chart.</p>';
        }
        // Clear breakdown on error too
        const methodBreakdownDiv = document.getElementById("methodBreakdown");
        if (methodBreakdownDiv) methodBreakdownDiv.innerHTML = "";
      }
    } // end modalContent check
  } // end modal check
} // end function openMethodChartModal

function closeMethodChartModal() {
  const modal = document.getElementById("methodChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// Function to apply method filter
function applyMethodFilter(method) {
  // First, close the modal
  closeMethodChartModal();

  // Use the common filter function
  applyFilterWithoutModal("method", method);
}

// Define sentiment data retrieval method if it doesn't exist
if (!window.Charts.getSentimentData) {
  window.Charts.getSentimentData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.sentimentData) {
      return window.Charts.sentimentData;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const sentimentCounts = {
        Positive: 0,
        Neutral: 0,
        Negative: 0,
        Unknown: 0,
      };

      window.sheetData.forEach((item) => {
        if (!item) return;

        // Try different possible field names for sentiment
        let sentimentValue = null;
        if (item.sentiment) {
          sentimentValue = item.sentiment;
        } else if (item.Sentiment) {
          sentimentValue = item.Sentiment;
        }

        // Skip items without sentiment data
        if (!sentimentValue) {
          sentimentCounts["Unknown"]++;
          return;
        }

        // Parse sentiment value
        const sentiment = parseFloat(sentimentValue);

        // Categorize sentiment
        if (sentiment === 5.5 || sentiment === 0 || !sentiment || 
            typeof sentiment === 'string' || isNaN(sentiment)) {
          sentimentCounts["Unknown"]++;
        } else if (sentiment >= 6.6) {
          sentimentCounts["Positive"]++;
        } else if (sentiment >= 3.3 && sentiment < 6.6 && sentiment !== 5.5 && sentiment !== 0) {
          sentimentCounts["Neutral"]++;
        } else if (sentiment < 3.3 && sentiment !== 5.5 && sentiment !== 0) {
          sentimentCounts["Negative"]++;
        } else {
          sentimentCounts["Unknown"]++;
        }
      });

      // Convert counts to array format
      Object.entries(sentimentCounts).forEach(([sentiment, count]) => {
        data.push([sentiment, count]);
      });
    }
    return data;
  };
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

function openSentimentChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("sentimentChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get sentiment data from the existing chart if possible
    let sentimentData = [];
    if (window.Charts && window.Charts.getSentimentData) {
      sentimentData = window.Charts.getSentimentData();
    }

    const modalContent = document.getElementById("sentimentChartModalContent");
    if (modalContent) {
      // --- MODIFIED: Apply consistent modal structure/styles ---
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2>Sentiment</h2>
                        <p>Sentiment scores across all users.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadSentimentChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeSentimentChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="sentimentChartDetailed" style="width: 100%; height: 400px;"></div>

                <div class="roles-stats"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3>Sentiment</h3>
                            <p>Distribution of sentiment by user's role.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSentimentTable" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadSentimentTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                                <span class="rolesChartModal-close" onclick="closeSentimentChartModal()">&times;</span> 
                            </div>
                        </div>
                    </div>
                    <div id="sentimentBreakdown"></div>
                </div>
            `;
      // --- END MODIFIED ---

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for sentiment chart");

        document.getElementById("sentimentChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Sentiment");
          data.addColumn("number", "Count");

          // If we have sentiment data from the chart object
          if (sentimentData.length > 0) {
            data.addRows(sentimentData);
          }
          // Otherwise use data from sheetData if available
          else if (window.sheetData && window.sheetData.length > 0) {
            // Count responses by sentiment
            const sentimentCounts = {
              Positive: 0,
              Neutral: 0,
              Negative: 0,
              Unknown: 0,
            };

            window.sheetData.forEach((item) => {
              if (!item) return;

              // Try different possible field names for sentiment
              let sentimentValue = null;
              if (item.sentiment) {
                sentimentValue = item.sentiment;
              } else if (item.Sentiment) {
                sentimentValue = item.Sentiment;
              }
              // Skip items without sentiment data
              if (!sentimentValue) {
                sentimentCounts["Unknown"]++;
                return;
              }

              const sentiment = parseFloat(sentimentValue);
              // Categorize sentiment
              if (sentiment === 5.5 || sentiment === 0 || !sentiment || 
                  typeof sentiment === 'string' || isNaN(sentiment)) {
                sentimentCounts["Unknown"]++;
              } else if (sentiment >= 6.6) {
                sentimentCounts["Positive"]++;
              } else if (sentiment >= 3.3 && sentiment < 6.6 && sentiment !== 5.5 && sentiment !== 0) {
                sentimentCounts["Neutral"]++;
              } else if (sentiment < 3.3 && sentiment !== 5.5 && sentiment !== 0) {
                sentimentCounts["Negative"]++;
              } else {
                sentimentCounts["Unknown"]++;
              }
            }); // Close the forEach loop

            // Add rows to the data table
            Object.entries(sentimentCounts).forEach(([sentiment, count]) => {
              data.addRow([sentiment, count]);
            });
          }

          // Options for the detailed chart
          const options = {
            title: "",
            is3D: true,
            colors: ["#54907f", "#ffb703", "#980912", "#D3D3D3"],
            chartArea: { width: "90%", height: "80%" },
            legend: { position: "bottom" },
            pieSliceText: "percentage"
          };

          const chart = new google.visualization.PieChart(
            document.getElementById("sentimentChartDetailed")
          );

          google.visualization.events.addListener(chart, "select", function () {
            const selection = chart.getSelection();
            if (selection.length > 0) {
              const selectedItem = selection[0];
              if (selectedItem) {
                const selectedSentiment = data.getValue(selectedItem.row, 0);

                closeSentimentChartModal();

                // Apply the sentiment filter
                applySentimentFilter(selectedSentiment);
              }
            }
          });

          chart.draw(data, options);

          // Display the breakdown as text
          const sentimentBreakdown =
            document.getElementById("sentimentBreakdown");
          if (sentimentBreakdown) {
            // --- MODIFIED: Apply consistent table styling ---
            let breakdownHTML =
              '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Container div
            breakdownHTML +=
              '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Basic table style

            // Header Row
            breakdownHTML +=
              '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Sticky header
            breakdownHTML +=
              '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Sentiment</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Count</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Percentage</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Action</th>';
            breakdownHTML += "</tr></thead>";

            // Table Body
            breakdownHTML += "<tbody>";
            let total = 0;
            for (let i = 0; i < data.getNumberOfRows(); i++) {
              total += data.getValue(i, 1);
            }

            for (let i = 0; i < data.getNumberOfRows(); i++) {
              const sentiment = data.getValue(i, 0);
              const count = data.getValue(i, 1);
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";

              // Don't show filter button for placeholder data (like 'Unknown')
              const actionCell =
                sentiment === "Unknown" || sentiment === "No Data Available"
                  ? `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">-</td>` // Consistent style
                  : `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                                    <button onclick="applySentimentFilter('${sentiment}')" class="filter-by-sentiment-btn"
                                        style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                                        View Responses
                                    </button>
                                </td>`;

              // Apply alternating background and consistent cell styles
              breakdownHTML += `<tr style="background-color: ${
                i % 2 === 0 ? "#fff" : "#f9f9f9"
              };">
                                <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${sentiment}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>
                                ${actionCell}
                            </tr>`;
            }
            breakdownHTML += "</tbody>";

            // Footer Row
            breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
            breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${total.toLocaleString()}</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${
              total > 0 ? "100.0%" : "N/A"
            }</td>`;
            breakdownHTML += `<td style="padding: 8px 8px; border-top: 2px solid #ccc;"></td>`; // Empty cell for Action column
            breakdownHTML += `</tr></tfoot>`;

            breakdownHTML += "</table></div>";
            sentimentBreakdown.innerHTML = breakdownHTML;
            // --- END MODIFIED ---
          }

          // Add download button handlers
          document
            .getElementById("downloadSentimentChart")
            .addEventListener("click", function () {
              // Get the chart image URI
              const chartImageURI = chart.getImageURI();

              // Create a temporary link element
              const downloadLink = document.createElement("a");
              downloadLink.href = chartImageURI;
              downloadLink.download = "sentiment-distribution-chart.png";

              // Append to document, click, and remove
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadSentimentTable")
            .addEventListener("click", function () {
              // Get the table data
              const table = document.querySelector("#sentimentBreakdown table");
              if (!table) return;

              // Create CSV content starting with the title and description
              let csv = [];
              csv.push(['"Sentiment Distribution"']);
              csv.push(['"Breakdown of sentiment data for all users."']);
              csv.push([]); // Empty line for spacing

              // Convert table to CSV, excluding the Action column
              const rows = table.querySelectorAll("tr");
              rows.forEach((row) => {
                const cells = row.querySelectorAll("td, th");
                // Take all cells except the last one (Action column)
                const rowData = Array.from(cells)
                  .slice(0, -1)
                  .map((cell) => {
                    // Remove any commas from the cell text to avoid CSV issues
                    return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
                  });
                csv.push(rowData.join(","));
              });

              // Create and trigger download
              const csvContent = csv.join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "sentiment-distribution-table.csv";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadSentimentTablePNG")
            .addEventListener("click", function () {
              const table = document.querySelector("#sentimentBreakdown table");
              if (!table) {
                alert("Table not found for PNG download.");
                return;
              }
              // --- ADDED: Check for html2canvas ---
              if (typeof html2canvas !== "function") {
                alert("html2canvas library not loaded.");
                return;
              }

              // --- MODIFIED: Create container with consistent styling ---
              const container = document.createElement("div");
              container.style.position = "absolute";
              container.style.left = "-9999px";
              container.style.background = "white";
              container.style.padding = "20px";
              container.style.border = "1px solid #ccc";
              container.style.fontFamily = "Arial, sans-serif";

              // Add title and description (use the new structure and styles)
              const titleElement = modalContent.querySelector(
                ".modal-title-and-x-2 h3"
              );
              if (titleElement) {
                const titleClone = titleElement.cloneNode(true);
                titleClone.style.marginBottom = "5px";
                titleClone.style.fontSize = "18px";
                container.appendChild(titleClone);
              }

              const descElement = modalContent.querySelector(
                ".modal-title-and-x-2 p"
              );
              if (descElement) {
                const descClone = descElement.cloneNode(true);
                descClone.style.marginBottom = "20px";
                descClone.style.fontSize = "14px";
                container.appendChild(descClone);
              }

              const tableClone = table.cloneNode(true);
              // Remove Action column from clone
              tableClone.querySelectorAll("tr").forEach((row) => {
                const cells = row.cells;
                if (cells.length > 0) cells[cells.length - 1].remove();
              });
              container.appendChild(tableClone);
              document.body.appendChild(container);

              // --- MODIFIED: Use scale, CORS, and add error handling ---
              html2canvas(container, { scale: 2, useCORS: true })
                .then(function (canvas) {
                  document.body.removeChild(container);
                  const link = document.createElement("a");
                  link.download = "sentiment-distribution-table.png";
                  link.href = canvas.toDataURL("image/png");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                })
                .catch((err) => {
                  console.error("Error generating canvas:", err);
                  alert("Failed to generate table image.");
                  if (document.body.contains(container)) {
                    document.body.removeChild(container);
                  }
                });
              // --- END MODIFIED ---
            });
        }
      } catch (e) {
        console.error("Error rendering sentiment chart in modal:", e);
        document.getElementById("sentimentChartDetailed").innerHTML =
          "<p>Unable to display detailed chart.</p>";
      }
    }
  }
}

function closeSentimentChartModal() {
  const modal = document.getElementById("sentimentChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// Define language data retrieval method if it doesn't exist
if (!window.Charts.getLanguageData) {
  window.Charts.getLanguageData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.languageData) {
      return window.Charts.languageData;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      const languageCounts = {};

      window.sheetData.forEach((item) => {
        if (!item) return;

        // Try different possible field names for language
        let languageValue = null;
        if (item.detected_language) {
          languageValue = item.detected_language;
        } else if (item.language) {
          languageValue = item.language;
        } else if (item.Language) {
          languageValue = item.Language;
        }

        // Skip items without language data
        if (!languageValue) {
          languageCounts["Unknown"] = (languageCounts["Unknown"] || 0) + 1;
          return;
        }

        // Normalize language name (proper case)
        const language = String(languageValue).trim();
        let displayLanguage = language;

        // Convert ISO codes to readable names if a language utility exists
        if (
          window.LanguageUtils &&
          typeof window.LanguageUtils.getLanguageDisplayName === "function"
        ) {
          displayLanguage =
            window.LanguageUtils.getLanguageDisplayName(language);
        } else {
          // Basic formatting - capitalize first letter
          displayLanguage =
            language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
        }

        languageCounts[displayLanguage] =
          (languageCounts[displayLanguage] || 0) + 1;
      });

      // Convert counts to array format
      Object.entries(languageCounts).forEach(([language, count]) => {
        data.push([language, count]);
      });
    }
    return data;
  };
}

function openLanguageChartModal() {
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("languageChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get language data from the existing chart if possible
    let languageData = [];
    if (window.Charts && window.Charts.getLanguageData) {
      languageData = window.Charts.getLanguageData();
    }

    const modalContent = document.getElementById("languageChartModalContent");
    if (modalContent) {
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2>Language Distribution Analysis</h2>
                        <p>Total unique users by primary language.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadLanguageChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeLanguageChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="languageChartDetailed" style="width: 100%; height: 400px;"></div>

                <div class="roles-stats"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3>Unique Users by Language</h3>
                            <p>Table view showing unique users for each language.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadLanguageTableCSV" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadLanguageTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                                <span class="rolesChartModal-close" onclick="closeLanguageChartModal()">&times;</span> 
                            </div>
                        </div>
                    </div>
                    <div id="languageBreakdown"></div>
                </div>
            `;
      // --- END MODIFIED ---

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for language chart");

        document.getElementById("languageChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Language");
          data.addColumn("number", "Count");

          // If we have language data from the chart object
          if (languageData.length > 0) {
            // Sort the existing language data to put English first
            languageData.sort((a, b) => {
              if (a[0] === "English") return -1;
              if (b[0] === "English") return 1;
              return a[0].localeCompare(b[0]);
            });
            data.addRows(languageData);
          }
          // Otherwise use data from sheetData if available
          else if (window.sheetData && window.sheetData.length > 0) {
            // Count responses by language
            const languageCounts = {};
            const processedUsers = new Map();

            window.sheetData.forEach((item) => {
              if (
                !item ||
                !item.user_id ||
                !item.detected_language ||
                processedUsers.has(item.user_id)
              )
                return;

              const language = window.LanguageUtils.getLanguageDisplayName(
                item.detected_language
              );
              languageCounts[language] = (languageCounts[language] || 0) + 1;
              processedUsers.set(item.user_id, language);
            });

            // Get all languages and create a sorted array with English first
            const allLanguages = Object.keys(languageCounts);
            const sortedLanguages = allLanguages.sort((a, b) => {
              if (a === "English") return -1;
              if (b === "English") return 1;
              return a.localeCompare(b);
            });

            // Add rows in the sorted order
            sortedLanguages.forEach((language) => {
              data.addRow([language, languageCounts[language]]);
            });
          }

          // Options for the detailed chart
          const options = {
            title: "",
            is3D: true,
            colors: [
              "#219ebc",
              "#ffb703",
              "#850101",
              "#c3c3c3",
              "#1f4f71",
              "#99582a",
              "#185040",
            ],
            chartArea: { width: "90%", height: "80%" },
            legend: { position: "bottom" },
            pieSliceText: "percentage",
          };

          const chart = new google.visualization.PieChart(
            document.getElementById("languageChartDetailed")
          );

          google.visualization.events.addListener(chart, "select", function () {
            const selection = chart.getSelection();
            if (selection.length > 0) {
              const selectedItem = selection[0];
              if (selectedItem) {
                const selectedLanguage = data.getValue(selectedItem.row, 0);

                closeLanguageChartModal();

                // Apply the language filter
                applyLanguageFilter(selectedLanguage);
              }
            }
          });

          chart.draw(data, options);

          // Display the breakdown as text
          const languageBreakdown =
            document.getElementById("languageBreakdown");
          if (languageBreakdown) {
            // --- MODIFIED: Apply consistent table styling ---
            let breakdownHTML =
              '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Container div
            breakdownHTML +=
              '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Basic table style

            // Header Row
            breakdownHTML +=
              '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Sticky header
            breakdownHTML +=
              '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Language</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Percentage</th>';
            breakdownHTML +=
              '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Action</th>';
            breakdownHTML += "</tr></thead>";

            // Table Body
            breakdownHTML += "<tbody>";
            let total = 0;
            for (let i = 0; i < data.getNumberOfRows(); i++) {
              total += data.getValue(i, 1);
            }

            for (let i = 0; i < data.getNumberOfRows(); i++) {
              const language = data.getValue(i, 0);
              const count = data.getValue(i, 1);
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";

              // Don't show filter button for placeholder data
              const actionCell =
                language === "No Data Available" ||
                language === "No Language Data Found"
                  ? `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">-</td>` // Consistent style
                  : `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">
                                    <button onclick="applyLanguageFilter('${language}')" class="filter-by-language-btn"
                                        style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                                        View Responses
                                    </button>
                                </td>`;

              // Apply alternating background and consistent cell styles
              breakdownHTML += `<tr style="background-color: ${
                i % 2 === 0 ? "#fff" : "#f9f9f9"
              };">
                                <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${language}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>
                                <td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${percentage}%</td>
                                ${actionCell}
                            </tr>`;
            }
            breakdownHTML += "</tbody>";

            // Footer Row
            breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
            breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${total.toLocaleString()}</td>`;
            breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${
              total > 0 ? "100.0%" : "N/A"
            }</td>`;
            breakdownHTML += `<td style="padding: 8px 8px; border-top: 2px solid #ccc;"></td>`; // Empty cell for Action column
            breakdownHTML += `</tr></tfoot>`;

            breakdownHTML += "</table></div>";
            languageBreakdown.innerHTML = breakdownHTML;
            // --- END MODIFIED ---
          }

          // Add download button handlers
          document
            .getElementById("downloadLanguageChart")
            .addEventListener("click", function () {
              // Get the chart image URI
              const chartImageURI = chart.getImageURI();

              // Create a temporary link element
              const downloadLink = document.createElement("a");
              downloadLink.href = chartImageURI;
              downloadLink.download = "language-distribution-chart.png";

              // Append to document, click, and remove
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadLanguageTableCSV")
            .addEventListener("click", function () {
              // Get the table data
              const table = document.querySelector("#languageBreakdown table");
              if (!table) return;

              // Create CSV content starting with the title and description
              let csv = [];
              csv.push(['"Language Distribution"']);
              csv.push(['"Breakdown of submission data for all users."']);
              csv.push([]); // Empty line for spacing

              // Convert table to CSV, excluding the Action column
              const rows = table.querySelectorAll("tr");
              rows.forEach((row) => {
                const cells = row.querySelectorAll("td, th");
                // Take all cells except the last one (Action column)
                const rowData = Array.from(cells)
                  .slice(0, -1)
                  .map((cell) => {
                    // Remove any commas from the cell text to avoid CSV issues
                    return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
                  });
                csv.push(rowData.join(","));
              });

              // Create and trigger download
              const csvContent = csv.join("\n");
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "language-distribution-table.csv";
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            });

          document
            .getElementById("downloadLanguageTablePNG")
            .addEventListener("click", function () {
              const table = document.querySelector("#languageBreakdown table");
              if (!table) {
                alert("Table not found for PNG download.");
                return;
              }
              // --- ADDED: Check for html2canvas ---
              if (typeof html2canvas !== "function") {
                alert("html2canvas library not loaded.");
                return;
              }

              // --- MODIFIED: Create container with consistent styling ---
              const container = document.createElement("div");
              container.style.position = "absolute";
              container.style.left = "-9999px";
              container.style.background = "white";
              container.style.padding = "20px";
              container.style.border = "1px solid #ccc";
              container.style.fontFamily = "Arial, sans-serif";

              // Add title and description (use the new structure and styles)
              const titleElement = modalContent.querySelector(
                ".modal-title-and-x-2 h3"
              );
              if (titleElement) {
                const titleClone = titleElement.cloneNode(true);
                titleClone.style.marginBottom = "5px";
                titleClone.style.fontSize = "18px";
                container.appendChild(titleClone);
              }

              const descElement = modalContent.querySelector(
                ".modal-title-and-x-2 p"
              );
              if (descElement) {
                const descClone = descElement.cloneNode(true);
                descClone.style.marginBottom = "20px";
                descClone.style.fontSize = "14px";
                container.appendChild(descClone);
              }

              const tableClone = table.cloneNode(true);
              // Remove Action column from clone
              tableClone.querySelectorAll("tr").forEach((row) => {
                const cells = row.cells;
                if (cells.length > 0) cells[cells.length - 1].remove();
              });
              container.appendChild(tableClone);
              document.body.appendChild(container);

              // --- MODIFIED: Use scale, CORS, and add error handling ---
              html2canvas(container, { scale: 2, useCORS: true })
                .then(function (canvas) {
                  document.body.removeChild(container);
                  const link = document.createElement("a");
                  link.download = "language-distribution-table.png";
                  link.href = canvas.toDataURL("image/png");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                })
                .catch((err) => {
                  console.error("Error generating canvas:", err);
                  alert("Failed to generate table image.");
                  if (document.body.contains(container)) {
                    document.body.removeChild(container);
                  }
                });
              // --- END MODIFIED ---
            });
        }
      } catch (e) {
        console.error("Error rendering language chart in modal:", e);
        const chartDiv = document.getElementById("languageChartDetailed");
        if (chartDiv) {
          chartDiv.innerHTML = "<p>Unable to display detailed chart.</p>";
        }
      }
    }
  }
}

function closeLanguageChartModal() {
  const modal = document.getElementById("languageChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// Function to apply language filter
function applyLanguageFilter(language) {
  // Add this line to close the language distribution modal
  closeLanguageDistributionChartModal();

  // First, close the modal
  closeLanguageChartModal();

  // Use the common filter function
  applyFilterWithoutModal("language", language);
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// Define daily submissions data retrieval method if it doesn't exist
if (!window.Charts.getDailySubmissionData) {
  window.Charts.getDailySubmissionData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.dailySubmissionData) {
      return window.Charts.dailySubmissionData;
    }

    // If we have API data via Charts.submissionsData, use that
    if (
      window.Charts.submissionsData &&
      Array.isArray(window.Charts.submissionsData)
    ) {
      // Process the API data which is likely in {date: "YYYY-MM-DD", count: N} format
      // Return in [date_label, count] format needed by the chart
      const data = [];

      // Determine the date range (last 7 days)
      const today = new Date();
      const dateMap = {};
      const dateLabels = [];

      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        const dateStr = `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
        const displayDateStr = `${d.toLocaleString("default", {
          month: "short",
        })} ${d.getDate()}`;
        dateLabels.push(displayDateStr);
        dateMap[dateStr] = { display: displayDateStr, count: 0 };
      }

      // Fill in counts from API data
      window.Charts.submissionsData.forEach((item) => {
        if (item && item.date && dateMap[item.date]) {
          dateMap[item.date].count = item.count || 0;
        }
      });

      // Convert to the format needed by the chart
      Object.keys(dateMap)
        .sort()
        .forEach((dateStr) => {
          data.push([dateMap[dateStr].display, dateMap[dateStr].count]);
        });

      return data;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      // Group submissions by date
      const submissionsByDate = {};

      // Determine the date range (last 7 days)
      const today = new Date();
      const dateLabels = [];
      for (let i = 6; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        const dateStr = `${d.getFullYear()}-${(d.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
        const displayDateStr = `${d.toLocaleString("default", {
          month: "short",
        })} ${d.getDate()}`;
        dateLabels.push(displayDateStr);
        submissionsByDate[dateStr] = 0;
      }

      // Count submissions by date - check all possible date field names
      window.sheetData.forEach((item) => {
        if (!item) return;

        // Try all possible date field names
        let dateValue = null;
        if (item.submission_date) {
          dateValue = item.submission_date;
        } else if (item.date) {
          dateValue = item.date;
        } else if (item.timestamp) {
          dateValue = item.timestamp;
        }

        if (!dateValue) return;

        // Try to parse the submission date
        let submissionDate;
        try {
          submissionDate = new Date(dateValue);
          if (isNaN(submissionDate.getTime())) {
            return; // Invalid date
          }
        } catch (e) {
          return; // Error parsing date
        }

        // Format date as YYYY-MM-DD for counting
        const dateStr = `${submissionDate.getFullYear()}-${(
          submissionDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${submissionDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;

        // Only count if date is within the last 7 days
        if (submissionsByDate.hasOwnProperty(dateStr)) {
          submissionsByDate[dateStr]++;
        }
      });

      // Convert counts to array format with display labels
      let i = 0;
      Object.keys(submissionsByDate)
        .sort()
        .forEach((dateStr) => {
          data.push([dateLabels[i], submissionsByDate[dateStr]]);
          i++;
        });
    }
    return data;
  };
}

// Define weekly submissions data retrieval method if it doesn't exist
if (!window.Charts.getWeeklySubmissionData) {
  window.Charts.getWeeklySubmissionData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.weeklySubmissionData) {
      return window.Charts.weeklySubmissionData;
    }

    // If we have API data via Charts.submissionsData, use that
    if (
      window.Charts.submissionsData &&
      Array.isArray(window.Charts.submissionsData)
    ) {
      const data = [];
      const submissionsByDate = {};

      // Convert API data to a date-indexed object
      window.Charts.submissionsData.forEach((item) => {
        if (item && item.date && !isNaN(item.count)) {
          submissionsByDate[item.date] = item.count;
        }
      });

      // Determine the week range (last 6 weeks)
      const today = new Date();
      const weekLabels = [];
      const weeklyTotals = {};

      for (let i = 5; i >= 0; i--) {
        const weekStart = new Date(today);
        weekStart.setDate(weekStart.getDate() - i * 7 - today.getDay());

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        const weekLabel = `${weekStart.getMonth() + 1}/${weekStart.getDate()}-${
          weekEnd.getMonth() + 1
        }/${weekEnd.getDate()}`;
        weekLabels.push(weekLabel);
        weeklyTotals[weekLabel] = 0;

        // Calculate all days in this week
        for (let day = 0; day < 7; day++) {
          const currentDate = new Date(weekStart);
          currentDate.setDate(weekStart.getDate() + day);

          // Format date as YYYY-MM-DD
          const dateKey = `${currentDate.getFullYear()}-${(
            currentDate.getMonth() + 1
          )
            .toString()
            .padStart(2, "0")}-${currentDate
            .getDate()
            .toString()
            .padStart(2, "0")}`;

          // Add the count for this day to the weekly total
          if (submissionsByDate[dateKey]) {
            weeklyTotals[weekLabel] += submissionsByDate[dateKey];
          }
        }
      }

      // Convert weekly totals to the array format needed by the chart
      weekLabels.forEach((weekLabel) => {
        data.push([weekLabel, weeklyTotals[weekLabel]]);
      });

      return data;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      // Group submissions by week
      const submissionsByWeek = {};

      // Determine the week range (last 6 weeks)
      const today = new Date();
      const weekLabels = [];

      for (let i = 5; i >= 0; i--) {
        const weekStart = new Date(today);
        weekStart.setDate(weekStart.getDate() - i * 7 - today.getDay());

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        const weekLabel = `${weekStart.getMonth() + 1}/${weekStart.getDate()}-${
          weekEnd.getMonth() + 1
        }/${weekEnd.getDate()}`;
        weekLabels.push(weekLabel);
        submissionsByWeek[weekLabel] = 0;
      }

      // Count submissions by week - check all possible date field names
      window.sheetData.forEach((item) => {
        if (!item) return;

        // Try all possible date field names
        let dateValue = null;
        if (item.submission_date) {
          dateValue = item.submission_date;
        } else if (item.date) {
          dateValue = item.date;
        } else if (item.timestamp) {
          dateValue = item.timestamp;
        }

        if (!dateValue) return;

        // Try to parse the submission date
        let submissionDate;
        try {
          submissionDate = new Date(dateValue);
          if (isNaN(submissionDate.getTime())) {
            return; // Invalid date
          }
        } catch (e) {
          return; // Error parsing date
        }

        // Determine which week this date falls into
        const dayDiff = Math.floor(
          (today - submissionDate) / (1000 * 60 * 60 * 24)
        );
        if (dayDiff < 0 || dayDiff > 42) {
          return; // Outside of our 6-week window
        }

        const weekIndex = Math.floor(dayDiff / 7);
        if (weekIndex < 6) {
          submissionsByWeek[weekLabels[weekIndex]]++;
        }
      });

      // Convert counts to array format
      for (let i = 0; i < weekLabels.length; i++) {
        const weekLabel = weekLabels[i];
        data.push([weekLabel, submissionsByWeek[weekLabel]]);
      }
    }
    return data;
  };
}

function openDailySubmissionsChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  // Try to sync submissions data first to ensure we have the latest data
  syncSubmissionsData();

  const modal = document.getElementById("dailySubmissionsChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get daily submission data from the existing chart if possible
    let dailySubmissionData = [];
    if (window.Charts && window.Charts.getDailySubmissionData) {
      dailySubmissionData = window.Charts.getDailySubmissionData();
    }

    const modalContent = document.getElementById(
      "dailySubmissionsChartModalContent"
    );
    if (modalContent) {
      modalContent.innerHTML = `
                <div id="dailySubmissionsChartDetailed" style="width: 100%; height: 400px;"></div>
                <div class="roles-stats">
                    <h3>Daily Submissions Analysis</h3>
                    <p>This chart shows the number of submissions received each day for the past 7 days.</p>
                    <div id="dailySubmissionsBreakdown"></div>
                </div>
            `;

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for daily submissions chart");

        document.getElementById("dailySubmissionsChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Date");
          data.addColumn("number", "Submissions");
          data.addColumn({ type: "string", role: "style" });

          // Colors array
          const colors = [
            "#219ebc",
            "#ffb703",
            "#850101",
            "#c3c3c3",
            "#1f4f71",
            "#99582a",
            "#185040",
            "#FFA726",
            "#66BB6A",
            "#EF5350",
          ];

          // If we have daily submission data from the chart object
          if (dailySubmissionData.length > 0) {
            dailySubmissionData.forEach((row, index) => {
              data.addRow([row[0], row[1], colors[index % colors.length]]);
            });
          }
          // Otherwise use data from sheetData if available
          else if (window.sheetData && window.sheetData.length > 0) {
            // Group submissions by date
            const submissionsByDate = {};

            // Determine the date range (last 7 days)
            const today = new Date();
            const dateLabels = [];
            for (let i = 6; i >= 0; i--) {
              const d = new Date(today);
              d.setDate(d.getDate() - i);
              const dateStr = `${d.getFullYear()}-${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")}`;
              const displayDateStr = `${d.toLocaleString("default", {
                month: "short",
              })} ${d.getDate()}`;
              dateLabels.push(displayDateStr);
              submissionsByDate[dateStr] = 0;
            }

            // Count submissions by date
            window.sheetData.forEach((item) => {
              if (!item || !item.submission_date) return;

              // Try to parse the submission date
              let submissionDate;
              try {
                submissionDate = new Date(item.submission_date);
                if (isNaN(submissionDate.getTime())) {
                  return; // Invalid date
                }
              } catch (e) {
                return; // Error parsing date
              }

              // Format date as YYYY-MM-DD for counting
              const dateStr = `${submissionDate.getFullYear()}-${(
                submissionDate.getMonth() + 1
              )
                .toString()
                .padStart(2, "0")}-${submissionDate
                .getDate()
                .toString()
                .padStart(2, "0")}`;

              // Only count if date is within the last 7 days
              if (submissionsByDate.hasOwnProperty(dateStr)) {
                submissionsByDate[dateStr]++;
              }
            });

            // Convert counts to array format with display labels and colors
            let i = 0;
            Object.keys(submissionsByDate)
              .sort()
              .forEach((dateStr) => {
                data.addRow([
                  dateLabels[i],
                  submissionsByDate[dateStr],
                  colors[i % colors.length],
                ]);
                i++;
              });
          }

          // Calculate total submissions for the title
          let totalSubmissions = 0;
          for (let i = 0; i < data.getNumberOfRows(); i++) {
            totalSubmissions += data.getValue(i, 1);
          }

          // Options for the detailed chart
          const options = {
            title: `Daily Submissions (Last 7 Days) - Total: ${totalSubmissions}`,
            chartArea: { width: "80%", height: "80%" },
            legend: { position: "none" },
            hAxis: {
              title: "Date",
            },
            vAxis: {
              title: "Submissions",
              minValue: 0,
            },
          };

          const chart = new google.visualization.ColumnChart(
            document.getElementById("dailySubmissionsChartDetailed")
          );
          chart.draw(data, options);

          // Check if there's actually any data
          if (data.getNumberOfRows() === 0 || !data.getNumberOfRows()) {
            document.getElementById(
              "dailySubmissionsChartDetailed"
            ).innerHTML = `
                            <div style="text-align: center; padding: 20px;">
                                <p>No submission data available for the past 7 days.</p>
                                <button onclick="syncSubmissionsData(); openDailySubmissionsChartModal();" 
                                    style="padding: 8px 16px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 15px;">
                                    Refresh Data
                                </button>
                            </div>
                        `;
            return;
          }

          // Display the breakdown as text
          const dailySubmissionsBreakdown = document.getElementById(
            "dailySubmissionsBreakdown"
          );
          if (dailySubmissionsBreakdown) {
            let breakdownHTML = '<table style="width:100%; margin-top:15px;">';
            breakdownHTML +=
              '<tr><th style="text-align:left;">Date</th><th style="text-align:center;">Submissions</th><th style="text-align:center;">Percentage</th></tr>';

            let total = 0;
            for (let i = 0; i < data.getNumberOfRows(); i++) {
              total += data.getValue(i, 1);
            }

            for (let i = 0; i < data.getNumberOfRows(); i++) {
              const date = data.getValue(i, 0);
              const count = data.getValue(i, 1);
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";

              breakdownHTML += `<tr>
                                <td style="text-align:left;">${date}</td>
                                <td style="text-align:center;">${count}</td>
                                <td style="text-align:center;">${percentage}%</td>
                            </tr>`;
            }

            breakdownHTML += `<tr style="font-weight: bold; border-top: 2px solid #ddd;">
                            <td style="text-align:left;">Total</td>
                            <td style="text-align:center;">${total}</td>
                            <td style="text-align:center;">100%</td>
                        </tr>`;

            breakdownHTML += "</table>";
            dailySubmissionsBreakdown.innerHTML = breakdownHTML;
          }
        }
      } catch (e) {
        console.error("Error rendering daily submissions chart in modal:", e);
        document.getElementById("dailySubmissionsChartDetailed").innerHTML =
          "<p>Unable to display detailed chart.</p>";
      }
    }
  }
}

function closeDailySubmissionsChartModal() {
  const modal = document.getElementById("dailySubmissionsChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

function openWeeklySubmissionsChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  // Try to sync submissions data first to ensure we have the latest data
  syncSubmissionsData();

  const modal = document.getElementById("weeklySubmissionsChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get weekly submission data from the existing chart if possible
    let weeklySubmissionData = [];
    if (window.Charts && window.Charts.getWeeklySubmissionData) {
      weeklySubmissionData = window.Charts.getWeeklySubmissionData();
    }

    const modalContent = document.getElementById(
      "weeklySubmissionsChartModalContent"
    );
    if (modalContent) {
      // Create a more detailed version of the chart
      modalContent.innerHTML = `
                <div id="weeklySubmissionsChartDetailed" style="width: 100%; height: 400px;"></div>
                <div class="roles-stats">
                    <h3>Weekly Submission Breakdown</h3>
                    <p>Breakdown of submission data for the last 6 weeks.</p>
                    <div id="weeklySubmissionsBreakdown"></div>
                </div>
            `;

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for weekly submissions chart");

        document.getElementById("weeklySubmissionsChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Try to draw a new chart in the modal with the same data
      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Week");
          data.addColumn("number", "Submissions");
          data.addColumn({ type: "string", role: "style" });

          // Colors array
          const colors = [
            "#219ebc",
            "#ffb703",
            "#850101",
            "#c3c3c3",
            "#1f4f71",
            "#99582a",
            "#185040",
            "#FFA726",
            "#66BB6A",
            "#EF5350",
          ];

          // If we have weekly submission data from the chart object
          if (weeklySubmissionData.length > 0) {
            weeklySubmissionData.forEach((row, index) => {
              data.addRow([row[0], row[1], colors[index % colors.length]]);
            });
          }
          // Otherwise use data from sheetData if available
          else if (window.sheetData && window.sheetData.length > 0) {
            // Group submissions by week
            const submissionsByWeek = {};

            // Determine the week range (last 6 weeks)
            const today = new Date();
            const weekLabels = [];

            for (let i = 5; i >= 0; i--) {
              const weekStart = new Date(today);
              weekStart.setDate(weekStart.getDate() - i * 7 - today.getDay());

              const weekEnd = new Date(weekStart);
              weekEnd.setDate(weekStart.getDate() + 6);

              const weekLabel = `${
                weekStart.getMonth() + 1
              }/${weekStart.getDate()}-${
                weekEnd.getMonth() + 1
              }/${weekEnd.getDate()}`;
              weekLabels.push(weekLabel);
              submissionsByWeek[weekLabel] = 0;
            }

            // Count submissions by week - check all possible date field names
            window.sheetData.forEach((item) => {
              if (!item) return;

              // Try all possible date field names
              let dateValue = null;
              if (item.submission_date) {
                dateValue = item.submission_date;
              } else if (item.date) {
                dateValue = item.date;
              } else if (item.timestamp) {
                dateValue = item.timestamp;
              }

              if (!dateValue) return;

              // Try to parse the submission date
              let submissionDate;
              try {
                submissionDate = new Date(dateValue);
                if (isNaN(submissionDate.getTime())) {
                  return; // Invalid date
                }
              } catch (e) {
                return; // Error parsing date
              }

              // Determine which week this date falls into
              const dayDiff = Math.floor(
                (today - submissionDate) / (1000 * 60 * 60 * 24)
              );
              if (dayDiff < 0 || dayDiff > 42) {
                return; // Outside of our 6-week window
              }

              const weekIndex = Math.floor(dayDiff / 7);
              if (weekIndex < 6) {
                submissionsByWeek[weekLabels[weekIndex]]++;
              }
            });

            // Convert counts to array format with colors
            for (let i = 0; i < weekLabels.length; i++) {
              const weekLabel = weekLabels[i];
              data.addRow([
                weekLabel,
                submissionsByWeek[weekLabel],
                colors[i % colors.length],
              ]);
            }
          }

          // Options for the detailed chart
          const options = {
            title: `Weekly Submissions (Last 6 Weeks)`,
            chartArea: { width: "80%", height: "80%" },
            legend: { position: "none" },
            hAxis: {
              title: "",
            },
            vAxis: {
              title: "Submissions",
              minValue: 0,
            },
          };

          const chart = new google.visualization.ColumnChart(
            document.getElementById("weeklySubmissionsChartDetailed")
          );
          chart.draw(data, options);

          // Check if there's actually any data
          if (data.getNumberOfRows() === 0 || !data.getNumberOfRows()) {
            document.getElementById(
              "weeklySubmissionsChartDetailed"
            ).innerHTML = `
                            <div style="text-align: center; padding: 20px;">
                                <p>No submission data available for the past 6 weeks.</p>
                                <button onclick="syncSubmissionsData(); openWeeklySubmissionsChartModal();" 
                                    style="padding: 8px 16px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 15px;">
                                    Refresh Data
                                </button>
                            </div>
                        `;
            return;
          }

          // Display the breakdown as text
          const weeklySubmissionsBreakdown = document.getElementById(
            "weeklySubmissionsBreakdown"
          );
          if (weeklySubmissionsBreakdown) {
            let breakdownHTML = '<table style="width:100%; margin-top:15px;">';
            breakdownHTML +=
              '<tr><th style="text-align:left;">Week</th><th style="text-align:center;">Submissions</th><th style="text-align:center;">Percentage</th></tr>';

            let total = 0;
            for (let i = 0; i < data.getNumberOfRows(); i++) {
              total += data.getValue(i, 1);
            }

            for (let i = 0; i < data.getNumberOfRows(); i++) {
              const week = data.getValue(i, 0);
              const count = data.getValue(i, 1);
              const percentage =
                total > 0 ? ((count / total) * 100).toFixed(1) : "0.0";

              breakdownHTML += `<tr>
                                <td style="text-align:left;">${week}</td>
                                <td style="text-align:center;">${count}</td>
                                <td style="text-align:center;">${percentage}%</td>
                            </tr>`;
            }

            breakdownHTML += `<tr style="font-weight: bold; border-top: 2px solid #ddd;">
                            <td style="text-align:left;">Total</td>
                            <td style="text-align:center;">${total}</td>
                            <td style="text-align:center;">100%</td>
                        </tr>`;

            breakdownHTML += "</table>";
            weeklySubmissionsBreakdown.innerHTML = breakdownHTML;
          }
        }
      } catch (e) {
        console.error("Error rendering weekly submissions chart in modal:", e);
        document.getElementById("weeklySubmissionsChartDetailed").innerHTML =
          "<p>Unable to display detailed chart.</p>";
      }
    }
  }
}

function closeWeeklySubmissionsChartModal() {
  const modal = document.getElementById("weeklySubmissionsChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// Define word cloud data retrieval method if it doesn't exist
if (!window.Charts.getWordCloudData) {
  window.Charts.getWordCloudData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.wordCloudData) {
      return window.Charts.wordCloudData;
    }

    if (window.WordCloud && window.WordCloud._fetchedData) {
      const wordCounts = {};
      let processedItems = 0;

      // Get all text content from the WordCloud data
      window.WordCloud._fetchedData.forEach((item) => {
        if (!item) return;
        // Use the same function as the WordCloud object to get text
        if (
          typeof window.WordCloud.getAllEnglishTranscriptions === "function"
        ) {
          const text = window.WordCloud.getAllEnglishTranscriptions(item);
          if (text) {
            processedItems++;
            // Clean and tokenize the text similar to WordCloud's method
            const words = String(text)
              .toLowerCase()
              .replace(/[^\w\s]/g, "") // Remove punctuation
              .split(/\s+/) // Split by whitespace
              .filter((word) => word.length > 3) // Only words longer than 3 characters
              .filter((word) => !window.WordCloud.stopWords.has(word)); // Filter stop words

            // Count word frequency
            words.forEach((word) => {
              wordCounts[word] = (wordCounts[word] || 0) + 1;
            });
          }
        }
      });

      // Convert to array format for word cloud
      const data = [];
      Object.entries(wordCounts)
        .sort((a, b) => b[1] - a[1]) // Sort by frequency descending
        .slice(0, 100) // Take top 100 words only
        .forEach(([word, count]) => {
          data.push({ text: word, weight: count });
        });

      // Cache the generated data for future use
      window.Charts.wordCloudData = data;

      console.log("Word cloud data generated:", data.length + " items");
      return data;
    }

    // Otherwise generate data from sheetData
    const data = [];
    if (window.sheetData && window.sheetData.length > 0) {
      console.log(
        "Processing " + window.sheetData.length + " items for word cloud"
      );
      const wordCounts = {};
      let processedItems = 0;
      let emptyItems = 0;

      // Process all responses to count word frequency
      window.sheetData.forEach((item) => {
        if (!item) {
          emptyItems++;
          return;
        }

        // Get response text from various possible field names
        let responseText = "";
        if (item.response) {
          responseText = item.response;
        } else if (item.answer) {
          responseText = item.answer;
        } else if (item.answers) {
          responseText = item.answers;
        } else if (item.text) {
          responseText = item.text;
        } else if (item.comment) {
          responseText = item.comment;
        } else if (item.feedback) {
          responseText = item.feedback;
        } else if (item.english_transcription) {
          responseText = item.english_transcription;
        }

        if (!responseText) {
          emptyItems++;
          return;
        }

        processedItems++;

        // Clean and tokenize the text
        const words = String(responseText)
          .toLowerCase()
          .replace(/[^\w\s]/g, "") // Remove punctuation
          .split(/\s+/) // Split by whitespace
          .filter((word) => word.length > 3) // Only words longer than 3 characters
          .filter(
            (word) =>
              ![
                "this",
                "that",
                "with",
                "from",
                "have",
                "should",
                "would",
                "could",
                "there",
                "their",
                "they",
                "them",
                "then",
                "than",
                "what",
                "when",
                "where",
                "which",
                "will",
                "were",
                "your",
                "because",
                "about",
              ].includes(word)
          ); // Filter common stop words

        // Count word frequency
        words.forEach((word) => {
          wordCounts[word] = (wordCounts[word] || 0) + 1;
        });
      });

      console.log(
        `Processed ${processedItems} items with text content. Skipped ${emptyItems} empty items.`
      );
      console.log(`Found ${Object.keys(wordCounts).length} unique words.`);

      // Convert to array format for word cloud
      Object.entries(wordCounts)
        .sort((a, b) => b[1] - a[1]) // Sort by frequency descending
        .slice(0, 100) // Take top 100 words only
        .forEach(([word, count]) => {
          data.push({ text: word, weight: count });
        });

      // Cache the generated data for future use
      window.Charts.wordCloudData = data;

      console.log("Word cloud data generated:", data.length + " items");
    } else {
      console.warn("No sheet data available for word cloud generation");
    }

    return data;
  };
}

function openWordCloudChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("wordCloudChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get word cloud data from the existing chart if possible
    let wordCloudData = [];

    // First check if WordCloud object has data we can use
    if (
      window.WordCloud &&
      window.WordCloud._currentWords &&
      window.WordCloud._currentWords.length > 0
    ) {
      console.log("Using word cloud data from WordCloud component");
      wordCloudData = window.WordCloud._currentWords.map((item) => ({
        text: item.word,
        weight: item.count,
      }));
    }
    // If no data from WordCloud object, use our own getWordCloudData
    else if (window.Charts && window.Charts.getWordCloudData) {
      wordCloudData = window.Charts.getWordCloudData();
      console.log(
        "Word cloud data retrieved:",
        wordCloudData.length + " items"
      );
    }

    const modalContent = document.getElementById("wordCloudChartModalContent");
    if (modalContent) {
      // Create a more detailed version of the chart
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper">
                        <h2>Top 100 Words</h2>
                        <p>Most used words from all participants.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper">
                            <div class="wordcloud-tooltip-container">
                                <button id="downloadWordCloudChart" class="download-chart-btn">
                                <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Wordcloud as Image</span>
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeWordCloudChartModal()">&times;</span>
                    </div>
                </div>
                <div id="wordCloudChartDetailed" style="width: 100%; height: 500px;"></div>

                




                <div class="roles-stats">
                    <div class="modal-title-and-x-2">    
                    
                        <div class="wordcloud-title-wrapper">
                            <h3>Top 100 Words</h3>
                            <p>Table view of the most used words from all participants.</p>
                            
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper">
                            
                                <div class="wordcloud-tooltip-container">
                                    <button id="downloadWordCloudTable" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span>
                                </div>

                                <div class="wordcloud-tooltip-container">
                                    <button id="downloadWordCloudTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span>
                                </div>

                                <span class="rolesChartModal-close" onclick="closeWordCloudChartModal()">&times;</span>

                            </div>
                        </div>
                    </div>
                    <div id="wordCloudBreakdown">
                </div>
            `;

      // Debug the data source
      if (
        (!window.sheetData || window.sheetData.length === 0) &&
        (!window.WordCloud || !window.WordCloud._fetchedData)
      ) {
        console.warn("No data available for word cloud chart");

        document.getElementById("wordCloudChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Try to render the word cloud
      try {
        // Always use the simple DOM-based rendering which doesn't require jQuery
        renderSimpleWordCloud(wordCloudData);

        // Display the breakdown as a table
        renderWordFrequencyTable(wordCloudData);

        // Add download button handlers
        document
          .getElementById("downloadWordCloudChart")
          .addEventListener("click", function () {
            // Instead of the existing implementation, call our working function
            if (typeof window.downloadMainWordCloud === "function") {
              window.downloadMainWordCloud();
            } else {
              console.error("downloadMainWordCloud function not found");
              // Fallback to old behavior
              const cloudContainer = document.getElementById(
                "word-cloud-visualization"
              );
              if (!cloudContainer) return;

              // Check if html-to-image library is available
              if (typeof htmlToImage === "undefined") {
                // Add the script if it's not already included
                window.loadHtmlToImage(function () {
                  captureWithHtmlToImage(cloudContainer);
                });
              } else {
                captureWithHtmlToImage(cloudContainer);
              }
            }
          });

        document
          .getElementById("downloadWordCloudTable")
          .addEventListener("click", function () {
            // Create CSV content from the word cloud data
            if (!wordCloudData || wordCloudData.length === 0) return;

            // Sort data by frequency (weight) descending
            const sortedData = [...wordCloudData].sort(
              (a, b) => b.weight - a.weight
            );

            // Calculate total frequency for percentages
            const totalFrequency = sortedData.reduce(
              (sum, item) => sum + item.weight,
              0
            );

            // Create CSV content
            let csv = [];
            csv.push(['"Word Cloud"']);
            csv.push(['"Most used words from all participants."']);
            csv.push([]); // Empty line for spacing
            csv.push(['"Word"', '"Frequency"', '"Percentage"']);

            // Add the top 100 words
            sortedData.slice(0, 100).forEach((item) => {
              const percentage = ((item.weight / totalFrequency) * 100).toFixed(
                2
              );
              csv.push([`"${item.text}"`, item.weight, `"${percentage}%"`]);
            });

            // Create and trigger download
            const csvContent = csv.join("\n");
            const blob = new Blob([csvContent], {
              type: "text/csv;charset=utf-8;",
            });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "word-cloud-table.csv";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });

        document
          .getElementById("downloadWordCloudTablePNG")
          .addEventListener("click", function () {
            // Get the original data from the table
            const tableContainer =
              document.getElementById("wordCloudBreakdown");
            if (!tableContainer) return;

            // Extract data from the original table
            const dataRows = Array.from(
              tableContainer.querySelectorAll("tbody tr")
            );
            const wordData = dataRows.map((row) => {
              return {
                word: row.cells[0].textContent,
                frequency: row.cells[1].textContent,
                percentage: row.cells[2].textContent,
              };
            });

            if (wordData.length === 0) {
              alert("No word data found to export");
              return;
            }

            // Create a brand new document with clean HTML
            const exportDoc = document.createElement("div");
            exportDoc.style.background = "white";
            exportDoc.style.padding = "20px";
            exportDoc.style.fontFamily = "Arial, sans-serif";
            exportDoc.style.width = "1200px"; // Wider to accommodate 4 columns
            exportDoc.style.position = "absolute";
            exportDoc.style.left = "-9999px"; // Position off-screen

            // Add title and description
            const headerDiv = document.createElement("div");

            const title = document.createElement("h2");
            title.textContent = "Word Frequency";
            title.style.margin = "0 0 5px 0";
            title.style.fontSize = "18px";

            const description = document.createElement("p");
            description.textContent =
              "Most used words from all participants. Larger words indicate higher use.";
            description.style.margin = "0 0 20px 0";
            description.style.fontSize = "14px";

            headerDiv.appendChild(title);
            headerDiv.appendChild(description);
            exportDoc.appendChild(headerDiv);

            // Create a 4-column layout with gaps
            const columnsContainer = document.createElement("div");
            columnsContainer.style.display = "flex";
            columnsContainer.style.justifyContent = "space-between";
            columnsContainer.style.width = "100%";

            // Calculate how many items per column
            const itemsPerColumn = Math.ceil(
              Math.min(wordData.length, 100) / 4
            );

            // Create four columns with 7% gap between them
            for (let colIdx = 0; colIdx < 4; colIdx++) {
              const columnDiv = document.createElement("div");
              columnDiv.style.width = "21%"; // 4 columns at 21% each = 84%, leaving 16% for gaps (approx. 5.33% between each)

              // Create table for this column
              const table = document.createElement("table");
              table.style.width = "100%";
              table.style.borderCollapse = "collapse";
              table.style.fontSize = "12px";

              // Create table header
              const thead = document.createElement("thead");
              const headerRow = document.createElement("tr");

              const wordHeader = document.createElement("th");
              wordHeader.textContent = "Word";
              wordHeader.style.padding = "5px";
              wordHeader.style.textAlign = "left";
              wordHeader.style.backgroundColor = "#f2f2f2";
              wordHeader.style.border = "1px solid #ddd";

              const freqHeader = document.createElement("th");
              freqHeader.textContent = "Frequency";
              freqHeader.style.padding = "5px";
              freqHeader.style.textAlign = "center";
              freqHeader.style.backgroundColor = "#f2f2f2";
              freqHeader.style.border = "1px solid #ddd";

              const pctHeader = document.createElement("th");
              pctHeader.textContent = "Percentage";
              pctHeader.style.padding = "5px";
              pctHeader.style.textAlign = "center";
              pctHeader.style.backgroundColor = "#f2f2f2";
              pctHeader.style.border = "1px solid #ddd";

              headerRow.appendChild(wordHeader);
              headerRow.appendChild(freqHeader);
              headerRow.appendChild(pctHeader);
              thead.appendChild(headerRow);
              table.appendChild(thead);

              // Create table body
              const tbody = document.createElement("tbody");

              // Calculate start and end index for this column
              const startIdx = colIdx * itemsPerColumn;
              const endIdx = Math.min(
                startIdx + itemsPerColumn,
                wordData.length
              );

              // Add rows for this column
              for (let i = startIdx; i < endIdx; i++) {
                const item = wordData[i];
                const row = document.createElement("tr");
                row.style.backgroundColor =
                  (i - startIdx) % 2 === 0 ? "#fff" : "#f9f9f9";

                const wordCell = document.createElement("td");
                wordCell.textContent = item.word;
                wordCell.style.padding = "5px";
                wordCell.style.textAlign = "left";
                wordCell.style.border = "1px solid #ddd";

                const freqCell = document.createElement("td");
                freqCell.textContent = item.frequency;
                freqCell.style.padding = "5px";
                freqCell.style.textAlign = "center";
                freqCell.style.border = "1px solid #ddd";

                const pctCell = document.createElement("td");
                pctCell.textContent = item.percentage;
                pctCell.style.padding = "5px";
                pctCell.style.textAlign = "right";
                pctCell.style.border = "1px solid #ddd";

                row.appendChild(wordCell);
                row.appendChild(freqCell);
                row.appendChild(pctCell);

                tbody.appendChild(row);
              }

              table.appendChild(tbody);
              columnDiv.appendChild(table);
              columnsContainer.appendChild(columnDiv);
            }

            exportDoc.appendChild(columnsContainer);

            // Add to document
            document.body.appendChild(exportDoc);

            // Generate image
            html2canvas(exportDoc, {
              scale: 2,
              backgroundColor: "white",
              logging: false,
              useCORS: true,
              allowTaint: true,
            })
              .then(function (canvas) {
                // Remove the temporary element
                document.body.removeChild(exportDoc);

                // Create download link
                const link = document.createElement("a");
                link.download = "word-cloud-table-image.png";
                link.href = canvas.toDataURL("image/png");
                link.click();
              })
              .catch(function (error) {
                console.error("Error generating image:", error);
                document.body.removeChild(exportDoc);
                alert("Failed to generate image. Please try again.");
              });
          });
      } catch (e) {
        console.error("Error rendering word cloud in modal:", e);
        document.getElementById("wordCloudChartDetailed").innerHTML =
          "<p>Unable to display detailed word cloud.</p>";
      }
    }
  }
}

function renderSimpleWordCloud(wordCloudData) {
  const container = document.getElementById("wordCloudChartDetailed");
  if (!container) return;

  // Clear container
  container.innerHTML = "";

  // Check if we have data
  if (!wordCloudData || wordCloudData.length === 0) {
    container.innerHTML = `
            <div style="text-align: center; padding: 40px; background-color: #f9f9f9; border-radius: 8px;">
                <h3 style="color: #666;">No word cloud data available</h3>
                <p>Try refreshing the page or use another browser.</p>
            </div>
        `;
    return;
  }

  // Calculate max frequency for scaling
  const maxWeight = Math.max(...wordCloudData.map((item) => item.weight));

  // Create a div for each word with size proportional to frequency
  const cloudContainer = document.createElement("div");
  cloudContainer.style.cssText =
    "display: flex; flex-wrap: wrap; justify-content: center; align-items: center; width: 100%; height: 100%; padding: 20px;";

  // Color scale
  const colors = [
    "#219ebc",
    "#ffb703",
    "#850101",
    "#1f4f71",
    "#99582a",
    "#185040",
    "#8ecae6",
  ];

  wordCloudData.forEach((word, index) => {
    const fontSize = 10 + (word.weight / maxWeight) * 40; // Scale between 10px and 50px
    const wordSpan = document.createElement("span");
    wordSpan.innerText = word.text;
    wordSpan.style.cssText = `
            font-size: ${fontSize}px;
            padding: 5px;
            margin: 5px;
            color: ${colors[index % colors.length]};
            display: inline-block;
            font-weight: ${fontSize > 25 ? "bold" : "normal"};
            cursor: pointer;
        `;

    // Add click handler to filter by this word
    wordSpan.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent any default behavior
      e.stopPropagation(); // Stop event propagation

      // Call searchForWord safely with the word text
      try {
        // Close modal first
        closeWordCloudChartModal();

        // Delay searching to ensure modal is closed first
        setTimeout(() => {
          searchForWord(word.text);
        }, 100);
      } catch (error) {
        console.error("Error handling word click:", error);
      }

      return false; // Prevent default behavior
    });

    cloudContainer.appendChild(wordSpan);
  });

  container.appendChild(cloudContainer);
}

function renderWordFrequencyTable(wordCloudData) {
  const container = document.getElementById("wordCloudBreakdown");
  if (!container) return;

  // Clear container
  container.innerHTML = "";

  // Check if we have data
  if (!wordCloudData || wordCloudData.length === 0) {
    container.innerHTML = "<p>No word frequency data available.</p>";
    return;
  }

  // Sort data by frequency (weight) descending
  const sortedData = [...wordCloudData].sort((a, b) => b.weight - a.weight);

  // Calculate total frequency for percentages
  const totalFrequency = sortedData.reduce((sum, item) => sum + item.weight, 0);

  // Create table
  const table = document.createElement("table");
  table.classList.add("data-table", "word-frequency-table");
  table.style.width = "100%";

  // Create table header
  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");

  const wordHeader = document.createElement("th");
  wordHeader.textContent = "Word";

  const freqHeader = document.createElement("th");
  freqHeader.textContent = "Frequency";

  const percentHeader = document.createElement("th");
  percentHeader.textContent = "Percentage";

  const actionHeader = document.createElement("th");
  actionHeader.textContent = "Action";

  headerRow.appendChild(wordHeader);
  headerRow.appendChild(freqHeader);
  headerRow.appendChild(percentHeader);
  headerRow.appendChild(actionHeader);
  thead.appendChild(headerRow);
  table.appendChild(thead);

  // Create table body
  const tbody = document.createElement("tbody");

  // Add rows
  sortedData.slice(0, 100).forEach((item) => {
    const row = document.createElement("tr");

    const wordCell = document.createElement("td");
    wordCell.textContent = item.text;

    const freqCell = document.createElement("td");
    freqCell.textContent = item.weight;

    const percentCell = document.createElement("td");
    const percentage = ((item.weight / totalFrequency) * 100).toFixed(2);
    percentCell.textContent = percentage + "%";

    const actionCell = document.createElement("td");
    const searchButton = document.createElement("button");
    searchButton.classList.add("search-for-word-btn");
    searchButton.textContent = "View Responses";
    searchButton.onclick = function () {
      searchForWord(item.text);
    };
    actionCell.appendChild(searchButton);

    row.appendChild(wordCell);
    row.appendChild(freqCell);
    row.appendChild(percentCell);
    row.appendChild(actionCell);

    tbody.appendChild(row);
  });

  table.appendChild(tbody);
  container.appendChild(table);

  // Add download buttons
  const downloadButtonsContainer = document.createElement("div");
  downloadButtonsContainer.style.marginTop = "20px";
  downloadButtonsContainer.style.textAlign = "center";
  downloadButtonsContainer.style.display = "none";

  const downloadCSVButton = document.createElement("button");
  downloadCSVButton.id = "downloadWordCloudTable";
  downloadCSVButton.classList.add(
    "btn",
    "btn-outline-primary",
    "downloadWordCloudTable"
  );
  downloadCSVButton.innerHTML =
    '<i class="bi bi-file-earmark-spreadsheet"></i> Download as CSV';

  const downloadPNGButton = document.createElement("button");
  downloadPNGButton.id = "downloadWordCloudChart";
  downloadPNGButton.classList.add("download-chart-btn");
  downloadPNGButton.innerHTML =
    '<i class="bi bi-file-earmark-image"></i> Download as PNG';

  downloadButtonsContainer.appendChild(downloadCSVButton);
  downloadButtonsContainer.appendChild(downloadPNGButton);
  container.appendChild(downloadButtonsContainer);
}

function searchForWord(word) {
  // First, close the modal
  closeWordCloudChartModal();

  console.log("Searching for word:", word);

  // Prevent default behavior if event exists
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  try {
    // Find the search input in the dashboard
    const searchInput = document.querySelector(
      '#searchInput, #search-input, input[type="search"]'
    );
    if (searchInput) {
      // First clear any existing filters to ensure we're starting fresh
      const clearAllFiltersBtn = document.querySelector(
        ".clear-all-filters-chip"
      );
      if (clearAllFiltersBtn) {
        clearAllFiltersBtn.click();
        console.log("Cleared all filters before search");
      }

      // Small delay to ensure filters are cleared
      setTimeout(() => {
        // Focus on the search input
        searchInput.focus();

        // Set the search value
        searchInput.value = word;

        // Trigger input event
        searchInput.dispatchEvent(new Event("input", { bubbles: true }));

        // Clear any previous search button click timeouts
        if (window.searchButtonClickTimeout) {
          clearTimeout(window.searchButtonClickTimeout);
        }

        // Wait briefly for the search input to update
        window.searchButtonClickTimeout = setTimeout(() => {
          // Find and clear the search button if it exists
          const clearSearchBtn =
            window.clearSearchBtn || document.querySelector("#clearSearch");
          if (clearSearchBtn && clearSearchBtn.style.display !== "none") {
            // If the clear button is visible, search is active - no need to press enter
            console.log("Search already active from input event");
          } else {
            // Try to submit the search
            const searchForm = searchInput.closest("form");

            // If there's a form, submit it
            if (searchForm) {
              searchForm.dispatchEvent(
                new Event("submit", { cancelable: true })
              );
            } else {
              // Try to find a search button
              const searchButton = document.querySelector(
                '.search-button, #searchButton, button[type="submit"]'
              );
              if (searchButton) {
                searchButton.click();
              } else {
                // Last resort: simulate Enter key
                searchInput.dispatchEvent(
                  new KeyboardEvent("keydown", {
                    key: "Enter",
                    code: "Enter",
                    keyCode: 13,
                    which: 13,
                    bubbles: true,
                  })
                );
              }
            }
          }

          const filterModal = document.querySelector(".filter-modal");

          if (filterModal && filterModal.style.display !== "none") {
            filterModal.style.display = "none";
            filterModal.style.opacity = "0";
          }

          // Update the active filters display if the function exists
          if (typeof updateActiveFiltersDisplay === "function") {
            updateActiveFiltersDisplay();
          }

          // Scroll to the responses section
          setTimeout(() => {
            const responsesSection = document.getElementById("d");
            if (responsesSection) {
              responsesSection.scrollIntoView({ behavior: "smooth" });
            }
          }, 250);
        }, 150);
      }, 100);

      return false;
    } else {
      // If no search input found, try to use direct filter mechanisms
      console.warn("No search input found, trying direct filter mechanisms");

      // Create a custom filter object with the search text
      const customFilters = {
        searchTerm: word,
        sentiments: [],
        roles: [],
        grades: [],
        languages: [],
        methods: [],
        questions: [],
        schools: [],
        sortOrder:
          typeof currentSortOrder !== "undefined" ? currentSortOrder : "newest",
      };

      // Try to apply the search filter directly
      if (typeof window.displayResponses === "function" && window.sheetData) {
        window.displayResponses(window.sheetData, customFilters);
        console.log("Applied text search filter with custom filter object");

        // Scroll to the responses section
        setTimeout(() => {
          const responsesSection = document.getElementById("d");
          if (responsesSection) {
            responsesSection.scrollIntoView({ behavior: "smooth" });
          }
        }, 250);

        return false;
      }

      // If direct filtering fails, try other search/filter functions
      if (typeof filterResponses === "function") {
        filterResponses(word);
        return false;
      } else if (typeof applyTextFilter === "function") {
        applyTextFilter(word);
        return false;
      } else if (typeof searchResponses === "function") {
        searchResponses(word);
        return false;
      }

      // Fall back to a non-intrusive notification
      const notification = document.createElement("div");
      notification.style.cssText = `
                position: fixed;
                bottom: 20px;
                right: 20px;
                background-color: #f8f9fa;
                border: 1px solid #dee2e6;
                border-radius: 4px;
                padding: 10px 15px;
                box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                z-index: 1000;
                font-size: 14px;
            `;
      notification.innerHTML = `To search for <strong>${word}</strong>, please use the search box in the Responses section.`;
      document.body.appendChild(notification);

      // Remove the notification after a few seconds
      setTimeout(() => {
        if (notification.parentNode === document.body) {
          document.body.removeChild(notification);
        }
      }, 5000);
    }
  } catch (error) {
    console.error("Error in word search functionality:", error);
    return false;
  }

  return false;
}

function closeWordCloudChartModal() {
  const modal = document.getElementById("wordCloudChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// Add a global function to download the main word cloud
window.downloadMainWordCloud = function () {
  // Get the main word cloud from the homepage
  const mainWordCloud = document.getElementById("word-cloud-visualization");
  if (!mainWordCloud) {
    console.error("Main word cloud not found on page");
    return;
  }

  // Check if html-to-image library is available
  if (typeof htmlToImage === "undefined") {
    // Add the script if it's not already included
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/html-to-image/1.11.13/html-to-image.js";
    script.onload = function () {
      captureWithHtmlToImage();
    };
    script.onerror = function () {
      console.error("Failed to load library");
      alert("Could not load word cloud. Please try another browser.");
    };
    document.head.appendChild(script);
  } else {
    captureWithHtmlToImage();
  }

  function captureWithHtmlToImage() {
    // Simple debugging
    console.log("Starting word cloud capture with dimension fix");

    // Get original dimensions
    const originalRect = mainWordCloud.getBoundingClientRect();
    const originalWidth = originalRect.width;
    const originalHeight = originalRect.height;

    console.log(
      `Original dimensions: ${originalWidth}px × ${originalHeight}px`
    );

    // Create a clone with proper dimensions
    const clonedCloud = mainWordCloud.cloneNode(true);
    clonedCloud.id = "temp-word-cloud-for-capture";
    clonedCloud.style.position = "absolute";
    clonedCloud.style.top = "0";
    clonedCloud.style.left = "0";
    clonedCloud.style.zIndex = "-1000";

    // Set explicit dimensions to match the original
    clonedCloud.style.width = `${originalWidth}px`;
    clonedCloud.style.height = `${originalHeight}px`;

    // Force the desired font directly with inline styles
    clonedCloud.style.fontFamily =
      'sans-serif';

    // Apply the font to all child elements to ensure it's used
    const allElements = clonedCloud.querySelectorAll("*");
    for (let i = 0; i < allElements.length; i++) {
      allElements[i].style.fontFamily = 'sans-serif';
    }

    // Add to document
    document.body.appendChild(clonedCloud);

    // Simple options that avoid any complex processing
    const options = {
      backgroundColor: "#ffffff",
      pixelRatio: 2,
      quality: 1,
      // Set explicit width and height
      width: originalWidth,
      height: originalHeight,
      // Skip all font and image processing
      skipFonts: true,
      // No external embedding
      fontEmbedCSS: "",
      // Simplest filter to include everything
      filter: () => true,
      // Include inline styles
      style: {
        fontFamily: 'sans-serif',
        fontWeight: "bold",
        width: `${originalWidth}px`,
        height: `${originalHeight}px`,
      },
    };

    // Use basic toPng without any fancy options
    htmlToImage
      .toPng(clonedCloud, options)
      .then(function (dataUrl) {
        // Remove clone when done
        document.body.removeChild(clonedCloud);

        // Create simple download link
        const link = document.createElement("a");
        link.download = "word-cloud.png";
        link.href = dataUrl;
        link.click();

        console.log("Capture completed with correct dimensions");
      })
      .catch(function (error) {
        console.error("Capture failed:", error);

        // Clean up
        if (document.body.contains(clonedCloud)) {
          document.body.removeChild(clonedCloud);
        }

        // Use dimension-corrected canvas fallback
        useCanvasFallback(originalWidth, originalHeight);
      });
  }

  function useCanvasFallback(width, height) {
    console.log(
      `Using canvas fallback with dimensions: ${width}px × ${height}px`
    );

    try {
      // Choose direct screen capture approach with correct dimensions
      html2canvas(mainWordCloud, {
        backgroundColor: "#ffffff",
        scale: 2,
        width: width,
        height: height,
        logging: false,
        onclone: function (clonedDoc) {
          // Apply font and dimensions to cloned document
          const clonedElement = clonedDoc.getElementById(mainWordCloud.id);
          if (clonedElement) {
            clonedElement.style.fontFamily =
              'sans-serif';
            clonedElement.style.width = `${width}px`;
            clonedElement.style.height = `${height}px`;

            // Apply to all child elements too
            const allElements = clonedElement.querySelectorAll("*");
            for (let i = 0; i < allElements.length; i++) {
              allElements[i].style.fontFamily =
                'sans-serif';
            }
          }
        },
      }).then(function (canvas) {
        // Convert and download
        const link = document.createElement("a");
        link.download = "word-cloud-canvas.png";
        link.href = canvas.toDataURL("image/png");
        link.click();

        console.log("Canvas capture completed with correct dimensions");
      });
    } catch (error) {
      console.error("All methods failed:", error);
      alert("Could not capture word cloud with correct dimensions.");
    }
  }
};

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// Define response length data retrieval method if it doesn't exist
if (!window.Charts.getResponseLengthData) {
  window.Charts.getResponseLengthData = function () {
    // If there's a direct chart data object, use that
    if (window.Charts.responseLengthData) {
      console.log("Using cached response length");
      return window.Charts.responseLengthData;
    }

    console.log("Generating response length data from sheetData");

    // Generate data from sheetData
    const data = {
      roleLabels: [],
      averageLengths: [],
      wordCounts: [],
      charCounts: [],
    };

    if (window.sheetData && window.sheetData.length > 0) {
      // Group data by role
      const roleGroups = {};

      window.sheetData.forEach((item) => {
        if (!item || !item.role) return;

        const role = item.role.trim();

        // Get response text from various possible field names
        let responseText = "";
        if (item.response) {
          responseText = item.response;
        } else if (item.answer) {
          responseText = item.answer;
        } else if (item.answers) {
          responseText = item.answers;
        } else if (item.text) {
          responseText = item.text;
        } else if (item.comment) {
          responseText = item.comment;
        } else if (item.feedback) {
          responseText = item.feedback;
        } else if (item.english_transcription) {
          responseText = item.english_transcription;
        }

        if (!responseText) return;

        // Initialize role group if it doesn't exist
        if (!roleGroups[role]) {
          roleGroups[role] = {
            totalLength: 0,
            totalWords: 0,
            count: 0,
          };
        }

        // Count words (approximate method - split by spaces)
        const wordCount = responseText
          .split(/\s+/)
          .filter((word) => word.length > 0).length;

        // Add to totals
        roleGroups[role].totalLength += responseText.length;
        roleGroups[role].totalWords += wordCount;
        roleGroups[role].count++;
      });

      // Convert to arrays for the chart
      Object.entries(roleGroups).forEach(([role, counts]) => {
        if (counts.count > 0) {
          const avgCharLength = Math.round(counts.totalLength / counts.count);
          const avgWordCount = Math.round(counts.totalWords / counts.count);

          data.roleLabels.push(role);
          data.averageLengths.push(avgCharLength);
          data.wordCounts.push(avgWordCount);
          data.charCounts.push(counts.totalLength);
        }
      });

      // Sort by role for consistent display (optional)
      const indices = data.roleLabels.map((_, i) => i);
      indices.sort((a, b) =>
        data.roleLabels[a].localeCompare(data.roleLabels[b])
      );

      data.roleLabels = indices.map((i) => data.roleLabels[i]);
      data.averageLengths = indices.map((i) => data.averageLengths[i]);
      data.wordCounts = indices.map((i) => data.wordCounts[i]);
      data.charCounts = indices.map((i) => data.charCounts[i]);

      // Cache the generated data for future use
      window.Charts.responseLengthData = data;

      console.log("Response length data generated");
    } else {
      console.warn("No sheet data available for response length chart");
    }

    return data;
  };
}

function openResponseLengthChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("responseLengthChartModal");
  if (modal) {
    modal.style.display = "block";

    // Get response length data
    let responseLengthData = {};
    if (window.Charts && window.Charts.getResponseLengthData) {
      responseLengthData = window.Charts.getResponseLengthData();
    }

    const modalContent = document.getElementById(
      "responseLengthChartModalContent"
    );
    if (modalContent) {
      modalContent.innerHTML = `
                <div style="display: flex; margin-bottom: 10px; flex-direction: column">
                   <!-- <h3 style="margin: 0;">Response Length Analysis</h3> -->

                   




<div class="dropdown-container">
  <select id="responseLengthChartViewOption">
      <option value="words" selected>Average Word Count</option>
      <option value="chars">Average Character Count</option>
      <option value="total">Total Character Count</option>
  </select>
  <i class="fas fa-chevron-down"></i>
</div>

<style>
.dropdown-container {
  position: relative;
  display: inline-block;
  width: max-content !important;
  min-width: 25px;
}

.dropdown-container select {
  padding: 0 32px 0 9px !important;
  transition: all 0.3s ease;
  background-image: linear-gradient(68deg, #e4e4e4 .1%, #fdfdfd 51.5%, #d8d8d8 100.2%) !important;
  white-space: nowrap !important;
  /* width: auto; */
  min-width: 225px;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  font-size: 14px;
  width: max-content !important;
  background: repeat;
}

.dropdown-container i {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
}
</style>










                </div>
                <div id="responseLengthChartDetailed" style="width: 100%; height: 400px;"></div>
                <div class="roles-stats">
                    <p>Breakdown of response length data organized by role.</p>
                    <div id="responseLengthBreakdown"></div>
                </div>
            `;

      // Debug the data source
      if (!window.sheetData || window.sheetData.length === 0) {
        console.warn("No sheet data available for response length chart");

        document.getElementById("responseLengthChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>No data available. Please ensure data is loaded correctly.</p>
                    </div>
                `;
        return;
      }

      // Initialize the chart with character count view
      renderResponseLengthChart("words", responseLengthData);

      // Add event listener for view option change
      const viewSelector = document.getElementById(
        "responseLengthChartViewOption"
      );
      if (viewSelector) {
        viewSelector.addEventListener("change", function () {
          // Get chart container
          const chartContainer = document.getElementById(
            "responseLengthChartDetailed"
          );

          // Fade out the chart container
          if (chartContainer) {
            chartContainer.style.opacity = "0";
            chartContainer.style.transition = "opacity 0.45s ease-in-out";
          }

          // Wait for fade-out to complete before changing the chart
          setTimeout(() => {
            renderResponseLengthChart(this.value, responseLengthData);

            // Fade in the chart container after rendering
            setTimeout(() => {
              if (chartContainer) {
                chartContainer.style.opacity = "1";
              }
            }, 150);
          }, 450); // Ensure fade-out is complete
        });
      }
    }
  }
}

function renderResponseLengthChart(viewType, responseLengthData) {
  console.log(`Rendering response length chart with view type: ${viewType}`);

  try {
    if (!window.google || !window.google.visualization) {
      console.error("Google visualization library not available");
      document.getElementById("responseLengthChartDetailed").innerHTML =
        "<p>Chart visualization not available. Please make sure Google Charts is loaded.</p>";
      return;
    }

    // Set chart container to initial opacity 0 (will be faded in after rendering)
    const chartContainer = document.getElementById(
      "responseLengthChartDetailed"
    );
    if (chartContainer) {
      chartContainer.style.transition = "opacity 0.45s ease-in-out";
      chartContainer.style.opacity = "0";
      // Add cursor pointer to indicate interactivity
      chartContainer.style.cursor = "pointer";
    }

    // Create a DataTable
    const data = new google.visualization.DataTable();
    data.addColumn("string", "Role");

    let chartTitle = "";
    let valueColumn = "";

    switch (viewType) {
      case "chars":
        data.addColumn("number", "Average Character Count");
        chartTitle = "Average Character Count by Role";
        valueColumn = "averageLengths";
        break;
      case "words":
        data.addColumn("number", "Average Word Count");
        chartTitle = "Average Word Count by Role";
        valueColumn = "wordCounts";
        break;
      case "total":
        data.addColumn("number", "Total Character Count");
        chartTitle = "Total Character Count by Role";
        valueColumn = "charCounts";
        break;
    }

    // Add style column for colors
    data.addColumn({ type: "string", role: "style" });

    // Colors array
    const colors = [
      "#219ebc",
      "#ffb703",
      "#850101",
      "#c3c3c3",
      "#1f4f71",
      "#99582a",
      "#185040",
      "#FFA726",
      "#66BB6A",
      "#EF5350",
    ];

    // Create a role-to-color mapping for consistent colors
    const roleColors = {};
    responseLengthData.roleLabels.forEach((role, index) => {
      roleColors[role] = colors[index % colors.length];
    });

    // Add rows
    for (let i = 0; i < responseLengthData.roleLabels.length; i++) {
      const role = responseLengthData.roleLabels[i];
      data.addRow([
        role,
        responseLengthData[valueColumn][i],
        roleColors[role], // Use consistent color for each role
      ]);
    }

    const options = {
      title: chartTitle,
      height: 400,
      legend: { position: "none" },
      hAxis: { title: "", titleTextStyle: { color: "#333" } },
      vAxis: {
        title: viewType === "words" ? "Words" : "Characters",
        minValue: 0,
      },
    };

    const chart = new google.visualization.ColumnChart(chartContainer);

    google.visualization.events.addListener(chart, "select", function () {
      const selection = chart.getSelection();
      if (selection.length > 0) {
        const selectedItem = selection[0];
        if (selectedItem) {
          const role = data.getValue(selectedItem.row, 0);

          closeResponseLengthChartModal();

          // Apply role filter
          applyRoleFilter(role);
        }
      }
    });

    chart.draw(data, options);

    // Create a breakdown table
    createResponseLengthBreakdownTable(responseLengthData);

    // Fade in the chart container after rendering is complete
    if (chartContainer) {
      setTimeout(() => {
        chartContainer.style.opacity = "1";
      }, 150);
    }
  } catch (e) {
    console.error("Error rendering response length chart:", e);
    document.getElementById("responseLengthChartDetailed").innerHTML = `
            <div style="color: #721c24; background-color: #f8d7da; padding: 15px; border-radius: 5px;">
                <h3>Error Displaying Chart</h3>
                <p>${e.message}</p>
            </div>
        `;
  }
}

function createResponseLengthBreakdownTable(data) {
  const breakdownDiv = document.getElementById("responseLengthBreakdown");
  if (!breakdownDiv) return;

  let breakdownHTML = "<h4>Detailed Response Length by Role</h4>";
  breakdownHTML +=
    '<table style="width:100%; margin-top:15px; border-collapse: collapse;">';
  breakdownHTML += `
        <tr>
            <th style="text-align:left; padding: 8px; border-bottom: 2px solid #ddd;">Role</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd;">Avg. Characters</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd;">Avg. Words</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd;">Total Characters</th>
            <th style="text-align:center; padding: 8px; border-bottom: 2px solid #ddd;">Action</th>
        </tr>
    `;

  // Add a row for each role
  for (let i = 0; i < data.roleLabels.length; i++) {
    const role = data.roleLabels[i];
    const avgChars = data.averageLengths[i];
    const avgWords = data.wordCounts[i];
    const totalChars = data.charCounts[i];

    breakdownHTML += `
            <tr>
                <td style="text-align:left; padding: 8px; border-bottom: 1px solid #ddd; font-weight: bold;">${role}</td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">${avgChars}</td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">${avgWords}</td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">${totalChars.toLocaleString()}</td>
                <td style="text-align:center; padding: 8px; border-bottom: 1px solid #ddd;">
                    <button onclick="applyRoleFilter('${role}')" class="filter-by-role-btn"
                        style="cursor: pointer; padding: 3px 8px; border-radius: 4px; border: 1px solid #ddd; background: #f5f5f5;">
                        View Responses
                    </button>
                </td>
            </tr>
        `;
  }

  breakdownHTML += "</table>";
  breakdownDiv.innerHTML = breakdownHTML;
}

function closeResponseLengthChartModal() {
  const modal = document.getElementById("responseLengthChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************
// ***********************************************************

// Define language by grade data retrieval method if it doesn't exist
if (!window.Charts.getLanguageByGradeData) {
  window.Charts.getLanguageByGradeData = function () {
    // If we have a direct chart data object, use that
    if (window.Charts.languageByGradeData) {
      return window.Charts.languageByGradeData;
    }

    // Otherwise generate data from sheetData
    const data = {
      languages: [],
      grades: [],
      counts: [],
      gradeTotals: [], // Add a new array to store total unique users per grade
    };

    if (window.sheetData && window.sheetData.length > 0) {
      const languageByGrade = {};
      const languageSet = new Set();
      const gradeSet = new Set();

      // Track unique users by userId/role/grade/language
      const processedUsers = new Map();

      // Track unique users by grade (regardless of language)
      const uniqueUsersByGrade = {};

      // Process the data to group by language and grade
      window.sheetData.forEach((item) => {
        if (!item) return;

        // Get user id
        const userId =
          item.user_id ||
          item.userId ||
          item.id ||
          item.respondentId ||
          item.email;
        if (!userId) return; // Skip if we can't identify the user

        // Get role value
        let role = null;
        if (item.role) {
          role = item.role;
        } else if (item.Role) {
          role = item.Role;
        }

        // Skip if no role data
        if (!role) return;

        // Normalize role
        role = String(role).trim().toLowerCase();

        // Only count students
        if (role !== "student") return;

        // Get language value
        let language = null;
        if (item.detected_language) {
          language = item.detected_language;
        } else if (item.language) {
          language = item.language;
        } else if (item.Language) {
          language = item.Language;
        }

        // Get grade value
        let grade = null;
        if (item.grade) {
          grade = item.grade;
        } else if (item.Grade) {
          grade = item.Grade;
        } else if (item.grade_level) {
          grade = item.grade_level;
        } else if (item.gradeLevel) {
          grade = item.gradeLevel;
        }

        if (!language || !grade) return;

        // Normalize language
        language = String(language).trim();
        if (
          window.LanguageUtils &&
          typeof window.LanguageUtils.getLanguageDisplayName === "function"
        ) {
          language = window.LanguageUtils.getLanguageDisplayName(language);
        } else {
          // Basic capitalization
          language =
            language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
        }

        if (grade.includes(",")) {
          grade.split(",").forEach((g) => {
            const gradeName = g.trim();
            if (!gradeName) return;

            const userKey = `${userId}|${gradeName}|${language}`;

            if (processedUsers.has(userKey)) return;
            processedUsers.set(userKey, role);

            gradeSet.add(gradeName);
            languageSet.add(language);

            if (!languageByGrade[gradeName]) {
              languageByGrade[gradeName] = {};
            }

            languageByGrade[gradeName][language] =
              (languageByGrade[gradeName][language] || 0) + 1;

            if (!uniqueUsersByGrade[gradeName]) {
              uniqueUsersByGrade[gradeName] = new Set();
            }
            uniqueUsersByGrade[gradeName].add(userId);
          });
        } else {
          const gradeName = grade.trim();
          if (!gradeName) return;

          const userKey = `${userId}|${gradeName}|${language}`;

          if (processedUsers.has(userKey)) return;
          processedUsers.set(userKey, role);

          gradeSet.add(gradeName);
          languageSet.add(language);

          if (!languageByGrade[gradeName]) {
            languageByGrade[gradeName] = {};
          }

          languageByGrade[gradeName][language] =
            (languageByGrade[gradeName][language] || 0) + 1;

          if (!uniqueUsersByGrade[gradeName]) {
            uniqueUsersByGrade[gradeName] = new Set();
          }
          uniqueUsersByGrade[gradeName].add(userId);
        }
      });

      data.languages = Array.from(languageSet);

      // Custom sort function for grades
      const gradeOrder = (a, b) => {
        // Handle special cases for PK and K
        if (a.toUpperCase() === "PK" || a.toUpperCase() === "PRE-K") return -2;
        if (b.toUpperCase() === "PK" || b.toUpperCase() === "PRE-K") return 2;
        if (a.toUpperCase() === "K" || a.toUpperCase() === "KINDERGARTEN")
          return -1;
        if (b.toUpperCase() === "K" || b.toUpperCase() === "KINDERGARTEN")
          return 1;

        // Try to compare as numbers for numbered grades
        const numA = parseInt(a);
        const numB = parseInt(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.localeCompare(b);
      };

      data.grades = Array.from(gradeSet).sort(gradeOrder);

      data.counts = data.grades.map((grade) => {
        return data.languages.map((language) => {
          return languageByGrade[grade] && languageByGrade[grade][language]
            ? languageByGrade[grade][language]
            : 0;
        });
      });

      data.gradeTotals = data.grades.map((grade) => {
        return uniqueUsersByGrade[grade] ? uniqueUsersByGrade[grade].size : 0;
      });

      // Cache the data
      window.Charts.languageByGradeData = data;
    }
    return data;
  };
}

if (!window.Charts.getLanguageBySchoolData) {
  window.Charts.getLanguageBySchoolData = function () {
    // If we have a direct chart data object, use that
    if (window.Charts.languageBySchoolData) {
      return window.Charts.languageBySchoolData;
    }

    const data = {
      languages: [],
      schools: [],
      counts: [],
      schoolTotals: [], // Add a new array to store total unique users per school
    };

    if (window.sheetData && window.sheetData.length > 0) {
      const languageBySchool = {};
      const languageSet = new Set();
      const schoolSet = new Set();

      const processedUsers = new Map();

      const uniqueUsersBySchool = {};

      window.sheetData.forEach((item) => {
        if (!item) return;

        const userId =
          item.user_id ||
          item.userId ||
          item.id ||
          item.respondentId ||
          item.email;
        if (!userId) return; // Skip if we can't identify the user

        let role = null;
        if (item.role) {
          role = item.role;
        } else if (item.Role) {
          role = item.Role;
        }

        if (!role) return;

        role = String(role).trim().toLowerCase();

        if (role !== "student") return;

        let language = null;
        if (item.detected_language) {
          language = item.detected_language;
        } else if (item.language) {
          language = item.language;
        } else if (item.Language) {
          language = item.Language;
        }

        if (!language) return;

        let school = null;
        if (item.school) {
          school = item.school;
        } else if (item.School) {
          school = item.School;
        } else if (item.school_name) {
          school = item.school_name;
        } else if (item.schoolName) {
          school = item.schoolName;
        }

        if (!school) return;

        language = String(language).trim();
        if (
          window.LanguageUtils &&
          typeof window.LanguageUtils.getLanguageDisplayName === "function"
        ) {
          language = window.LanguageUtils.getLanguageDisplayName(language);
        } else {
          // Basic capitalization
          language =
            language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
        }

        school = String(school).trim();

        const userKey = `${userId}|${school}|${language}`;

        // Only count each unique user once per school+language combination
        if (processedUsers.has(userKey)) return;
        processedUsers.set(userKey, role);

        schoolSet.add(school);
        languageSet.add(language);

        if (!languageBySchool[school]) {
          languageBySchool[school] = {};
        }

        languageBySchool[school][language] =
          (languageBySchool[school][language] || 0) + 1;

        if (!uniqueUsersBySchool[school]) {
          uniqueUsersBySchool[school] = new Set();
        }
        uniqueUsersBySchool[school].add(userId);
      });

      data.languages = Array.from(languageSet);
      data.schools = Array.from(schoolSet).sort(); // Sort alphabetically

      data.counts = data.schools.map((school) => {
        return data.languages.map((language) => {
          return languageBySchool[school] && languageBySchool[school][language]
            ? languageBySchool[school][language]
            : 0;
        });
      });

      data.schoolTotals = data.schools.map((school) => {
        return uniqueUsersBySchool[school]
          ? uniqueUsersBySchool[school].size
          : 0;
      });

      // Cache the data
      window.Charts.languageBySchoolData = data;

      console.log(
        "Language by school data generated (counting student roles only):",
        data
      );
    }

    return data;
  };
}

// Function to open the Language Distribution Chart Modal
function openLanguageDistributionChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("languageDistributionChartModal");
  if (modal) {
    modal.style.display = "block";

    const modalContent = document.getElementById(
      "languageDistributionChartModalContent"
    );
    if (modalContent) {
      // --- Apply consistent modal structure/styles (Keep this part) ---
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2 id="languageDistTitle">Language Distribution</h2> 
                        <p id="languageDistDescription">Submission data organized by user's primary language.</p>
                    </div>
                    <div class="action-container">
                        <div style="margin-right: 15px;"> 
                             <!-- <label for="languageDistChartViewOption" style="font-size:0.9em; margin-right: 5px;">View by:</label> -->


                             <select id="languageDistChartViewOption" onchange="switchLanguageDistView(this.value)" 
                                style="padding: 4px 8px; border-radius: 4px; border: 1px solid #ccc;">
                                 <option value="grade">Grade Level</option>
                                 <option value="school">School</option>
                             </select>
                         </div>
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadLanguageDistributionChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeLanguageDistributionChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="languageDistributionChartDetailed" style="width: 100%; height: 400px; opacity: 1;"></div>

                <div class="roles-stats"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3 id="languageDistTableTitle">Language Distribution</h3>
                            <p id="languageDistTableDescription">Breakdown of submission data organized by language.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadLanguageDistributionTableCSV" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadLanguageDistributionTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                                <span class="rolesChartModal-close" onclick="closeLanguageDistributionChartModal()">&times;</span> 
                            </div>
                        </div>
                    </div>
                    <div id="languageDistributionBreakdown"></div>
                </div>
            `;

      let languageByGradeData = {};
      let languageBySchoolData = {};
      let dataAvailable = false;

      if (window.Charts) {
        if (typeof window.Charts.getLanguageByGradeData === "function") {
          languageByGradeData = window.Charts.getLanguageByGradeData();
        } else {
          console.warn(
            "window.Charts.getLanguageByGradeData function not found."
          );
        }

        if (typeof window.Charts.getLanguageBySchoolData === "function") {
          languageBySchoolData = window.Charts.getLanguageBySchoolData();
        } else {
          console.warn(
            "window.Charts.getLanguageBySchoolData function not found."
          );
        }

        // Check if *at least* grade data was successfully retrieved (as grade is the default view)
        // Adjust this check based on actual structure of retrieved data if necessary (e.g., check for key properties)
        if (
          languageByGradeData &&
          Object.keys(languageByGradeData).length > 0
        ) {
          dataAvailable = true;
        }
      } else {
        console.warn("window.Charts object not found.");
      }

      // Initially render the chart if data was found
      if (dataAvailable) {
        renderLanguageDistributionChart(
          "grade",
          languageByGradeData,
          languageBySchoolData
        );
      } else {
        // Display error message if data still couldn't be retrieved
        const chartDetailDiv = document.getElementById(
          "languageDistributionChartDetailed"
        );
        const tableBreakdownDiv = document.getElementById(
          "languageDistributionBreakdown"
        );
        const errorMsg =
          '<p style="text-align:center; padding: 20px; color: red;">Required language data could not be loaded.</p>';

        if (chartDetailDiv) chartDetailDiv.innerHTML = errorMsg;
        if (tableBreakdownDiv) tableBreakdownDiv.innerHTML = ""; // Clear table area

        console.error(
          "Language data not found or getters failed on modal open."
        );
      }
    }
  }
}

function switchLanguageDistView(viewType) {
  const chartContainer = document.getElementById(
    "languageDistributionChartDetailed"
  );
  const breakdownContainer = document.getElementById(
    "languageDistributionBreakdown"
  );

  // Optionally add fade-out effect
  if (chartContainer) chartContainer.style.opacity = "0";
  if (breakdownContainer) breakdownContainer.style.opacity = "0"; // Fade table too

  // Retrieve data again (necessary if getters don't return cached data)
  let languageByGradeData = {};
  let languageBySchoolData = {};
  let dataAvailable = false;

  if (window.Charts) {
    if (typeof window.Charts.getLanguageByGradeData === "function") {
      languageByGradeData = window.Charts.getLanguageByGradeData();
    }
    if (typeof window.Charts.getLanguageBySchoolData === "function") {
      languageBySchoolData = window.Charts.getLanguageBySchoolData();
    }

    // Check if data for the *selected* view is available by looking at arrays
    if (
      viewType === "grade" &&
      languageByGradeData &&
      languageByGradeData.grades &&
      languageByGradeData.grades.length > 0
    ) {
      dataAvailable = true;
    } else if (
      viewType === "school" &&
      languageBySchoolData &&
      languageBySchoolData.schools &&
      languageBySchoolData.schools.length > 0
    ) {
      dataAvailable = true;
    }
  }

  setTimeout(() => {
    if (dataAvailable) {
      renderLanguageDistributionChart(
        viewType,
        languageByGradeData,
        languageBySchoolData
      );
      // Optionally add fade-in effect after render (handled within render function now)
    } else {
      const errorMsg = `<p style="text-align:center; padding: 20px; color: red;">Required language data for '${viewType}' view could not be loaded.</p>`;
      if (chartContainer) chartContainer.innerHTML = errorMsg;
      if (breakdownContainer) breakdownContainer.innerHTML = "";
      // Fade back in to show error message
      if (chartContainer) chartContainer.style.opacity = "1";
    }
  }, 300);
}

// Function to render the language distribution chart based on view type
function renderLanguageDistributionChart(
  viewType,
  languageByGradeData,
  languageBySchoolData
) {
  const chartContainer = document.getElementById(
    "languageDistributionChartDetailed"
  );
  const breakdownContainer = document.getElementById(
    "languageDistributionBreakdown"
  );

  try {
    if (!window.google || !window.google.visualization) {
      console.error("Google visualization library not available");
      if (chartContainer) {
        // Check if chartContainer exists
        chartContainer.innerHTML =
          "<p>Chart visualization not available. Please make sure Google Charts is loaded.</p>";
      }
      return;
    }

    if (chartContainer) {
      chartContainer.style.transition = "opacity 0.45s ease-in-out";
      chartContainer.style.opacity = "1";
    }

    if (breakdownContainer) {
      breakdownContainer.style.transition = "opacity 0.45s ease-in-out";
    }

    if (
      viewType === "school" &&
      (!languageBySchoolData.schools ||
        languageBySchoolData.schools.length === 0)
    ) {
      document.getElementById("languageDistributionChartDetailed").innerHTML = `
                <div style="text-align: center; padding: 20px;">
                    <p>School data is not available in this dataset. Showing by grade level instead.</p>
                </div>
            `;
      viewType = "grade";
      const viewSelector = document.getElementById(
        "languageDistChartViewOption"
      );
      if (viewSelector) viewSelector.value = "grade";
    }

    const downloadChartBtn = document.getElementById(
      "downloadLanguageDistributionChart"
    );
    const downloadTableBtn = document.getElementById(
      "downloadLanguageDistributionTableCSV"
    );
    const downloadTablePNGBtn = document.getElementById(
      "downloadLanguageDistributionTablePNG"
    );

    if (downloadChartBtn) {
      const newBtn = downloadChartBtn.cloneNode(true);
      downloadChartBtn.parentNode.replaceChild(newBtn, downloadChartBtn);
    }

    if (downloadTableBtn) {
      const newBtn = downloadTableBtn.cloneNode(true);
      downloadTableBtn.parentNode.replaceChild(newBtn, downloadTableBtn);
    }

    if (downloadTablePNGBtn) {
      const newBtn = downloadTablePNGBtn.cloneNode(true);
      downloadTablePNGBtn.parentNode.replaceChild(newBtn, downloadTablePNGBtn);
    }

    const data = new google.visualization.DataTable();

    if (viewType === "grade") {
      data.addColumn("string", "Grade");

      const sortedLanguages = [...languageByGradeData.languages].sort(
        (a, b) => {
          if (a === "English") return -1;
          if (b === "English") return 1;
          return a.localeCompare(b);
        }
      );

      sortedLanguages.forEach((language) => {
        data.addColumn("number", language);
      });

      for (let i = 0; i < languageByGradeData.grades.length; i++) {
        const row = [languageByGradeData.grades[i]];
        sortedLanguages.forEach((language) => {
          const originalIndex = languageByGradeData.languages.indexOf(language);
          row.push(languageByGradeData.counts[i][originalIndex] || 0);
        });
        data.addRow(row);
      }

      const options = {
        title: "Language Distribution by Student Users Across Grade Levels",
        isStacked: true,
        height: 400,
        legend: { position: "top", maxLines: 1 },
        hAxis: { title: "", titleTextStyle: { color: "#333" } },
        vAxis: {
          title: "Student Count",
          minValue: 0,
          titleTextStyle: { fontSize: 16 },
        },
        colors: [
          "#219ebc",
          "#ffb703",
          "#850101",
          "#c3c3c3",
          "#1f4f71",
          "#99582a",
          "#185040",
          "#FFA726",
          "#66BB6A",
          "#EF5350",
        ],
      };

      const chart = new google.visualization.ColumnChart(chartContainer);

      google.visualization.events.addListener(chart, "select", function () {
        const selection = chart.getSelection();
        if (selection.length > 0) {
          const selectedItem = selection[0];
          if (selectedItem) {
            const grade = data.getValue(selectedItem.row, 0);
            const languageIndex = selectedItem.column;

            closeLanguageDistributionChartModal();

            setTimeout(() => {
              const filterModal = document.querySelector(".filter-modal");

              if (filterModal && filterModal.style.display !== "none") {
                filterModal.style.display = "none";
                filterModal.style.opacity = "0";
              }

              if (languageIndex > 0) {
                // 0 is the grade column
                const language = data.getColumnLabel(languageIndex);
                applyGradeAndLanguageFilter(grade, language);
              } else {
                applyGradeFilter(grade);
              }
            }, 50);
          }
        }
      });

      chart.draw(data, options);

      createLanguageByGradeBreakdownTable(languageByGradeData);

      const titleElement = document.getElementById("languageDistTitle");
      if (titleElement) titleElement.textContent = "Language Distribution";
      const descElement = document.getElementById("languageDistDescription");
      if (descElement) descElement.textContent = "";
      const tableTitleElement = document.getElementById(
        "languageDistTableTitle"
      );
      if (tableTitleElement)
        tableTitleElement.textContent = "Languages by Grade";
      const tableDescElement = document.getElementById(
        "languageDistTableDescription"
      );
      if (tableDescElement)
        tableDescElement.textContent = "Student Language Breakdown.";

      document
        .getElementById("downloadLanguageDistributionChart")
        .addEventListener("click", function () {
          const chartImageURI = chart.getImageURI();
          const downloadLink = document.createElement("a");
          downloadLink.href = chartImageURI;
          downloadLink.download = "language-distribution-by-grade-chart.png";

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });

      document
        .getElementById("downloadLanguageDistributionTableCSV")
        .addEventListener("click", function () {
          // Get the table data
          const table = document.querySelector(
            "#languageDistributionBreakdown table"
          );
          if (!table) return;

          // Create CSV content starting with the title and description
          let csv = [];
          const titleH3 = document.getElementById("languageDistTableTitle");
          const descP = document.getElementById("languageDistTableDescription");
          if (titleH3)
            csv.push(`"${titleH3.textContent.trim().replace(/"/g, '""')}"`);
          if (descP)
            csv.push(
              `"${descP.textContent
                .trim()
                .replace(/\s+/g, " ")
                .replace(/"/g, '""')}"`
            );
          csv.push([]); // Empty line for spacing

          // Convert table to CSV
          const rows = table.querySelectorAll("tr");
          rows.forEach((row) => {
            const cells = row.querySelectorAll("td, th");
            // Take all cells except any with action buttons
            const rowData = Array.from(cells)
              .map((cell) => {
                if (cell.querySelector("button")) return null;
                return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
              })
              .filter((text) => text !== null);
            csv.push(rowData.join(","));
          });

          // Create and trigger download
          const csvContent = csv.join("\n");
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "language-distribution-by-grade-table.csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });

      document
        .getElementById("downloadLanguageDistributionTablePNG")
        .addEventListener("click", function () {
          const table = document.querySelector(
            "#languageDistributionBreakdown table"
          );
          if (!table) {
            alert("Table not found for PNG download.");
            return;
          }
          if (typeof html2canvas !== "function") {
            alert("html2canvas library not loaded.");
            return;
          }

          const container = document.createElement("div");
          container.style.position = "absolute";
          container.style.left = "-9999px";
          container.style.background = "white";
          container.style.padding = "20px";
          container.style.border = "1px solid #ccc";
          container.style.fontFamily = "Arial, sans-serif";

          const titleH3 = document.getElementById("languageDistTableTitle");
          if (titleH3) {
            const titleClone = titleH3.cloneNode(true);
            titleClone.style.marginBottom = "5px";
            titleClone.style.fontSize = "18px";
            container.appendChild(titleClone);
          }

          const descP = document.getElementById("languageDistTableDescription");
          if (descP) {
            const descClone = descP.cloneNode(true);
            descClone.style.marginBottom = "20px";
            descClone.style.fontSize = "14px";
            container.appendChild(descClone);
          }

          const tableClone = table.cloneNode(true);
          tableClone
            .querySelectorAll("button")
            .forEach((elem) => elem.parentNode.removeChild(elem));
          container.appendChild(tableClone);
          document.body.appendChild(container);

          html2canvas(container, { scale: 2, useCORS: true })
            .then(function (canvas) {
              document.body.removeChild(container);
              const link = document.createElement("a");
              link.download = "language-distribution-by-grade-table.png";
              link.href = canvas.toDataURL("image/png");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch((err) => {
              console.error("Error generating canvas:", err);
              alert("Failed to generate table image.");
              if (document.body.contains(container)) {
                document.body.removeChild(container);
              }
            });
        });
    } else if (viewType === "school") {
      // Column for school
      data.addColumn("string", "School");

      const sortedLanguages = [...languageBySchoolData.languages].sort(
        (a, b) => {
          if (a === "English") return -1;
          if (b === "English") return 1;
          return a.localeCompare(b);
        }
      );

      sortedLanguages.forEach((language) => {
        data.addColumn("number", language);
      });

      for (let i = 0; i < languageBySchoolData.schools.length; i++) {
        const row = [languageBySchoolData.schools[i]];
        sortedLanguages.forEach((language) => {
          const originalIndex =
            languageBySchoolData.languages.indexOf(language);
          row.push(languageBySchoolData.counts[i][originalIndex] || 0);
        });
        data.addRow(row);
      }

      const options = {
        title: "Student Language Distribution by School",
        isStacked: true,
        height: 400,
        legend: { position: "top", maxLines: 1 },
        hAxis: { title: "", titleTextStyle: { color: "#333" } },
        vAxis: {
          title: "Student Count",
          minValue: 0,
          titleTextStyle: { fontSize: 16 },
        },
        colors: [
          "#219ebc",
          "#ffb703",
          "#850101",
          "#c3c3c3",
          "#1f4f71",
          "#99582a",
          "#185040",
          "#FFA726",
          "#66BB6A",
          "#EF5350",
        ],
      };

      const chart = new google.visualization.ColumnChart(chartContainer);

      google.visualization.events.addListener(chart, "select", function () {
        const selection = chart.getSelection();
        if (selection.length > 0) {
          const selectedItem = selection[0];
          if (selectedItem) {
            const school = data.getValue(selectedItem.row, 0);
            const languageIndex = selectedItem.column;

            closeLanguageDistributionChartModal();

            setTimeout(() => {
              // Close the filter modal if it's open
              const filterModal = document.querySelector(".filter-modal");

              if (filterModal && filterModal.style.display !== "none") {
                filterModal.style.display = "none";
                filterModal.style.opacity = "0";
              }

              if (languageIndex > 0) {
                // 0 is the school column
                const language = data.getColumnLabel(languageIndex);
                applySchoolAndLanguageFilter(school, language);
              } else {
                applySchoolFilter(school);
              }
            }, 50);
          }
        }
      });

      chart.draw(data, options);

      createLanguageBySchoolBreakdownTable(languageBySchoolData);

      const titleElement = document.getElementById("languageDistTitle");
      if (titleElement) titleElement.textContent = "Language Distribution";
      const descElement = document.getElementById("languageDistDescription");
      if (descElement) descElement.textContent = "";
      const tableTitleElement = document.getElementById(
        "languageDistTableTitle"
      );
      if (tableTitleElement)
        tableTitleElement.textContent = "Languages by School";
      const tableDescElement = document.getElementById(
        "languageDistTableDescription"
      );
      if (tableDescElement)
        tableDescElement.textContent = "Student Language Breakdown.";

      document
        .getElementById("downloadLanguageDistributionChart")
        .addEventListener("click", function () {
          const chartImageURI = chart.getImageURI();

          const downloadLink = document.createElement("a");
          downloadLink.href = chartImageURI;
          downloadLink.download = "language-distribution-by-school-chart.png";

          // Append to document, click, and remove
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });

      document
        .getElementById("downloadLanguageDistributionTableCSV")
        .addEventListener("click", function () {
          const table = document.querySelector(
            "#languageDistributionBreakdown table"
          );
          if (!table) return;

          let csv = [];
          const titleH3 = document.getElementById("languageDistTableTitle");
          const descP = document.getElementById("languageDistTableDescription");
          if (titleH3)
            csv.push(`"${titleH3.textContent.trim().replace(/"/g, '""')}"`);
          if (descP)
            csv.push(
              `"${descP.textContent
                .trim()
                .replace(/\s+/g, " ")
                .replace(/"/g, '""')}"`
            );
          csv.push([]);

          const rows = table.querySelectorAll("tr");
          rows.forEach((row) => {
            const cells = row.querySelectorAll("td, th");
            const rowData = Array.from(cells)
              .map((cell) => {
                if (cell.querySelector("button")) return null;
                return `"${cell.textContent.trim().replace(/"/g, '""')}"`;
              })
              .filter((text) => text !== null);
            csv.push(rowData.join(","));
          });

          const csvContent = csv.join("\n");
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "language-distribution-by-school-table.csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });

      document
        .getElementById("downloadLanguageDistributionTablePNG")
        .addEventListener("click", function () {
          const table = document.querySelector(
            "#languageDistributionBreakdown table"
          );
          if (!table) {
            alert("Table not found for PNG download.");
            return;
          }
          if (typeof html2canvas !== "function") {
            alert("html2canvas library not loaded.");
            return;
          }

          const container = document.createElement("div");
          container.style.position = "absolute";
          container.style.left = "-9999px";
          container.style.background = "white";
          container.style.padding = "20px";
          container.style.border = "1px solid #ccc";
          container.style.fontFamily = "Arial, sans-serif";

          const titleH3 = document.getElementById("languageDistTableTitle");
          if (titleH3) {
            const titleClone = titleH3.cloneNode(true);
            titleClone.style.marginBottom = "5px";
            titleClone.style.fontSize = "18px";
            container.appendChild(titleClone);
          }

          const descP = document.getElementById("languageDistTableDescription");
          if (descP) {
            const descClone = descP.cloneNode(true);
            descClone.style.marginBottom = "20px";
            descClone.style.fontSize = "14px";
            container.appendChild(descClone);
          }

          const tableClone = table.cloneNode(true);
          tableClone
            .querySelectorAll("button")
            .forEach((elem) => elem.parentNode.removeChild(elem));
          container.appendChild(tableClone);
          document.body.appendChild(container);

          html2canvas(container, { scale: 2, useCORS: true })
            .then(function (canvas) {
              document.body.removeChild(container);
              const link = document.createElement("a");
              link.download = "language-distribution-by-school-table.png";
              link.href = canvas.toDataURL("image/png");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch((err) => {
              console.error("Error generating canvas:", err);
              alert("Failed to generate table image.");
              if (document.body.contains(container)) {
                document.body.removeChild(container);
              }
            });
        });
    }

    if (chartContainer) {
      chartContainer.style.opacity = "1";
    }
    if (breakdownContainer) {
      breakdownContainer.style.opacity = "1";
    }
  } catch (e) {
    console.error("Error rendering language distribution chart:", e);
    document.getElementById("languageDistributionChartDetailed").innerHTML = `
            <div style="color: #721c24; background-color: #f8d7da; padding: 15px; border-radius: 5px;">
                <h3>Error Displaying Chart</h3>
                <p>${e.message}</p>
                <p>Check the console for more details.</p>
            </div>
        `;
  }
}

function createLanguageByGradeBreakdownTable(languageByGradeData) {
  const languageGradeBreakdown = document.getElementById(
    "languageDistributionBreakdown"
  );
  if (!languageGradeBreakdown) return;

  let breakdownHTML =
    '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Container div
  breakdownHTML +=
    '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Basic table style

  breakdownHTML +=
    '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Sticky header
  breakdownHTML +=
    '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Grade</th>';
  const sortedLanguages = [...languageByGradeData.languages].sort((a, b) => {
    if (a === "English") return -1;
    if (b === "English") return 1;
    return a.localeCompare(b);
  });
  sortedLanguages.forEach((lang) => {
    breakdownHTML += `<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">${lang}</th>`;
  });
  breakdownHTML +=
    '<th style="text-align:center; font-weight: bold; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total</th>'; // Total column header
  breakdownHTML += "</tr></thead>";

  breakdownHTML += "<tbody>";
  let grandTotals = { count: 0 }; // Initialize grand totals for footer
  sortedLanguages.forEach((lang) => (grandTotals[lang] = 0)); // Init language totals

  languageByGradeData.grades.forEach((grade, gradeIndex) => {
    let rowTotal = 0;
    breakdownHTML += `<tr style="background-color: ${
      gradeIndex % 2 === 0 ? "#fff" : "#f9f9f9"
    };">
            <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${grade}</td>`;
    sortedLanguages.forEach((lang) => {
      const originalLangIndex = languageByGradeData.languages.indexOf(lang);
      const count =
        languageByGradeData.counts[gradeIndex][originalLangIndex] || 0;
      rowTotal += count;
      grandTotals[lang] += count; // Add to grand total for this language
      breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>`;
    });
    grandTotals.count += rowTotal; // Add row total to overall grand total
    // Add row total cell
    breakdownHTML += `<td style="text-align:center; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #eee;">${rowTotal.toLocaleString()}</td>`;
    breakdownHTML += `</tr>`;
  });
  breakdownHTML += "</tbody>";

  breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
  breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
  // Add language totals
  sortedLanguages.forEach((lang) => {
    breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${(
      grandTotals[lang] || 0
    ).toLocaleString()}</td>`;
  });

  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${grandTotals.count.toLocaleString()}</td>`;
  breakdownHTML += `</tr></tfoot>`;

  breakdownHTML += "</table></div>";
  languageGradeBreakdown.innerHTML = breakdownHTML;
}

function createLanguageBySchoolBreakdownTable(languageBySchoolData) {
  const languageSchoolBreakdown = document.getElementById(
    "languageDistributionBreakdown"
  );
  if (!languageSchoolBreakdown) return;

  let breakdownHTML =
    '<div style="max-height: 400px; margin-top: 10px; border: 1px solid #eee;">'; // Container div
  breakdownHTML +=
    '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">'; // Basic table style

  breakdownHTML +=
    '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">'; // Sticky header
  breakdownHTML +=
    '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">School</th>';
  const sortedLanguages = [...languageBySchoolData.languages].sort((a, b) => {
    if (a === "English") return -1;
    if (b === "English") return 1;
    return a.localeCompare(b);
  });
  sortedLanguages.forEach((lang) => {
    breakdownHTML += `<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">${lang}</th>`;
  });
  breakdownHTML +=
    '<th style="text-align:center; font-weight: bold; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total</th>'; // Total column header
  breakdownHTML += "</tr></thead>";

  breakdownHTML += "<tbody>";
  let grandTotals = { count: 0 }; // Initialize grand totals for footer
  sortedLanguages.forEach((lang) => (grandTotals[lang] = 0)); // Init language totals

  languageBySchoolData.schools.forEach((school, schoolIndex) => {
    let rowTotal = 0;
    // Apply alternating row background
    breakdownHTML += `<tr style="background-color: ${
      schoolIndex % 2 === 0 ? "#fff" : "#f9f9f9"
    };">
            <td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${school}</td>`;
    sortedLanguages.forEach((lang) => {
      const originalLangIndex = languageBySchoolData.languages.indexOf(lang);
      const count =
        languageBySchoolData.counts[schoolIndex][originalLangIndex] || 0;
      rowTotal += count;
      grandTotals[lang] += count; // Add to grand total for this language
      breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>`;
    });
    grandTotals.count += rowTotal; // Add row total to overall grand total
    // Add row total cell
    breakdownHTML += `<td style="text-align:center; font-weight: bold; padding: 6px 8px; border-bottom: 1px solid #eee;">${rowTotal.toLocaleString()}</td>`;
    breakdownHTML += `</tr>`;
  });
  breakdownHTML += "</tbody>";

  breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
  breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;

  sortedLanguages.forEach((lang) => {
    breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${(
      grandTotals[lang] || 0
    ).toLocaleString()}</td>`;
  });

  breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${grandTotals.count.toLocaleString()}</td>`;
  breakdownHTML += `</tr></tfoot>`;

  breakdownHTML += "</table></div>";
  languageSchoolBreakdown.innerHTML = breakdownHTML;
}

function applySchoolAndLanguageFilter(school, language) {
  closeLanguageDistributionChartModal();

  const schoolChips = document.querySelectorAll(".school-chip");
  const languageChips = document.querySelectorAll(".language-chip");
  const roleChips = document.querySelectorAll(".role-chip");

  if (schoolChips.length > 0 && languageChips.length > 0) {
    const clearAllFiltersBtn = document.querySelector(
      ".clear-all-filters-chip"
    );
    if (clearAllFiltersBtn) {
      clearAllFiltersBtn.click();
    }

    setTimeout(() => {
      schoolChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      languageChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      roleChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });

      let targetSchoolChip = findFilterChip(schoolChips, school, "data-school");
      if (targetSchoolChip) {
        targetSchoolChip.classList.add("active");
      }

      let targetLanguageChip = findFilterChip(
        languageChips,
        language,
        "data-language"
      );
      if (targetLanguageChip) {
        targetLanguageChip.classList.add("active");
      }

      let targetRoleChip = findFilterChip(roleChips, "student", "data-role");
      if (targetRoleChip) {
        targetRoleChip.classList.add("active");
      }

      if (typeof updateDisplay === "function") {
        updateDisplay();
      }

      const filterModal = document.querySelector(".filter-modal");

      if (filterModal && filterModal.style.display !== "none") {
        filterModal.style.display = "none";
        filterModal.style.opacity = "0";
      }

      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
      }

      setTimeout(() => {
        const responsesSection = document.getElementById("d");
        if (responsesSection) {
          responsesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
    }, 100);
  } else {
    console.warn("School or language filter chips not found in the document");
  }
}

// xxx add student role part two - Function to apply both grade and language filters simultaneously
function applyGradeAndLanguageFilter(grade, language) {
  closeLanguageDistributionChartModal();

  const gradeChips = document.querySelectorAll(".grade-chip");
  const languageChips = document.querySelectorAll(".language-chip");
  const roleChips = document.querySelectorAll(".role-chip");

  if (gradeChips.length > 0 && languageChips.length > 0) {
    const clearAllFiltersBtn = document.querySelector(
      ".clear-all-filters-chip"
    );
    if (clearAllFiltersBtn) {
      clearAllFiltersBtn.click();
    }

    setTimeout(() => {
      gradeChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      languageChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });
      roleChips.forEach((chip) => {
        if (chip) chip.classList.remove("active");
      });

      let targetGradeChip = findFilterChip(gradeChips, grade, "data-grade");
      if (targetGradeChip) {
        targetGradeChip.classList.add("active");
      }

      let targetLanguageChip = findFilterChip(
        languageChips,
        language,
        "data-language"
      );
      if (targetLanguageChip) {
        targetLanguageChip.classList.add("active");
      }

      let targetRoleChip = findFilterChip(roleChips, "student", "data-role");
      if (targetRoleChip) {
        targetRoleChip.classList.add("active");
      }

      if (typeof updateDisplay === "function") {
        updateDisplay();
      }

      const filterModal = document.querySelector(".filter-modal");

      if (filterModal && filterModal.style.display !== "none") {
        filterModal.style.display = "none";
        filterModal.style.opacity = "0";
      }

      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
      }

      setTimeout(() => {
        const responsesSection = document.getElementById("d");
        if (responsesSection) {
          responsesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
    }, 100);
  } else {
    console.warn("Grade or language filter chips not found in the document");
  }
}

function closeLanguageDistributionChartModal() {
  const modal = document.getElementById("languageDistributionChartModal");
  if (modal) {
    // Add the closing class to trigger the fade animation
    modal.classList.add("closing");

    // Wait for the animation to complete before hiding the modal
    setTimeout(() => {
      modal.style.display = "none";
      // Remove the closing class so it can open properly next time
      modal.classList.remove("closing");
    }, 600); // Same duration as the animation (0.6s)
  }
}

// Helper function to close the modal for Total Submissions
function closeTotalSubmissionsChartModal() {
  const modal = document.getElementById("totalSubmissionsChartModal");
  if (modal) {
    modal.style.display = "none";
  }
  // Optional: Clear the chart content if needed
  const modalContent = document.getElementById(
    "totalSubmissionsChartModalContent"
  );
  if (modalContent) {
    modalContent.innerHTML = "";
  }
}

// Function to open the modal and draw the Total Submissions chart
function openTotalSubmissionsChartModal() {
  // Check if on mobile
  if (window.isMobileDevice()) {
    showMobileWarning();
    return;
  }

  const modal = document.getElementById("totalSubmissionsChartModal");
  if (modal) {
    modal.style.display = "block";

    const modalContent = document.getElementById(
      "totalSubmissionsChartModalContent"
    );
    if (modalContent) {
      modalContent.innerHTML = `
                <div class="modal-title-and-x">
                    <div class="wordcloud-title-wrapper"> 
                        <h2>Daily Trends</h2>
                        <p>Cumulative view of daily submission data.</p>
                    </div>
                    <div class="action-container">
                        <div class="wordcloud-tooltip-wrapper"> 
                            <div class="wordcloud-tooltip-container"> 
                                <button id="downloadTotalSubmissionsChart" class="download-chart-btn">
                                    <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important;"></i>
                                </button>
                                <span class="tooltip">Save Chart as Image</span> 
                            </div>
                        </div>
                        <span class="rolesChartModal-close" onclick="closeTotalSubmissionsChartModal()">&times;</span> 
                    </div>
                </div>
                <div id="totalSubmissionsChartDetailed" style="width: 100%; height: 400px; margin-top: 15px;"></div> 

                <div class="roles-stats" style="margin-top: 20px;"> 
                    <div class="modal-title-and-x-2"> 
                        <div class="wordcloud-title-wrapper"> 
                            <h3>Daily Sumbissions Breakdown</h3> 
                            <p>Cumulative view of daily submission data, broken down by role.</p>
                        </div>
                        <div class="action-container">
                            <div class="wordcloud-tooltip-wrapper"> 
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadTotalSubmissionsTableCSV" class="download-chart-btn">
                                        <i class="fa-duotone fa-solid fa-file-csv" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as CSV</span> 
                                </div>
                                <div class="wordcloud-tooltip-container"> 
                                    <button id="downloadTotalSubmissionsTablePNG" class="download-chart-btn">
                                        <i class="fa-duotone fa-regular fa-camera-retro" style="margin-top:0px; font-size: 1.7rem !important"></i>
                                    </button>
                                    <span class="tooltip">Save Table as Image</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="totalSubmissionsBreakdown" style="width: 100%; transition: opacity 0.3s ease-in-out;"></div> 
                </div>
            `;

      if (!window.sheetData || window.sheetData.length === 0) {
        document.getElementById("totalSubmissionsChartDetailed").innerHTML = `
                    <div style="text-align: center; padding: 20px;">
                        <p>Data not fully loaded. Please refresh the chart.</p>
                        <button onclick="syncSubmissionsData(); openTotalSubmissionsChartModal();"
                            style="padding: 8px 16px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 15px;">
                            Refresh Data
                        </button>
                    </div>
                `;
        const breakdownDiv = document.getElementById(
          "totalSubmissionsBreakdown"
        );
        if (breakdownDiv) breakdownDiv.innerHTML = "";
        return;
      }

      try {
        if (window.google && window.google.visualization) {
          const data = new google.visualization.DataTable();
          data.addColumn("string", "Date");
          data.addColumn("number", "Cumulative Unique Users");
          data.addColumn({ type: "string", role: "style" });
          data.addColumn({
            type: "string",
            role: "tooltip",
            p: { html: true },
          });

          const colors = [
            "#219ebc",
            "#ffb703",
            "#850101",
            "#c3c3c3",
            "#1f4f71",
            "#99582a",
            "#185040",
            "#FFA726",
            "#66BB6A",
            "#EF5350",
          ];
          let chartDataToUse = [];

          const submissionsByDate = {};

          const sortedSheetData = [...window.sheetData].sort((a, b) => {
            try {
              const correctDateProperty = "timestamp";
              const dateA = new Date(a[correctDateProperty]);
              const dateB = new Date(b[correctDateProperty]);
              if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0;
              return dateA - dateB;
            } catch (e) {
              return 0;
            }
          });

          let invalidDateCount = 0;
          let missingUserIdCount = 0;
          let missingRoleCount = 0; // Added: Track items missing a role

          sortedSheetData.forEach((item, index) => {
            const correctDateProperty = "timestamp";
            const itemDateValue = item ? item[correctDateProperty] : undefined;
            const userId = item?.user_id;
            const userRole = item?.role?.trim() || "Unknown"; // Added: Get role, default to 'Unknown'

            if (!item || !itemDateValue) return;

            if (!userId) {
              missingUserIdCount++;
              return;
            }

            // Added: Optional check/count for missing roles if 'Unknown' is not desired
            // if (!item?.role?.trim()) {
            //     missingRoleCount++;
            //     // Decide if you want to return here or assign 'Unknown'
            // }

            let submissionDate;
            try {
              submissionDate = new Date(itemDateValue);
              if (isNaN(submissionDate.getTime())) {
                invalidDateCount++;
                return;
              }
            } catch (e) {
              invalidDateCount++;
              return;
            }

            const dateStr = `${submissionDate.getFullYear()}-${(
              submissionDate.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${submissionDate
              .getDate()
              .toString()
              .padStart(2, "0")}`;
            const displayDateStr = `${submissionDate.toLocaleString("default", {
              month: "short",
            })} ${submissionDate.getDate()}, ${submissionDate.getFullYear()}`;

            // Initialize date entry if it doesn't exist
            if (!submissionsByDate[dateStr]) {
              submissionsByDate[dateStr] = {
                displayDate: displayDateStr,
                userIds: new Set(), // Overall unique users for the day
                dailyRoleCounts: {}, // Added: Track daily submissions per role
                dailyUniqueUsersByRole: {}, // Added: Track unique users per role per day
              };
            }

            // Track unique user for the day (overall)
            submissionsByDate[dateStr].userIds.add(userId);

            // --- Role Specific Tracking ---
            // Initialize role count if not present for this date
            if (!submissionsByDate[dateStr].dailyRoleCounts[userRole]) {
              submissionsByDate[dateStr].dailyRoleCounts[userRole] = 0;
            }
            submissionsByDate[dateStr].dailyRoleCounts[userRole]++; // Increment daily count for this role

            // Initialize Set for unique users for this role on this date
            if (!submissionsByDate[dateStr].dailyUniqueUsersByRole[userRole]) {
              submissionsByDate[dateStr].dailyUniqueUsersByRole[userRole] =
                new Set();
            }
            submissionsByDate[dateStr].dailyUniqueUsersByRole[userRole].add(
              userId
            ); // Add user to role's unique set for the day
            // --- End Role Specific Tracking ---
          });

          // --- Second pass: Calculate cumulative unique users and other metrics ---
          let encounteredUserIds = new Set(); // Master set of all unique users seen so far
          let encounteredUserIdsByRole = {}; // Added: Master sets per role
          let runningTotalUniqueUsers = 0;
          let previousDayUniqueUserCount = 0; // Added: For growth rate calculation
          let colorIndex = 0;
          const sortedUniqueDates = Object.keys(submissionsByDate).sort(); // Sort the YYYY-MM-DD date strings

          // Clear previous data before adding new rows
          data.removeRows(0, data.getNumberOfRows());

          sortedUniqueDates.forEach((dateStr) => {
            const dateInfo = submissionsByDate[dateStr];
            if (!dateInfo || !dateInfo.userIds) return; // Skip if data is missing for the date

            // Update overall unique users
            dateInfo.userIds.forEach((userId) => {
              encounteredUserIds.add(userId);
            });
            runningTotalUniqueUsers = encounteredUserIds.size; // Recalculate total unique users

            // Update unique users per role
            Object.entries(dateInfo.dailyUniqueUsersByRole).forEach(
              ([role, userIdSet]) => {
                if (!encounteredUserIdsByRole[role]) {
                  encounteredUserIdsByRole[role] = new Set();
                }
                userIdSet.forEach((userId) =>
                  encounteredUserIdsByRole[role].add(userId)
                );
              }
            );

            // --- Calculate Growth Rate ---
            const dailyGrowth =
              runningTotalUniqueUsers - previousDayUniqueUserCount;
            const growthRate =
              previousDayUniqueUserCount > 0
                ? ((dailyGrowth / previousDayUniqueUserCount) * 100).toFixed(1)
                : "N/A";
            const growthText = growthRate !== "N/A" ? ` (+${growthRate}%)` : "";

            const displayDate = dateInfo.displayDate;

            // --- Create Role Breakdown String for Tooltip ---
            let roleBreakdownHtml = "";
            const sortedRoles = Object.keys(
              dateInfo.dailyUniqueUsersByRole
            ).sort(); // Use dailyUniqueUsersByRole keys
            if (sortedRoles.length > 0) {
              // Changed heading for clarity
              roleBreakdownHtml +=
                '<p style="font-weight: 600; color: #57819e; font-size: 1.1em;">Submissions on This Day:</p><ul style="margin-bottom: 4px; padding: 0;">';
              sortedRoles.forEach((role) => {
                const dailyUniqueUserSet =
                  dateInfo.dailyUniqueUsersByRole[role];
                const dailyUniqueUserCount = dailyUniqueUserSet
                  ? dailyUniqueUserSet.size
                  : 0; // Get size of the Set
                // Use the count of unique users for the day
                roleBreakdownHtml += `<li style="margin-bottom: 1px;">${role}: ${dailyUniqueUserCount.toLocaleString()}</li>`;
              });
              roleBreakdownHtml += "</ul>";
            }

            let cumulativeRoleBreakdownHtml = "";
            const sortedCumulativeRoles = Object.keys(
              encounteredUserIdsByRole
            ).sort();
            if (sortedCumulativeRoles.length > 0) {
              cumulativeRoleBreakdownHtml +=
                '<p style="font-weight: 600; color: #57819e; font-size: 1.1em;">Cumulative Counts:</p><ul style="margin-top: 12px; padding: 0;">';
              sortedCumulativeRoles.forEach((role) => {
                cumulativeRoleBreakdownHtml += `<li style="margin-bottom: 1px;">${role}: ${encounteredUserIdsByRole[
                  role
                ].size.toLocaleString()}</li>`;
              });
              cumulativeRoleBreakdownHtml += "</ul>";
            }

            const tooltipHtml = `
                             <div style="padding:10px; min-width: 280px; max-width: 400px; font-size: 0.9em;">
                                 <strong style="font-size: 1.1em;">${displayDate}</strong><br>
                                 <hr style="margin-bottom: 9px;">
                                 ${
                                   roleBreakdownHtml
                                     ? roleBreakdownHtml + "<br>"
                                     : ""
                                 }
                                 <hr style="margin-bottom: 12px;">

                                <div>
                                ${cumulativeRoleBreakdownHtml}
                                </div>
                                
                                <div style="margin-top: 12px;">
                                <span style="font-size: 1em; font-weight: 700">Cumulative Total: ${runningTotalUniqueUsers.toLocaleString()}</span> <span style="color: green; font-size: 1em">${growthText}</span></strong>
            
                            </div>
                        </div>
                         `;

            data.addRow([
              displayDate,
              runningTotalUniqueUsers,
              `point { size: 5; fill-color: ${
                colors[colorIndex % colors.length]
              }; }`,
              tooltipHtml,
            ]);

            const cumulativeRolesSnapshot = {};
            Object.entries(encounteredUserIdsByRole).forEach(
              ([role, userSet]) => {
                // Create a NEW Set object copying the elements from the current master Set for this role
                cumulativeRolesSnapshot[role] = new Set(userSet);
              }
            );

            chartDataToUse.push({
              date: displayDate,
              cumulativeUniqueUsers: runningTotalUniqueUsers,
              cumulativeUniqueUsersByRole: cumulativeRolesSnapshot, // Use the snapshot with new Sets
              dailyRoleCounts: { ...dateInfo.dailyRoleCounts },
            });

            previousDayUniqueUserCount = runningTotalUniqueUsers;
            colorIndex++;
          });

          let finalTotalUniqueUsers = runningTotalUniqueUsers;

          const options = {
            title: "",
            chartArea: {
              height: "82%",
              left: 60,
              top: 40,
              right: 60,
            },
            legend: { position: "none" },
            hAxis: {
              title: "",
              titleTextStyle: { italic: false, fontSize: 11, color: "#555" },
              textStyle: { fontSize: 10 },
              slantedText: false,
            },
            vAxis: {
              title: "Cumulative Users",
              minValue: 0,
              viewWindow: { min: 0 },
            },
            curveType: "function",
            pointSize: 5,
            series: { 0: { pointShape: "circle" } },
            explorer: {
              actions: ["dragToZoom", "rightClickToReset"],
              axis: "horizontal",
              keepInBounds: true,
              maxZoomIn: 8.0,
            },
            tooltip: { isHtml: true },
          };

          const chart = new google.visualization.LineChart(
            document.getElementById("totalSubmissionsChartDetailed")
          );

          const numRows = data.getNumberOfRows();
          if (numRows > 2) {
            for (let i = 1; i < numRows - 1; i++) {
              data.setValue(i, 0, "");
            }
          }

          google.visualization.events.addListener(chart, "ready", function () {
            const totalSubmissionsBreakdown = document.getElementById(
              "totalSubmissionsBreakdown"
            );
            if (totalSubmissionsBreakdown && chartDataToUse.length > 0) {
              const allRoles = new Set();
              chartDataToUse.forEach((dataPoint) => {
                Object.keys(dataPoint.cumulativeUniqueUsersByRole).forEach(
                  (role) => allRoles.add(role)
                );
                Object.keys(dataPoint.dailyRoleCounts).forEach((role) =>
                  allRoles.add(role)
                );
              });
              const sortedRoles = Array.from(allRoles).sort();

              let breakdownHTML =
                '<div style="max-height: 300px; margin-top: 10px; border: 1px solid #eee;">';
              breakdownHTML +=
                '<table style="width:100%; border-collapse: collapse; font-size: 0.9em;">';

              breakdownHTML +=
                '<thead><tr style="position: sticky; top: 0; background-color: #f8f8f8; z-index: 1;">';
              breakdownHTML +=
                '<th style="text-align:left; border-bottom: 1px solid #ddd; padding: 6px 8px;">Date</th>';
              breakdownHTML +=
                '<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">Total Users</th>';

              sortedRoles.forEach((role) => {
                breakdownHTML += `<th style="text-align:center; border-bottom: 1px solid #ddd; padding: 6px 8px;">${
                  role.charAt(0).toUpperCase() + role.slice(1)
                }</th>`;
              });
              breakdownHTML += "</tr></thead>";

              breakdownHTML += "<tbody>";

              chartDataToUse.forEach((dataPoint, index) => {
                breakdownHTML += `<tr style="background-color: ${
                  index % 2 === 0 ? "#fff" : "#f9f9f9"
                };">`; // Alternating row color
                breakdownHTML += `<td style="text-align:left; padding: 6px 8px; border-bottom: 1px solid #eee;">${dataPoint.date}</td>`;
                breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${dataPoint.cumulativeUniqueUsers.toLocaleString()}</td>`;

                sortedRoles.forEach((role) => {
                  const uniqueUserSet =
                    dataPoint.cumulativeUniqueUsersByRole[role];
                  const count = uniqueUserSet ? uniqueUserSet.size : 0;
                  breakdownHTML += `<td style="text-align:center; padding: 6px 8px; border-bottom: 1px solid #eee;">${count.toLocaleString()}</td>`;
                });

                breakdownHTML += `</tr>`;
              });
              // --- END MODIFIED Table Body ---

              breakdownHTML += "</tbody>";

              breakdownHTML += `<tfoot style="font-weight: bold; background-color: #f8f8f8;"><tr>`;
              breakdownHTML += `<td style="text-align:left; padding: 8px 8px; border-top: 2px solid #ccc;">Final Totals</td>`;
              breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${finalTotalUniqueUsers.toLocaleString()}</td>`;

              // Populate final role counts in footer (Keep this)
              const finalRoleCounts =
                chartDataToUse.length > 0
                  ? chartDataToUse[chartDataToUse.length - 1]
                      .cumulativeUniqueUsersByRole
                  : {};
              sortedRoles.forEach((role) => {
                const finalSet = finalRoleCounts[role];
                const finalCount = finalSet ? finalSet.size : 0;
                breakdownHTML += `<td style="text-align:center; padding: 8px 8px; border-top: 2px solid #ccc;">${finalCount.toLocaleString()}</td>`;
              });

              breakdownHTML += `</tr></tfoot>`;

              breakdownHTML += "</table></div>";

              breakdownHTML +=
                '<div style="font-size: 0.8em; color: #666; margin-top: 8px;">';
              if (invalidDateCount > 0) {
                breakdownHTML += `Note: ${invalidDateCount} entries ignored due to invalid dates. `;
              }
              if (missingUserIdCount > 0) {
                breakdownHTML += `Note: ${missingUserIdCount} entries ignored due to missing user IDs. `;
              }
              if (missingRoleCount > 0) {
                breakdownHTML += `Note: ${missingRoleCount} entries processed with 'Unknown' role.`;
              }
              breakdownHTML += "</div>";

              totalSubmissionsBreakdown.innerHTML = breakdownHTML;
            } else if (totalSubmissionsBreakdown) {
              totalSubmissionsBreakdown.innerHTML =
                "<p>No data to display in the table.</p>";
            }
          });

          chart.draw(data, options);

          const downloadChartButton = document.getElementById(
            "downloadTotalSubmissionsChart"
          );
          if (downloadChartButton) {
            const newBtn = downloadChartButton.cloneNode(true);
            downloadChartButton.parentNode.replaceChild(
              newBtn,
              downloadChartButton
            );
            newBtn.addEventListener("click", function () {
              try {
                const chartImageURI = chart.getImageURI();
                if (!chartImageURI) {
                  console.error("Could not get chart image URI.");
                  alert("Could not generate chart image.");
                  return;
                }
                const downloadLink = document.createElement("a");
                downloadLink.href = chartImageURI;
                downloadLink.download = "cumulative-unique-users-chart.png";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
              } catch (e) {
                console.error("Error downloading chart:", e);
                alert("An error occurred while trying to download the chart.");
              }
            });
          }

          const downloadCSVButton = document.getElementById(
            "downloadTotalSubmissionsTableCSV"
          );
          if (downloadCSVButton) {
            const newBtn = downloadCSVButton.cloneNode(true);
            downloadCSVButton.parentNode.replaceChild(
              newBtn,
              downloadCSVButton
            );
            newBtn.addEventListener("click", function () {
              const table = document.querySelector(
                "#totalSubmissionsBreakdown table"
              );
              if (!table) {
                alert("Could not find the table to download.");
                return;
              }

              try {
                let csv = [];
                // Add Title/Description from modal structure
                const titleElement = modalContent.querySelector(
                  ".modal-title-and-x-2 h3"
                );
                const descElement = modalContent.querySelector(
                  ".modal-title-and-x-2 p"
                );
                if (titleElement)
                  csv.push(
                    `"${titleElement.textContent.trim().replace(/"/g, '""')}"`
                  );
                if (descElement)
                  csv.push(
                    `"${descElement.textContent.trim().replace(/"/g, '""')}"`
                  );
                csv.push([]); // Blank line

                const rows = table.querySelectorAll("tr");
                rows.forEach((row) => {
                  const cells = row.querySelectorAll("td, th");
                  const rowData = Array.from(cells).map((cell) => {
                    // Clean up cell text: trim whitespace, escape double quotes
                    let cellText = cell.textContent?.trim() || "";
                    cellText = cellText.replace(/"/g, '""'); // Escape double quotes
                    return `"${cellText}"`; // Enclose in double quotes
                  });
                  csv.push(rowData.join(","));
                });

                const csvContent = csv.join("\n");
                const blob = new Blob([csvContent], {
                  type: "text/csv;charset=utf-8;",
                });
                const downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = "cumulative-unique-users-breakdown.csv";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
              } catch (e) {
                console.error("Error generating/downloading CSV:", e);
                alert(
                  "An error occurred while trying to download the table as CSV."
                );
              }
            });
          }

          const downloadPNGButton = document.getElementById(
            "downloadTotalSubmissionsTablePNG"
          );
          if (downloadPNGButton) {
            // Clone and replace
            const newBtn = downloadPNGButton.cloneNode(true);
            downloadPNGButton.parentNode.replaceChild(
              newBtn,
              downloadPNGButton
            );
            newBtn.addEventListener("click", function () {
              const tableElement = document.querySelector(
                "#totalSubmissionsBreakdown table"
              );
              const tableContainer = document.getElementById(
                "totalSubmissionsBreakdown"
              ); // Get container for better context capture

              if (!tableElement || !tableContainer) {
                alert("Could not find the table element to download.");
                return;
              }

              // Check if html2canvas is available
              if (typeof html2canvas !== "function") {
                console.error("html2canvas library is not loaded.");
                alert(
                  "Cannot download table as PNG. Required library not found."
                );
                return;
              }

              try {
                // Create a temporary container for rendering
                const tempContainer = document.createElement("div");
                tempContainer.style.position = "absolute"; // Keep it off-screen
                tempContainer.style.left = "-9999px";
                tempContainer.style.background = "white";
                tempContainer.style.padding = "20px";
                tempContainer.style.border = "1px solid #ccc";
                tempContainer.style.fontFamily = "Arial, sans-serif"; // Consistent font

                // Add title/description from modal structure
                const titleElement = modalContent.querySelector(
                  ".modal-title-and-x-2 h3"
                );
                const descElement = modalContent.querySelector(
                  ".modal-title-and-x-2 p"
                );
                if (titleElement) {
                  const titleClone = titleElement.cloneNode(true);
                  titleClone.style.marginBottom = "5px";
                  titleClone.style.fontSize = "18px";
                  tempContainer.appendChild(titleClone);
                }
                if (descElement) {
                  const descClone = descElement.cloneNode(true);
                  descClone.style.marginBottom = "20px";
                  descClone.style.fontSize = "14px";
                  descClone.style.color = "#555";
                  tempContainer.appendChild(descClone);
                }

                // Add cloned table
                const tableClone = tableElement.cloneNode(true);
                tempContainer.appendChild(tableClone);

                // Add data quality notes if they exist
                const notesElement = tableContainer.nextElementSibling; // Assumes notes div is immediately after table container
                if (notesElement && notesElement.style.fontSize === "0.8em") {
                  const notesClone = notesElement.cloneNode(true);
                  notesClone.style.marginTop = "15px";
                  tempContainer.appendChild(notesClone);
                }

                document.body.appendChild(tempContainer); // Add to body to render

                html2canvas(tempContainer, {
                  scale: 2, // Increase scale for better resolution
                  useCORS: true, // If table contains external images (unlikely here)
                  logging: false, // Suppress logs
                })
                  .then(function (canvas) {
                    document.body.removeChild(tempContainer); // Clean up container

                    const link = document.createElement("a");
                    link.download = "cumulative-unique-users-breakdown.png";
                    link.href = canvas.toDataURL("image/png");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  })
                  .catch((err) => {
                    console.error(
                      "Error generating canvas with html2canvas:",
                      err
                    );
                    alert("Failed to generate table image.");
                    if (document.body.contains(tempContainer)) {
                      document.body.removeChild(tempContainer); // Ensure cleanup on error
                    }
                  });
              } catch (e) {
                console.error("Error initiating table PNG download:", e);
                alert(
                  "An error occurred while trying to download the table as PNG."
                );
              }
            });
          }

          if (data.getNumberOfRows() === 0) {
            document.getElementById(
              "totalSubmissionsChartDetailed"
            ).innerHTML = `
                            <div style="text-align: center; padding: 20px;">
                                <p>No valid submission data found to plot the trend after processing.</p>
                            </div>
                        `;
            const breakdownDiv = document.getElementById(
              "totalSubmissionsBreakdown"
            );
            if (breakdownDiv) breakdownDiv.innerHTML = "";
            return;
          }
        } else {
          if (modalContent) {
            modalContent.innerHTML =
              '<p style="color: red; text-align: center; padding: 20px;">Error: Google Charts library not available. Please check the console.</p>';
          }
        }
      } catch (e) {
        console.error("Error in openTotalSubmissionsChartModal:", e);
        if (modalContent) {
          modalContent.innerHTML = `<p style="color: red; text-align: center; padding: 20px;">Error loading chart: ${e.message}. Check console for details.</p>`;
        }
        const breakdownDiv = document.getElementById(
          "totalSubmissionsBreakdown"
        );
        if (breakdownDiv) breakdownDiv.innerHTML = "";
      }
    }
  }
}

function closeTotalSubmissionsChartModal() {
  const modal = document.getElementById("totalSubmissionsChartModal");
  if (modal) {
    modal.classList.add("closing");

    setTimeout(() => {
      modal.style.display = "none";
      modal.classList.remove("closing");
    }, 600);
  }
}

// allow language distribution chart toggle to work without opening modal
function handleLanguageDistributionChartClick(event) {
  // Check if the click originated from the toggle switch or its label
  const clickedElement = event.target;
  const isToggleOrLabel =
    clickedElement.id === "language-distribution-filter" ||
    clickedElement.id === "language-distribution-toggle" ||
    clickedElement.closest("#language-distribution-toggle") !== null ||
    clickedElement.tagName === "INPUT" ||
    clickedElement.tagName === "LABEL";

  // If the click was on the toggle or label, don't open the modal
  if (isToggleOrLabel) {
    event.stopPropagation();
    return;
  }

  // Otherwise open the modal
  openLanguageDistributionChartModal();
}

function initializeLanguageDistributionChartEvents() {
  const chartContainer = document.getElementById("languageDistributionChart");
  if (chartContainer) {
    chartContainer.removeAttribute("onclick");

    chartContainer.addEventListener(
      "click",
      handleLanguageDistributionChartClick
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initializeLanguageDistributionChartEvents, 500);

  document.addEventListener("chartsRefreshed", function () {
    setTimeout(initializeLanguageDistributionChartEvents, 500);
  });
});

// Common function to handle filtering without showing the filter modal
function applyFilterWithoutModal(filterType, filterValue) {
  // Set flag to prevent filter modal from appearing
  window.applyingChartFilter = true;
  console.log("1: Set flag to true");

  // Find all chips of this type
  const chipSelector = `.${filterType}-chip`;
  const chips = document.querySelectorAll(chipSelector);
  const allChip = document.querySelector(
    `${chipSelector}[data-${filterType}="all"]`
  );

  if (chips && chips.length > 0) {
    // Define a function to ensure all existing filters are cleared
    function clearAllExistingFilters() {
      // First try using the clearAllFiltersBtn if available
      const clearAllFiltersBtn = document.querySelector(
        ".clear-all-filters-chip"
      );
      if (clearAllFiltersBtn) {
        // Simulate a click to clear all filters
        clearAllFiltersBtn.click();
        console.log("2: Clicked clear all filters button");
        return true;
      } else {
        // Manual fallback if the clear button isn't found
        console.log("2.1: No clear button found, manually clearing filters");

        // Find all active chips and deactivate them
        const activeChips = document.querySelectorAll(".chip.active");
        let cleared = false;

        activeChips.forEach((chip) => {
          if (!chip.classList.contains("clear-all-filters-chip")) {
            chip.classList.remove("active");
            cleared = true;
          }
        });

        // Activate all "all" chips
        document
          .querySelectorAll(
            '[data-role="all"],[data-sentiment="all"],[data-grade="all"],[data-language="all"],[data-method="all"],[data-question="all"],[data-school="all"]'
          )
          .forEach((chip) => {
            chip.classList.add("active");
          });

        return cleared;
      }
    }

    // Clear all filters and set a longer timeout to ensure it completes
    if (clearAllExistingFilters()) {
      // Give more time for the clear filters operation to complete
      setTimeout(finishApplyingFilter, 300); // Increased timeout for better reliability
    } else {
      // If nothing was cleared, proceed directly
      finishApplyingFilter();
    }
  } else {
    console.error(`No ${filterType} chips found`);
    window.applyingChartFilter = false;
  }

  // Separate the filter application logic into its own function
  function finishApplyingFilter() {
    // Double-check that all other filters are inactive
    document.querySelectorAll(".chip").forEach((c) => {
      if (
        !c.classList.contains("clear-all-filters-chip") &&
        !c.classList.contains(`${filterType}-chip`)
      ) {
        c.classList.remove("active");
        console.log("3: Removed active class from non-matching chips");
      }
    });

    // Ensure all "all" chips for other filter types are active
    document
      .querySelectorAll(
        '[data-role="all"],[data-sentiment="all"],[data-grade="all"],[data-language="all"],[data-method="all"],[data-question="all"],[data-school="all"]'
      )
      .forEach((chip) => {
        if (!chip.classList.contains(`${filterType}-chip`)) {
          chip.classList.add("active");
          if (chip.dataset && Object.keys(chip.dataset).length > 0) {
            const typeAttr = Object.keys(chip.dataset)[0];
            console.log(`4: Added active class to "all" chip for ${typeAttr}`);
          }
        }
      });

    // Remove active class from the "all" chip for this filter type
    if (allChip) {
      allChip.classList.remove("active");
      console.log(
        "5: Removed active class from default `ALL` chip for",
        filterType
      );
    }

    // Try to find the target chip
    let targetChip = findFilterChip(chips, filterValue, `data-${filterType}`);

    if (targetChip) {
      const chipValue = targetChip.getAttribute(`data-${filterType}`);
      console.log(
        `6: Found target chip: ${chipValue} for filter type: ${filterType}`
      );

      // Activate the chip
      targetChip.classList.add("active");
      console.log(`7: Activated target chip: "${filterValue}"`);

      // If displayable field, show it in the summary area
      const responseFilterText = document.getElementById("responseFilterText");
      if (responseFilterText) {
        responseFilterText.innerHTML = `<div class="response-filters-summary">Showing Responses Filtered By: ${
          filterType.charAt(0).toUpperCase() + filterType.slice(1)
        } = ${filterValue}</div>`;
      }

      // Define a function to handle refreshing the response display
      function refreshResponseDisplay() {
        return new Promise((resolve) => {
          // Reset pagination to page 1
          currentPage = 1;
          console.log("8.1: currentPage set to 1");

          if (document.getElementById("currentPage")) {
            document.getElementById("currentPage").textContent = "1";
          }

          // Apply the filter change using the appropriate method
          if (typeof updateDisplay === "function") {
            updateDisplay();
            console.log("8: updateDisplay function called");
            resolve();
          } else if (typeof displayResponses === "function") {
            // Get filters - important to call after we've updated the active chips
            const filters =
              typeof getDefaultFilters === "function"
                ? getDefaultFilters()
                : {};
            console.log("8.2: Using filters:", filters);

            // Explicitly refresh the response container first
            const responseContainer = document.getElementById("responseData");
            if (responseContainer) {
              responseContainer.innerHTML =
                '<div class="loading">Refreshing responses...</div>';
            }

            // Small delay to ensure UI updates before applying the filter
            setTimeout(() => {
              // Call displayResponses with the current filters
              displayResponses(window.sheetData, filters);
              console.log("8.3: displayResponses function called");
              resolve();
            }, 50);
          } else {
            console.warn("8.4: No update/display function found");
            resolve();
          }
        });
      }

      // Close any open filter modal
      const filterModal = document.querySelector(".filter-modal");

      if (filterModal && filterModal.style.display !== "none") {
        filterModal.style.display = "none";
        filterModal.style.opacity = "0";
        console.log("8.5: Filter modal closed");
      }

      // Update the UI to indicate filtering
      if (typeof updateActiveFiltersDisplay === "function") {
        updateActiveFiltersDisplay();
        console.log("9: Update active filters display");
      }

      // Call refresh function and wait for it to complete before scrolling
      refreshResponseDisplay().then(() => {
        // Add a significant delay to ensure response cards are fully rendered
        setTimeout(() => {
          // Force a second refresh to ensure consistency
          if (typeof displayResponses === "function") {
            const filters =
              typeof getDefaultFilters === "function"
                ? getDefaultFilters()
                : {};
            displayResponses(window.sheetData, filters);
            console.log("9.1: Second displayResponses call for reliability");
          }

          // Scroll to the responses section after a delay
          setTimeout(() => {
            const responsesSection = document.getElementById("d");
            if (responsesSection) {
              responsesSection.scrollIntoView({ behavior: "smooth" });
              console.log("10: Scroll to responses section");
            }

            // Clear the flag after scrolling is complete
            setTimeout(() => {
              window.applyingChartFilter = false;
              console.log("END: Set flag to false");
            }, 300); //delay to ensure UI updates are complete before scrolling
          }, 300); //delay to ensure response cards are fully rendered
        }, 300); //delay to ensure UI updates are complete before scrolling
      });
    } else {
      console.warn(`Could not find ${filterType} chip for: "${filterValue}"`);
      window.applyingChartFilter = false;
    }
  }
}
